module.exports = Object.freeze([
  {
    id: 1,
    rashiIndex: 0,
    rashi: 'Aries',
    kpRashiBodyParts: `THE HEAD (Face, Brain and Facial bones)`,
    kpSubBodyParts: `Nasals - Bones of the Middle nose`,
    nakshatraIndex: 0,
    nakshatra: 'Ashwini',
    pada: '1',
    startsAt: `00°00'00"`,
    endsAt: `00°46'40"`,
    sign: 'Mars',
    star: 'Ketu',
    sub: 'Ketu',
    profession: ``,
    character: ``,
    epilogue: `Always injury Scar in the head, congestion in the brains, epilepsy, Coma, worries about enmity, jealousy, abortion, Military, machinery`,
    kpPathogenicEffects: `Brain Fever`
  },
  {
    id: 2,
    rashiIndex: 0,
    rashi: 'Aries',
    kpRashiBodyParts: `THE HEAD (Face, Brain and Facial bones)`,
    kpSubBodyParts: `Retina - The optic nerve and screen`,
    nakshatraIndex: 0,
    nakshatra: 'Ashwini',
    pada: '1',
    startsAt: `00°46'40"`,
    endsAt: `03°00'00"`,
    sign: 'Mars',
    star: 'Ketu',
    sub: 'Venus',
    profession: ``,
    character: ``,
    epilogue: `Service, headache, trance, eye trouble, eruptive fever, worried about ladies, not his own, Venereal affection, Railways, Industry, Slaughter house, Butcher, Horse rider, jockey`,
    kpPathogenicEffects: `Swelling of the eyes`
  },
  {
    id: 3,
    rashiIndex: 0,
    rashi: 'Aries',
    kpRashiBodyParts: `THE HEAD (Face, Brain and Facial bones)`,
    kpSubBodyParts: `Galea AponeurotIca - FrontaI Occipital muscle`,
    nakshatraIndex: 0,
    nakshatra: 'Ashwini',
    pada: '1-2',
    startsAt: `03°00'00"`,
    endsAt: `03°40'00"`,
    sign: 'Mars',
    star: 'Ketu',
    sub: 'Sun',
    profession: ``,
    character: ``,
    epilogue: `Paintings Cerebral anaemia, Reddish sore eyes, Severe headache on one side, Thrombosis, Veterinary surgeon, Criminal, Court, Jail, copper, Barren, Effeminate`,
    kpPathogenicEffects: `Pain and burning sensation`
  },
  {
    id: 4,
    rashiIndex: 0,
    rashi: 'Aries',
    kpRashiBodyParts: `THE HEAD (Face, Brain and Facial bones)`,
    kpSubBodyParts: `Occipitals - Posterlor part of the Occipital muscle`,
    nakshatraIndex: 0,
    nakshatra: 'Ashwini',
    pada: '2',
    startsAt: `03°40'00"`,
    endsAt: `04°46'40"`,
    sign: 'Mars',
    star: 'Ketu',
    sub: 'Moon',
    profession: ``,
    character: ``,
    epilogue: `Congestion in the brains, boils, dispute in the family, Hysteria, Neuralgia, boilers, Steam boiler, Railways, Cerebal Haemorrhage, Insomnia, Worried about landed property and cultivation-poor yield`,
    kpPathogenicEffects: `Heaviness in the back of the head. Headache and fever`
  },
  {
    id: 5,
    rashiIndex: 0,
    rashi: 'Aries',
    kpRashiBodyParts: `THE HEAD (Face, Brain and Facial bones)`,
    kpSubBodyParts: `Ear drum (The drum which responds to the noise outside)`,
    nakshatraIndex: 0,
    nakshatra: 'Ashwini',
    pada: '2',
    startsAt: `04°46'40"`,
    endsAt: `05°33'20"`,
    sign: 'Mars',
    star: 'Ketu',
    sub: 'Mars',
    profession: ``,
    character: ``,
    epilogue: `Accident, Scar in the head-Haemorrhage, epilepsy, dispute, violence, Military, Police, Industry, Independent, Managing Director`,
    kpPathogenicEffects: `All sorts of ear complaints - pus In the ear - swellings, boils inside the ear`
  },
  {
    id: 6,
    rashiIndex: 0,
    rashi: 'Aries',
    kpRashiBodyParts: `THE HEAD (Face, Brain and Facial bones)`,
    kpSubBodyParts: `Cochlea (Essential organ of the hearing)`,
    nakshatraIndex: 0,
    nakshatra: 'Ashwini',
    pada: '2-3',
    startsAt: `05°33'20"`,
    endsAt: `07°33'20"`,
    sign: 'Mars',
    star: 'Ketu',
    sub: 'Rahu',
    profession: `Cochlea (Essential organ of the hearing)`,
    character: ``,
    epilogue: `Note what Rahu denotes to a person. Irritable, quarrelsome, diseased-Military Jail, Criminal Jail, Police Department, dog-bite, Rabies, fear of black magic, litigation and landed property`,
    kpPathogenicEffects: `Ear Drum weakness - All sorts of noises inside the ear`
  },
  {
    id: 7,
    rashiIndex: 0,
    rashi: 'Aries',
    kpRashiBodyParts: `THE HEAD (Face, Brain and Facial bones)`,
    kpSubBodyParts: `Cornea - Transparent structure of the Anterior of the Eye`,
    nakshatraIndex: 0,
    nakshatra: 'Ashwini',
    pada: '3',
    startsAt: `07°33'20"`,
    endsAt: `09°20'00"`,
    sign: 'Mars',
    star: 'Ketu',
    sub: 'Jupiter',
    profession: ``,
    character: ``,
    epilogue: `Brave, Congestion in the brains, malaria, meningitis, manager of factory, bank agent, religious endowment, executive officer, Criminal Session Judge`,
    kpPathogenicEffects: `Tumour or cataract in the eye`
  },
  {
    id: 8,
    rashiIndex: 0,
    rashi: 'Aries',
    kpRashiBodyParts: `THE HEAD (Face, Brain and Facial bones)`,
    kpSubBodyParts: `Optic disc - (DIsc enclosing the eye)-Ear (External)`,
    nakshatraIndex: 0,
    nakshatra: 'Ashwini',
    pada: '3-4',
    startsAt: `09°20'00"`,
    endsAt: `11°26'40"`,
    sign: 'Mars',
    star: 'Ketu',
    sub: 'Saturn',
    profession: ``,
    character: ``,
    epilogue: `Scar in the head, Small pox, boils, injury, Cerebral operation, coma, Insomnia, Filarial fever, Severe headache, Section Officer, foreman (maistry), Iron, Steel Factory, Mine or land owner-Barren, abortion, false pains, irregular monthly periodicity`,
    kpPathogenicEffects: `Pain at the bones where eyebrows are grown`
  },
  {
    id: 9,
    rashiIndex: 0,
    rashi: 'Aries',
    kpRashiBodyParts: `THE HEAD (Face, Brain and Facial bones)`,
    kpSubBodyParts: `Frontalls - (Front portion of the ear).`,
    nakshatraIndex: 0,
    nakshatra: 'Ashwini',
    pada: '4',
    startsAt: `11°26'40"`,
    endsAt: `13°20'00"`,
    sign: 'Mars',
    star: 'Ketu',
    sub: 'Mercury',
    profession: ``,
    character: ``,
    epilogue: `Epilepsy, Violence, Spasm, paralytic Stroke, quarrelsome, Petition writer, Typist, Mechanical Engineer, Land, Building Broker-Barren, no child`,
    kpPathogenicEffects: `Nervous pain around the outer ears`
  },
  {
    id: 10,
    rashiIndex: 0,
    rashi: 'Aries',
    kpRashiBodyParts: `THE HEAD (Face, Brain and Facial bones)`,
    kpSubBodyParts: `Optid nerve - Nerve of the eye (Lobule the lowest soft portion of the ear)`,
    nakshatraIndex: 1,
    nakshatra: 'Bharani',
    pada: '1',
    startsAt: `13°20'00"`,
    endsAt: `15°33'20"`,
    sign: 'Mars',
    star: 'Venus',
    sub: 'Venus',
    profession: ``,
    character: ``,
    epilogue: `Amorou always fond of pleasure, chain smoker, injury above the eye, sportsman, deals in musical instrument, exhibition, maternity`,
    kpPathogenicEffects: `Swelling and pus in the optic nerve`
  },
  {
    id: 11,
    rashiIndex: 0,
    rashi: 'Aries',
    kpRashiBodyParts: `THE HEAD (Face, Brain and Facial bones)`,
    kpSubBodyParts: `Papa - The small circular portion at the Interior part of the eye`,
    nakshatraIndex: 1,
    nakshatra: 'Bharani',
    pada: '1',
    startsAt: `15°33'20"`,
    endsAt: `16°13'20"`,
    sign: 'Mars',
    star: 'Venus',
    sub: 'Sun',
    profession: ``,
    character: ``,
    epilogue: `Will carry out his affairs to the end. Magnanimous, Catarrh, injury around the eyes, dissipating habits, visual publicity, advertisement, railway, industry, Veterinary doctor, Criminal Lawyer and judge, Surgeon`,
    kpPathogenicEffects: `Hardening of the cornea - pain + burning in the eyes`
  },
  {
    id: 12,
    rashiIndex: 0,
    rashi: 'Aries',
    kpRashiBodyParts: `THE HEAD (Face, Brain and Facial bones)`,
    kpSubBodyParts: `Lacrimal Sac - The sac that sheds out tears`,
    nakshatraIndex: 1,
    nakshatra: 'Bharani',
    pada: '1-2',
    startsAt: `16°13'20"`,
    endsAt: `17°20'00"`,
    sign: 'Mars',
    star: 'Venus',
    sub: 'Moon',
    profession: ``,
    character: ``,
    epilogue: `Fond of hot drinks, avaricious, wanting in character, clever, silk, cotton, Fertilizer, Tea, Coffee, Hotel, Agriculturist, Shipyard`,
    kpPathogenicEffects: `White pus along with tears`
  },
  {
    id: 13,
    rashiIndex: 0,
    rashi: 'Aries',
    kpRashiBodyParts: `THE HEAD (Face, Brain and Facial bones)`,
    kpSubBodyParts: `Cerebellum - The part behind the brain Steum.`,
    nakshatraIndex: 1,
    nakshatra: 'Bharani',
    pada: '2',
    startsAt: `17°20'00"`,
    endsAt: `18°06'40"`,
    sign: 'Mars',
    star: 'Venus',
    sub: 'Mars',
    profession: ``,
    character: ``,
    epilogue: `Ever active very healthy, fond of pleasure, Venereal distemper, Syphilis, barber, Sportsman, dealer in silver vessels and eversilver vessels, Cinema theatre, Studio, Mansion for marriage, Venereal experts`,
    kpPathogenicEffects: `Sunstroke`
  },
  {
    id: 14,
    rashiIndex: 0,
    rashi: 'Aries',
    kpRashiBodyParts: `THE HEAD (Face, Brain and Facial bones)`,
    kpSubBodyParts: `Pons (The tissue connecting the medulla oblongata and the spine)`,
    nakshatraIndex: 1,
    nakshatra: 'Bharani',
    pada: '2',
    startsAt: `18°06'40"`,
    endsAt: `20°06'40"`,
    sign: 'Mars',
    star: 'Venus',
    sub: 'Rahu',
    profession: ``,
    character: ``,
    epilogue: `Aspiring, lowborn person, Leucoderma, Leprosy, Automobile Industry, Slaughter house`,
    kpPathogenicEffects: `Brain Fever`
  },
  {
    id: 15,
    rashiIndex: 0,
    rashi: 'Aries',
    kpRashiBodyParts: `THE HEAD (Face, Brain and Facial bones)`,
    kpSubBodyParts: `Cornea - Transparent structure of the anterior of the eye`,
    nakshatraIndex: 1,
    nakshatra: 'Bharani',
    pada: '2-3',
    startsAt: `20°06'40"`,
    endsAt: `21°53'20"`,
    sign: 'Mars',
    star: 'Venus',
    sub: 'Jupiter',
    profession: ``,
    character: ``,
    epilogue: `Indulges in pleasure, clever and happy, escapes from accidents, has higher studies, sits for competitive examination, Successful sportsman, Goldsmith, owner of theaters, animal husbandry judge, Income- tax Officer, Estate owner, Farms`,
    kpPathogenicEffects: `Tumour or Cataract`
  },
  {
    id: 16,
    rashiIndex: 0,
    rashi: 'Aries',
    kpRashiBodyParts: `THE HEAD (Face, Brain and Facial bones)`,
    kpSubBodyParts: `Masseter - muscle connected to the jaw`,
    nakshatraIndex: 1,
    nakshatra: 'Bharani',
    pada: '3',
    startsAt: `21°53'20"`,
    endsAt: `24°00'00"`,
    sign: 'Mars',
    star: 'Venus',
    sub: 'Saturn',
    profession: ``,
    character: ``,
    epilogue: `Lowborn, Mean minded, fond of other ladies, meeting with accident, ill repute, Veneral distemper, Catarrh in the head, Mucus, Noise to humour, lean due to gratifying one's taste, Fertilizer, wrestler, Slaughter house, Mine products, Transport for mine, ores, Venereal expert, Agriculturist`,
    kpPathogenicEffects: `Swelling of the Jaw, Pain in the cheek`
  },
  {
    id: 17,
    rashiIndex: 0,
    rashi: 'Aries',
    kpRashiBodyParts: `THE HEAD (Face, Brain and Facial bones)`,
    kpSubBodyParts: `Cochlea nerve - Medulla oblongata`,
    nakshatraIndex: 1,
    nakshatra: 'Bharani',
    pada: '3-4',
    startsAt: `24°00'00"`,
    endsAt: `25°53'20"`,
    sign: 'Mars',
    star: 'Venus',
    sub: 'Mercury',
    profession: ``,
    character: ``,
    epilogue: `Wavering, author of books on Surgery, Maternity, and Sexual side, Engineering Contractor, Export import, Caterer`,
    kpPathogenicEffects: `Nervous disorders and shooting pain in the back of the head`
  },
  {
    id: 18,
    rashiIndex: 0,
    rashi: 'Aries',
    kpRashiBodyParts: `THE HEAD (Face, Brain and Facial bones)`,
    kpSubBodyParts: `Cavity of middle ear`,
    nakshatraIndex: 1,
    nakshatra: 'Bharani',
    pada: '4',
    startsAt: `25°53'20"`,
    endsAt: `26°40'00"`,
    sign: 'Mars',
    star: 'Venus',
    sub: 'Ketu',
    profession: ``,
    character: ``,
    epilogue: `Jealous, Diseased, Leucoderma , Syphilis, Poor vision, Catarrh, Veterinary Surgeon, Skins and hides, dealer in roots and pulps`,
    kpPathogenicEffects: `Itches Inside the middle ear`
  },
  {
    id: 19,
    rashiIndex: 0,
    rashi: 'Aries',
    kpRashiBodyParts: `THE HEAD (Face, Brain and Facial bones)`,
    kpSubBodyParts: `Right eye`,
    nakshatraIndex: 2,
    nakshatra: 'Krittika',
    pada: '1',
    startsAt: `26°40'00"`,
    endsAt: `27°20'00"`,
    sign: 'Mars',
    star: 'Sun',
    sub: 'Sun',
    profession: ``,
    character: ``,
    epilogue: `Bold, active, dauntless, speculator, Plague, brain fever, Military, Police, surgical, defence department`,
    kpPathogenicEffects: `Burning of the eyes`
  },
  {
    id: 20,
    rashiIndex: 0,
    rashi: 'Aries',
    kpRashiBodyParts: `THE HEAD (Face, Brain and Facial bones)`,
    kpSubBodyParts: `Left eye`,
    nakshatraIndex: 2,
    nakshatra: 'Krittika',
    pada: '1',
    startsAt: `27°20'00"`,
    endsAt: `28°26'40"`,
    sign: 'Mars',
    star: 'Sun',
    sub: 'Moon',
    profession: ``,
    character: ``,
    epilogue: `Muscular body, Carbuncle, poxes, competitive mind, famous, pushful, acquires land, Navy, Travels, manufactures, Chemicals, Tonics`,
    kpPathogenicEffects: `Cold & Tears always in the eyes`
  },
  {
    id: 21,
    rashiIndex: 0,
    rashi: 'Aries',
    kpRashiBodyParts: `THE HEAD (Face, Brain and Facial bones)`,
    kpSubBodyParts: `Rectus muscle (Straight muscle leading to the optic nerve)`,
    nakshatraIndex: 2,
    nakshatra: 'Krittika',
    pada: '1-2',
    startsAt: `28°26'40"`,
    endsAt: `29°13'20"`,
    sign: 'Mars',
    star: 'Sun',
    sub: 'Mars',
    profession: ``,
    character: ``,
    epilogue: `Robust health, Militant temperament, commanding appearance, argumentative ability, sharp fever, Malaria, eruptive fever, Cerebral Meningitis, injury, cut, accident, explosion, Match box, iron and steel vessels, war materials`,
    kpPathogenicEffects: `Palpitation of the eyes`
  },
  {
    id: 22,
    rashiIndex: 0,
    rashi: 'Aries',
    kpRashiBodyParts: `THE HEAD (Face, Brain and Facial bones)`,
    kpSubBodyParts: `Optic nerve - Nerve of the eye`,
    nakshatraIndex: 2,
    nakshatra: 'Krittika',
    pada: '2',
    startsAt: `29°13'20"`,
    endsAt: `30°00'00"`,
    sign: 'Mars',
    star: 'Sun',
    sub: 'Rahu',
    profession: ``,
    character: ``,
    epilogue: `Leading temperament, eats much, attracted by others, wives, Plague, Filaria, Fire accident, burns in the body, Chemical Industry, Police, jail department.`,
    kpPathogenicEffects: `Blurred vision of the eyes`
  },
  {
    id: 23,
    rashiIndex: 1,
    rashi: 'Taurus',
    kpRashiBodyParts: `FACE & NECK (Gullet, Larynx, Throat, Cerebellum, bones of the neck, Trachea`,
    kpSubBodyParts: `Infra orbital - Place where the eyes roll`,
    nakshatraIndex: 2,
    nakshatra: 'Krittika',
    pada: '2',
    startsAt: `00°00'00"`,
    endsAt: `01°13'20"`,
    sign: 'Venus',
    star: 'Sun',
    sub: 'Rahu',
    profession: ``,
    character: ``,
    epilogue: `Speculative tendency, selfish,--eye-soar, Reddish eye, Photographer, wool dealer, works in leper clinics`,
    kpPathogenicEffects: `Pain and swelling around the eyes`
  },
  {
    id: 24,
    rashiIndex: 1,
    rashi: 'Taurus',
    kpRashiBodyParts: `FACE & NECK (Gullet, Larynx, Throat, Cerebellum, bones of the neck, Trachea`,
    kpSubBodyParts: `Forehead - The broad bone above the eyes`,
    nakshatraIndex: 2,
    nakshatra: 'Krittika',
    pada: '2-3',
    startsAt: `01°13'20"`,
    endsAt: `03°00'00"`,
    sign: 'Venus',
    star: 'Sun',
    sub: 'Jupiter',
    profession: ``,
    character: ``,
    epilogue: `Social generous, cheerful, Swelling above neck, victory over enemies, costly jewels and dress, international trade, music, artist, decoration, tax collector`,
    kpPathogenicEffects: `Headache and Fever`
  },
  {
    id: 25,
    rashiIndex: 1,
    rashi: 'Taurus',
    kpRashiBodyParts: `FACE & NECK (Gullet, Larynx, Throat, Cerebellum, bones of the neck, Trachea`,
    kpSubBodyParts: `Maxillary - The upper & lower jaw`,
    nakshatraIndex: 2,
    nakshatra: 'Krittika',
    pada: '3',
    startsAt: `03°00'00"`,
    endsAt: `05°06'40"`,
    sign: 'Venus',
    star: 'Sun',
    sub: 'Saturn',
    profession: ``,
    character: ``,
    epilogue: `Selfish, dishonest, pimples, throat troubles, poor voice, loss by bad debts, drawing master, draftsman, sculpture, industry, wool dealer, hair dressers or export of hair`,
    kpPathogenicEffects: `Chronic pain at the jaws`
  },
  {
    id: 26,
    rashiIndex: 1,
    rashi: 'Taurus',
    kpRashiBodyParts: `FACE & NECK (Gullet, Larynx, Throat, Cerebellum, bones of the neck, Trachea`,
    kpSubBodyParts: `Lips - The lower & upper lips on the face`,
    nakshatraIndex: 2,
    nakshatra: 'Krittika',
    pada: '3-4',
    startsAt: `05°06'40"`,
    endsAt: `07°00'00"`,
    sign: 'Venus',
    star: 'Sun',
    sub: 'Mercury',
    profession: ``,
    character: ``,
    epilogue: `Intelligent, cheerful, best fitted for business, creative mind, tumor in the knee, polypus of the nose, broker, representative of drugs and pharmaceutical, bill collector, engineer, Valuation officer, assessor`,
    kpPathogenicEffects: `Chronic itch on the lips`
  },
  {
    id: 27,
    rashiIndex: 1,
    rashi: 'Taurus',
    kpRashiBodyParts: `FACE & NECK (Gullet, Larynx, Throat, Cerebellum, bones of the neck, Trachea`,
    kpSubBodyParts: `Nostrill (external orifice of the nose) - Carotid (Principal artery of the neck)`,
    nakshatraIndex: 2,
    nakshatra: 'Krittika',
    pada: '4',
    startsAt: `07°00'00"`,
    endsAt: `07°46'40"`,
    sign: 'Venus',
    star: 'Sun',
    sub: 'Ketu',
    profession: ``,
    character: ``,
    epilogue: `Discourteous, ill repute, inimical, jealousy, cataract, nose trouble, photography, venereal expert, Executive Officer, Religious Endowment.`,
    kpPathogenicEffects: `Pain and swelling of the nasal bones. Cold, Fever, Headache`
  },
  {
    id: 28,
    rashiIndex: 1,
    rashi: 'Taurus',
    kpRashiBodyParts: `FACE & NECK (Gullet, Larynx, Throat, Cerebellum, bones of the neck, Trachea`,
    kpSubBodyParts: `Opthaimic - The areas of the vision`,
    nakshatraIndex: 2,
    nakshatra: 'Krittika',
    pada: '4',
    startsAt: `07°46'40"`,
    endsAt: `10°00'00"`,
    sign: 'Venus',
    star: 'Sun',
    sub: 'Venus',
    profession: ``,
    character: ``,
    epilogue: `Speculative, mind, popular, prosperous, fruitful action, fond of company, benefit through Government, Realises bad debts, acquires jewels and dress, decoration, Poet, artist, silk, decoration, maternity, dance music`,
    kpPathogenicEffects: `Complication in the sight`
  },
  {
    id: 29,
    rashiIndex: 1,
    rashi: 'Taurus',
    kpRashiBodyParts: `FACE & NECK (Gullet, Larynx, Throat, Cerebellum, bones of the neck, Trachea`,
    kpSubBodyParts: `Opthalmic - The area of vision`,
    nakshatraIndex: 3,
    nakshatra: 'Rohini',
    pada: '1',
    startsAt: `10°00'00"`,
    endsAt: `11°06'40"`,
    sign: 'Venus',
    star: 'Moon',
    sub: 'Moon',
    profession: ``,
    character: ``,
    epilogue: `Pleasant manners, Sweet tongued, lovely appearance, dairy farm Milk, Scented Oil, Shipping, Sugarcane`,
    kpPathogenicEffects: `Complication in the sight`
  },
  {
    id: 30,
    rashiIndex: 1,
    rashi: 'Taurus',
    kpRashiBodyParts: `FACE & NECK (Gullet, Larynx, Throat, Cerebellum, bones of the neck, Trachea`,
    kpSubBodyParts: `Carotid (Principal artery of the neck) - Auditory tube (hearing tube)`,
    nakshatraIndex: 3,
    nakshatra: 'Rohini',
    pada: '1',
    startsAt: `11°06'40"`,
    endsAt: `11°53'20"`,
    sign: 'Venus',
    star: 'Moon',
    sub: 'Mars',
    profession: ``,
    character: ``,
    epilogue: `Taste in instrumental music, arranges public functions, pleasant life in the company of other sex, Caters to the needs of the Public, hotel, lodging house, bar attached, Sandal wood, Navy, Cows, Dealer of pearls, or acids`,
    kpPathogenicEffects: `Sudden and shooting pain the carotid`
  },
  {
    id: 31,
    rashiIndex: 1,
    rashi: 'Taurus',
    kpRashiBodyParts: `FACE & NECK (Gullet, Larynx, Throat, Cerebellum, bones of the neck, Trachea`,
    kpSubBodyParts: `Nostrill - ExternaI orifice of the nose - Root of tongue (small portion where the tongue is attached)`,
    nakshatraIndex: 3,
    nakshatra: 'Rohini',
    pada: '1-2',
    startsAt: `11°53'20"`,
    endsAt: `13°53'20"`,
    sign: 'Venus',
    star: 'Moon',
    sub: 'Rahu',
    profession: ``,
    character: ``,
    epilogue: `One is to note down the position of Rahu in the horoscope and judge which planet is represented by Rahu. Then the results or the sub of planet is to be taken for the sub of Rahu. But generally one is to take that Venus Moon Rahu shows no settled minds, Lacking in manners, lives on others, deals in plastic, dyes, tannery, fishermen`,
    kpPathogenicEffects: `Pain and burning sensation at the external opening of the nose`
  },
  {
    id: 32,
    rashiIndex: 1,
    rashi: 'Taurus',
    kpRashiBodyParts: `FACE & NECK (Gullet, Larynx, Throat, Cerebellum, bones of the neck, Trachea`,
    kpSubBodyParts: `Chin - The anterior porminence of the lower jaw`,
    nakshatraIndex: 3,
    nakshatra: 'Rohini',
    pada: '2',
    startsAt: `13°53'20"`,
    endsAt: `15°40'00"`,
    sign: 'Venus',
    star: 'Moon',
    sub: 'Jupiter',
    profession: ``,
    character: ``,
    epilogue: `Apoplexy (brain stroke), Swellings, Maternal affection, sympathetic, steady person, lovely appearance, Bakeries, shipping, Judge, Politician, Sugar and sugarcoated tablets. Very good for higher education, and high position politics`,
    kpPathogenicEffects: `Tumour and extra growth at the chin`
  },
  {
    id: 33,
    rashiIndex: 1,
    rashi: 'Taurus',
    kpRashiBodyParts: `FACE & NECK (Gullet, Larynx, Throat, Cerebellum, bones of the neck, Trachea`,
    kpSubBodyParts: `Denture (The teeth)-Thyroid-Shield like gland behind the neck`,
    nakshatraIndex: 3,
    nakshatra: 'Rohini',
    pada: '2',
    startsAt: `15°40'00"`,
    endsAt: `17°46'40"`,
    sign: 'Venus',
    star: 'Moon',
    sub: 'Saturn',
    profession: ``,
    character: ``,
    epilogue: `Selfish, funky, mischievous, stealthy action, cough, cold, irregular menses, pains in the legs, Hotels with bar and all attached, petrol, oil, ice­ cream, paint, submarine, tannery`,
    kpPathogenicEffects: `Chronic Dental Pain`
  },
  {
    id: 34,
    rashiIndex: 1,
    rashi: 'Taurus',
    kpRashiBodyParts: `FACE & NECK (Gullet, Larynx, Throat, Cerebellum, bones of the neck, Trachea`,
    kpSubBodyParts: `Tongue - The bulk of the tongue in the mouth - Esophagus (The muscular passage extending from pharynx to stomach)`,
    nakshatraIndex: 3,
    nakshatra: 'Rohini',
    pada: '2-3',
    startsAt: `17°46'40"`,
    endsAt: `19°40'00"`,
    sign: 'Venus',
    star: 'Moon',
    sub: 'Mercury',
    profession: ``,
    character: ``,
    epilogue: `Tonsils, Cerebellum, tongue, goitre, sore-throat, can argue both the sides, enjoys nature, addresses public functions, at least vote of thanks: Broker, Engineer shipping, nurse, yarn merchant, pearls dealer, broker, contractor, clearing agent, waterworks engineer`,
    kpPathogenicEffects: `Complication of the Taste Nerves`
  },
  {
    id: 35,
    rashiIndex: 1,
    rashi: 'Taurus',
    kpRashiBodyParts: `FACE & NECK (Gullet, Larynx, Throat, Cerebellum, bones of the neck, Trachea`,
    kpSubBodyParts: `Throat - The anterior part of the neck-Uvuta (Fleshy mass suspending over the base of tongue)`,
    nakshatraIndex: 3,
    nakshatra: 'Rohini',
    pada: '3',
    startsAt: `19°40'00"`,
    endsAt: `20°26'40"`,
    sign: 'Venus',
    star: 'Moon',
    sub: 'Ketu',
    profession: ``,
    character: ``,
    epilogue: ` Pimples, Quinsy, tumour, defective voice or mute, unsettled mind, always worried, fear complex, dealer in fruits, tannery, skins, hides, observer of vows, yogins, service in petrol products`,
    kpPathogenicEffects: `Sour throat and cough`
  },
  {
    id: 36,
    rashiIndex: 1,
    rashi: 'Taurus',
    kpRashiBodyParts: `FACE & NECK (Gullet, Larynx, Throat, Cerebellum, bones of the neck, Trachea`,
    kpSubBodyParts: `Lingual - Part leading to the tongue - Vocal fold (The chord that vibrates to make sound)`,
    nakshatraIndex: 3,
    nakshatra: 'Rohini',
    pada: '3-4',
    startsAt: `20°26'40"`,
    endsAt: `22°40'00"`,
    sign: 'Venus',
    star: 'Moon',
    sub: 'Venus',
    profession: ``,
    character: ``,
    epilogue: `Very beautiful, attractive, sweet tongued, humorous, fertile imagination, pain in the breast, swellings, cold, glass, plastic, dairy farm, petrol, oils, paints, shipping, aquatic animals, fishermen, wealthy person`,
    kpPathogenicEffects: `Swelling and pain in the lingual`
  },
  {
    id: 37,
    rashiIndex: 1,
    rashi: 'Taurus',
    kpRashiBodyParts: `FACE & NECK (Gullet, Larynx, Throat, Cerebellum, bones of the neck, Trachea`,
    kpSubBodyParts: `Frontal - The forehead`,
    nakshatraIndex: 3,
    nakshatra: 'Rohini',
    pada: '4',
    startsAt: `22°40'00"`,
    endsAt: `23°20'00"`,
    sign: 'Venus',
    star: 'Moon',
    sub: 'Sun',
    profession: ``,
    character: ``,
    epilogue: `Sore-throat, irregular menses, scanty bleeding, enjoys life in the presence of other women, reads light literature, bakeries, perfumeries, synthetic ones, acids, shipping department, Sugar industry, agriculturist`,
    kpPathogenicEffects: `Burning sensation at the forehead`
  },
  {
    id: 38,
    rashiIndex: 1,
    rashi: 'Taurus',
    kpRashiBodyParts: `FACE & NECK (Gullet, Larynx, Throat, Cerebellum, bones of the neck, Trachea`,
    kpSubBodyParts: `Supra Orbitai - The area where the eye balls roll`,
    nakshatraIndex: 4,
    nakshatra: 'Mrigashirsh',
    pada: '1',
    startsAt: `23°20'00"`,
    endsAt: `24°06'40"`,
    sign: 'Venus',
    star: 'Mars',
    sub: 'Mars',
    profession: ``,
    character: ``,
    epilogue: `Inflammation of pericardium, inflamed tonsils, dexterity, excitable, industrious, indulges in sexual pleasure even against the will of the partner, selfish, deals in machines, automobiles, tailors, corals`,
    kpPathogenicEffects: `Shooting pain around the eyes`
  },
  {
    id: 39,
    rashiIndex: 1,
    rashi: 'Taurus',
    kpRashiBodyParts: `FACE & NECK (Gullet, Larynx, Throat, Cerebellum, bones of the neck, Trachea`,
    kpSubBodyParts: `Tympanic - Portion near the abdomen appearing like a bell`,
    nakshatraIndex: 4,
    nakshatra: 'Mrigashirsh',
    pada: '1',
    startsAt: `24°06'40"`,
    endsAt: `26°06'40"`,
    sign: 'Venus',
    star: 'Mars',
    sub: 'Rahu',
    profession: ``,
    character: ``,
    epilogue: `Mark in the cheeks, Jugular veins, dirty pimples, King's evil, tobacco, snuff, taxi driver, hire purchase, cinema, sound engineer, photography`,
    kpPathogenicEffects: `Pain and swelling at the Tympanic`
  },
  {
    id: 40,
    rashiIndex: 1,
    rashi: 'Taurus',
    kpRashiBodyParts: `FACE & NECK (Gullet, Larynx, Throat, Cerebellum, bones of the neck, Trachea`,
    kpSubBodyParts: `Sphena palatine - Palatic bones inside the mouth`,
    nakshatraIndex: 4,
    nakshatra: 'Mrigashirsh',
    pada: '1-2',
    startsAt: `26°06'40"`,
    endsAt: `27°53'20"`,
    sign: 'Venus',
    star: 'Mars',
    sub: 'Jupiter',
    profession: ``,
    character: ``,
    epilogue: `Beautiful cheek, Less of hair growth, carotid arteries, adenoid, goitre, estate owner, exhibition, platinum, animal husbandry, apple and bananas income tax and sales tax department`,
    kpPathogenicEffects: `Pain and Tumour at phalatic tones`
  },
  {
    id: 41,
    rashiIndex: 1,
    rashi: 'Taurus',
    kpRashiBodyParts: `FACE & NECK (Gullet, Larynx, Throat, Cerebellum, bones of the neck, Trachea`,
    kpSubBodyParts: `Denture - The Teeth - Vertebra (The back bone)`,
    nakshatraIndex: 4,
    nakshatra: 'Mrigashirsh',
    pada: '2',
    startsAt: `27°53'20"`,
    endsAt: `30°00'00"`,
    sign: 'Venus',
    star: 'Mars',
    sub: 'Saturn',
    profession: ``,
    character: ``,
    epilogue: `Injury in the cheek and chin, pain in the throat, weak loins, constipation, venereal distemper, polypus, Deals in lands and buildings, ever silver, dressmaker, estate duty, death duty, rickshaw puller, taxi driver, sandal powder, face powder, lethal chamber, slaughter house`,
    kpPathogenicEffects: `Chronic Dental Pain`
  },
  {
    id: 42,
    rashiIndex: 2,
    rashi: 'Gemini',
    kpRashiBodyParts: `THE ARMS`,
    kpSubBodyParts: `Palmar Aponeurosis - Nerves that leads to the palms`,
    nakshatraIndex: 4,
    nakshatra: 'Mrigashirsh',
    pada: '2',
    startsAt: `00°00'00"`,
    endsAt: `01°53'20"`,
    sign: 'Mercury',
    star: 'Mars',
    sub: 'Mercury',
    profession: ``,
    character: ``,
    epilogue: `Injury in the shoulder and defective vocal cord. Surfeit, most energetic, alert, dealing in tool, electrical goods, telephone, telegraph, building contractor, Radio, computers`,
    kpPathogenicEffects: `Paralytic attack of the hands`
  },
  {
    id: 43,
    rashiIndex: 2,
    rashi: 'Gemini',
    kpRashiBodyParts: `THE ARMS`,
    kpSubBodyParts: `Branchial Is-Lower lobes of lunys - muscle. Immediate above the elbow`,
    nakshatraIndex: 4,
    nakshatra: 'Mrigashirsh',
    pada: '2-3',
    startsAt: `01°53'20"`,
    endsAt: `02°40'00"`,
    sign: 'Mercury',
    star: 'Mars',
    sub: 'Ketu',
    profession: ``,
    character: ``,
    epilogue: `Thymus gland, corrupted blood, fever, collar bone, Excitable Vitriolic in their wrath, Tongues more poisonous than Rattle snakes, deals in surgical instruments, mechanical engineering, telegraph, dam site construction, thieves`,
    kpPathogenicEffects: `Pain at the elbow muscle`
  },
  {
    id: 44,
    rashiIndex: 2,
    rashi: 'Gemini',
    kpRashiBodyParts: `THE ARMS`,
    kpSubBodyParts: `Biceps - Arm muscle between shoulder to elbow`,
    nakshatraIndex: 4,
    nakshatra: 'Mrigashirsh',
    pada: '3',
    startsAt: `02°40'00"`,
    endsAt: `04°53'20"`,
    sign: 'Mercury',
    star: 'Mars',
    sub: 'Venus',
    profession: ``,
    character: ``,
    epilogue: `Vocal cord, throat, ears, itches, disorders in secret parts, inflammation of pericardium, fractured femur, sciatica, quick, imaginative enthusiastic, sharp witted, wealthy, indulges in sexual pleasure, Ambassadors, Astronomers, Textile Engineer, Tape record, electronics, beasts, foresters, fruits, flowers, fetter bearers, cables`,
    kpPathogenicEffects: `Pain and swelling on the biceps`
  },
  {
    id: 45,
    rashiIndex: 2,
    rashi: 'Gemini',
    kpRashiBodyParts: `THE ARMS`,
    kpSubBodyParts: `Clavicle - Upper lobe of lungs - Shoulder (Collar) bone - 1st rib`,
    nakshatraIndex: 4,
    nakshatra: 'Mrigashirsh',
    pada: '3-4',
    startsAt: `04°53'20"`,
    endsAt: `05°33'20"`,
    sign: 'Mercury',
    star: 'Mars',
    sub: 'Sun',
    profession: ``,
    character: ``,
    epilogue: `Shoulders Upper ribs, arms, excitable, fluent, eloquent, dexterity telephone, telegraph, electricity, surgeon, soldier, press publication, All India radio, surgical instruments`,
    kpPathogenicEffects: `Burning pain at the coliar bone.`
  },
  {
    id: 46,
    rashiIndex: 2,
    rashi: 'Gemini',
    kpRashiBodyParts: `THE ARMS`,
    kpSubBodyParts: `Pectoralis major - muscle leading from chest to arms - 2nd rib`,
    nakshatraIndex: 4,
    nakshatra: 'Mrigashirsh',
    pada: '4',
    startsAt: `05°33'20"`,
    endsAt: `06°40'00"`,
    sign: 'Mercury',
    star: 'Mars',
    sub: 'Moon',
    profession: ``,
    character: ``,
    epilogue: `Throat thymus gland, mental energy, impulsive, mischievous, disorder in secret parts, inflammation, boils, ambassadors, mathematician, bridge construction, salesman, broker, bus`,
    kpPathogenicEffects: `Swelling and pain at the shoulders.`
  },
  {
    id: 47,
    rashiIndex: 2,
    rashi: 'Gemini',
    kpRashiBodyParts: `THE ARMS`,
    kpSubBodyParts: `Arm pit - muscle and area of armpit - 3rd rib`,
    nakshatraIndex: 5,
    nakshatra: 'Ardra',
    pada: '1',
    startsAt: `06°40'00"`,
    endsAt: `08°40'00"`,
    sign: 'Mercury',
    star: 'Rahu',
    sub: 'Rahu',
    profession: ``,
    character: ``,
    epilogue: `Septic throat, Eosinophilia, unsuccessful in literary pursuits, liar, ungrateful, sinful, atomic energy, research department`,
    kpPathogenicEffects: `Swelling, boils etc at the armpit`
  },
  {
    id: 48,
    rashiIndex: 2,
    rashi: 'Gemini',
    kpRashiBodyParts: `THE ARMS`,
    kpSubBodyParts: `Triceps - muscle between shoulders & biceps - 4th rib`,
    nakshatraIndex: 5,
    nakshatra: 'Ardra',
    pada: '1',
    startsAt: `08°40'00"`,
    endsAt: `10°26'40"`,
    sign: 'Mercury',
    star: 'Rahu',
    sub: 'Jupiter',
    profession: ``,
    character: ``,
    epilogue: `Septic throat, ear trouble, mums, ingenious, scholar, good character, reader, stock keeper, writer, explorer, finance broker, statistician`,
    kpPathogenicEffects: `Tumour and extra growth at thse triceps`
  },
  {
    id: 49,
    rashiIndex: 2,
    rashi: 'Gemini',
    kpRashiBodyParts: `THE ARMS`,
    kpSubBodyParts: `Coroco branchialls - muscle below the armpit - 5th rib`,
    nakshatraIndex: 5,
    nakshatra: 'Ardra',
    pada: '1-2',
    startsAt: `10°26'40"`,
    endsAt: `12°33'20"`,
    sign: 'Mercury',
    star: 'Rahu',
    sub: 'Saturn',
    profession: ``,
    character: ``,
    epilogue: `Asthma, puss in the ear education poor, hand writing expert, or committing forgery, finger print expert, physics`,
    kpPathogenicEffects: `Pain and swelling below the armpit`
  },
  {
    id: 50,
    rashiIndex: 2,
    rashi: 'Gemini',
    kpRashiBodyParts: `THE ARMS`,
    kpSubBodyParts: `Extensor, Carpiradialis longus - muscle of the lower forearm - 7th rib`,
    nakshatraIndex: 5,
    nakshatra: 'Ardra',
    pada: '2',
    startsAt: `12°33'20"`,
    endsAt: `14°26'40"`,
    sign: 'Mercury',
    star: 'Rahu',
    sub: 'Mercury',
    profession: ``,
    character: ``,
    epilogue: `Hiccough (hiccup), ear trouble, active mind, critical scholar, salesman, communication department, transport, aerial, atomic energy, writer, author, dynamics`,
    kpPathogenicEffects: `Convulsion at the lower forearm`
  },
  {
    id: 51,
    rashiIndex: 2,
    rashi: 'Gemini',
    kpRashiBodyParts: `THE ARMS`,
    kpSubBodyParts: `Flexur Carpiulnaris - muscle between elbow & the wrist - 8th rib`,
    nakshatraIndex: 5,
    nakshatra: 'Ardra',
    pada: '2',
    startsAt: `14°26'40"`,
    endsAt: `15°13'20"`,
    sign: 'Mercury',
    star: 'Rahu',
    sub: 'Ketu',
    profession: ``,
    character: ``,
    epilogue: `Septic throat, diphtheria, jealousy, adulterer, thief, cruel minded, pseudonymous, petition writer, ungrateful, no child birth, research department, deals in poisonous drugs, canned goods, gravitation`,
    kpPathogenicEffects: `Swelling of the elbow and wrist muscle`
  },
  {
    id: 52,
    rashiIndex: 2,
    rashi: 'Gemini',
    kpRashiBodyParts: `THE ARMS`,
    kpSubBodyParts: `Abductor, policis longus - muscle below the thumb - 9th rib`,
    nakshatraIndex: 5,
    nakshatra: 'Ardra',
    pada: '2-3',
    startsAt: `15°13'20"`,
    endsAt: `17°26'40"`,
    sign: 'Mercury',
    star: 'Rahu',
    sub: 'Venus',
    profession: ``,
    character: ``,
    epilogue: `Septic throat, dry cough, eartrouble, ingenious, humorous, artist, sales man, post and telegraph department, transport, radio, bus`,
    kpPathogenicEffects: `Pain and swelling below the Thumb`
  },
  {
    id: 53,
    rashiIndex: 2,
    rashi: 'Gemini',
    kpRashiBodyParts: `THE ARMS`,
    kpSubBodyParts: `Palmaris longus - Sternum - Forearm muscle below the elbow - 10th rib`,
    nakshatraIndex: 5,
    nakshatra: 'Ardra',
    pada: '3',
    startsAt: `17°26'40"`,
    endsAt: `18°06'40"`,
    sign: 'Mercury',
    star: 'Rahu',
    sub: 'Sun',
    profession: ``,
    character: ``,
    epilogue: `Eosinophilia, pain in the shoulder, cruel minded, man versed in the art pertaining to boggling-amazements, holy, perfidious, atomic energy, research department, public appointment`,
    kpPathogenicEffects: `Convulsion and burning pain at the forearm muscle`
  },
  {
    id: 54,
    rashiIndex: 2,
    rashi: 'Gemini',
    kpRashiBodyParts: `THE ARMS`,
    kpSubBodyParts: `Palmar apeneurosis - area above the centre of the palms - 11th rib.`,
    nakshatraIndex: 5,
    nakshatra: 'Ardra',
    pada: '3-4',
    startsAt: `18°06'40"`,
    endsAt: `19°13'20"`,
    sign: 'Mercury',
    star: 'Rahu',
    sub: 'Moon',
    profession: ``,
    character: ``,
    epilogue: `Ear trouble, puss in the ear, asthma, intuitive, thief, boatman, deals in drugs, explorer, nurse, engineer`,
    kpPathogenicEffects: `Boils, Pus at the lower joint of the fingers`
  },
  {
    id: 55,
    rashiIndex: 2,
    rashi: 'Gemini',
    kpRashiBodyParts: `THE ARMS`,
    kpSubBodyParts: `Flexur Digitorum super ficialis - Forearm muscle above Abductor policis longus - Scapula - 12th rib`,
    nakshatraIndex: 5,
    nakshatra: 'Ardra',
    pada: '4',
    startsAt: `19°13'20"`,
    endsAt: `20°00'00"`,
    sign: 'Mercury',
    star: 'Rahu',
    sub: 'Mars',
    profession: ``,
    character: ``,
    epilogue: `Septic throat, injury in the shoulder, critic, murderer, robber, rogue, mischievous, mechanical engineer, handwriting expert, finger print expert, police department`,
    kpPathogenicEffects: `Shooting and sudden pams at the forearm muscle`
  },
  {
    id: 56,
    rashiIndex: 2,
    rashi: 'Gemini',
    kpRashiBodyParts: `THE ARMS`,
    kpSubBodyParts: `Deltoid - The bulk of the arm muscle`,
    nakshatraIndex: 6,
    nakshatra: 'Punarvasu',
    pada: '1',
    startsAt: `20°00'00"`,
    endsAt: `21°46'40"`,
    sign: 'Mercury',
    star: 'Jupiter',
    sub: 'Jupiter',
    profession: ``,
    character: ``,
    epilogue: `Swelling in the ear, pulmonary apoplexy, broad outlook, proper judgment, true, rich, merchant, journalism, story writing, advertising, religious, finance broker, mayor, astrologer`,
    kpPathogenicEffects: `Tumour and extra growth in the muscle of the arm`
  },
  {
    id: 57,
    rashiIndex: 2,
    rashi: 'Gemini',
    kpRashiBodyParts: `THE ARMS`,
    kpSubBodyParts: `Olecranon - Anterior part of lungs - The elbow (Radius)`,
    nakshatraIndex: 6,
    nakshatra: 'Punarvasu',
    pada: '1',
    startsAt: `21°46'40"`,
    endsAt: `23°53'20"`,
    sign: 'Mercury',
    star: 'Jupiter',
    sub: 'Saturn',
    profession: ``,
    character: ``,
    epilogue: `Injury in the shoulder blade, inflammation, pain the ear, iodine deficiency, infiltration in the upper lob of the lungs, worldly wisdom, sincere, servant, insurance agent, messengers, postman, woolen merchants, provision dealers`,
    kpPathogenicEffects: `Chronic pain at the elbow`
  },
  {
    id: 58,
    rashiIndex: 2,
    rashi: 'Gemini',
    kpRashiBodyParts: `THE ARMS`,
    kpSubBodyParts: `Extensor retina elulum - posterior part of lungs - The wrlst - Carpus`,
    nakshatraIndex: 6,
    nakshatra: 'Punarvasu',
    pada: '1-2',
    startsAt: `23°53'20"`,
    endsAt: `25°46'40"`,
    sign: 'Mercury',
    star: 'Jupiter',
    sub: 'Mercury',
    profession: ``,
    character: ``,
    epilogue: `Hiccough, asthma, active mind, ingenious, scholar, salesman, book seller, high official, competitive examiner, auto, research • scholar, public appointment, service in the head of the department registrar, astrologer`,
    kpPathogenicEffects: `Pain at the wrist`
  },
  {
    id: 59,
    rashiIndex: 2,
    rashi: 'Gemini',
    kpRashiBodyParts: `THE ARMS`,
    kpSubBodyParts: `Abductor Digiti minimi - the posterior above the little finger - lower lobe of lungs`,
    nakshatraIndex: 6,
    nakshatra: 'Punarvasu',
    pada: '2',
    startsAt: `25°46'40"`,
    endsAt: `26°33'20"`,
    sign: 'Mercury',
    star: 'Jupiter',
    sub: 'Ketu',
    profession: ``,
    character: ``,
    epilogue: `Pleurisy, Pneumonia, Pulmonary apoplexy, poor judgement, abortive tendency, no peace of mind, worried, religious, interpreter, secretary, astrologer`,
    kpPathogenicEffects: `Pain and swelling in the little fingure`
  },
  {
    id: 60,
    rashiIndex: 2,
    rashi: 'Gemini',
    kpRashiBodyParts: `THE ARMS`,
    kpSubBodyParts: `Abductor policis brevis - The fleshy part below the thumb`,
    nakshatraIndex: 6,
    nakshatra: 'Punarvasu',
    pada: '2',
    startsAt: `26°33'20"`,
    endsAt: `28°46'40"`,
    sign: 'Mercury',
    star: 'Jupiter',
    sub: 'Venus',
    profession: ``,
    character: ``,
    epilogue: `Bronchitis, Arms disorder, good memory, proper judgment, well disposed, intelligent, rich, easily contented, inspector, poet, auditor, civil judge, civil engineer, Tamil pandit, clothier`,
    kpPathogenicEffects: `Swelling at the Venus mount`
  },
  {
    id: 61,
    rashiIndex: 2,
    rashi: 'Gemini',
    kpRashiBodyParts: `THE ARMS`,
    kpSubBodyParts: `Dorsal Interasseous - The posterior part of the palm - upper lobe of lungs - Metacarpus`,
    nakshatraIndex: 6,
    nakshatra: 'Punarvasu',
    pada: '2-3',
    startsAt: `28°46'40"`,
    endsAt: `29°26'40"`,
    sign: 'Mercury',
    star: 'Jupiter',
    sub: 'Sun',
    profession: ``,
    character: ``,
    epilogue: `Throat affected, pain in the ear, broad outlook, clear in sight bronchitis, eosinophilia, advertising, visual publicity, judge, Income-tax inspector, auditor, registrar, deputy secretary`,
    kpPathogenicEffects: `Pain and swelling of the fourth finger (sun finger)`
  },
  {
    id: 62,
    rashiIndex: 2,
    rashi: 'Gemini',
    kpRashiBodyParts: `THE ARMS`,
    kpSubBodyParts: `Palmar brevis - The fleshy part below the little finger`,
    nakshatraIndex: 6,
    nakshatra: 'Punarvasu',
    pada: '3',
    startsAt: `29°26'40"`,
    endsAt: `30°00'00"`,
    sign: 'Mercury',
    star: 'Jupiter',
    sub: 'Moon',
    profession: ``,
    character: ``,
    epilogue: `Pleurisy, Pneumonia, good memory, correct intuition, merchant, estate broker, finance broker, politician, mayor, councillor, schoolmaster, interpreter`,
    kpPathogenicEffects: `Pain and swelling at the Tower part of the little finger`
  },
  {
    id: 63,
    rashiIndex: 3,
    rashi: 'Cancer',
    kpRashiBodyParts: `Breast, Chest, Epigastric Region Bones & Ribs ~ Stomach, Digestive Organs`,
    kpSubBodyParts: `Thoracic (Middle) pertaining to chest`,
    nakshatraIndex: 6,
    nakshatra: 'Punarvasu',
    pada: '3-4',
    startsAt: `00°00'00"`,
    endsAt: `00°33'20"`,
    sign: 'Moon',
    star: 'Jupiter',
    sub: 'Moon',
    profession: ``,
    character: ``,
    epilogue: `Lungs, breast, Lacteels, dropsy, beriberi, corrupt blood, jaundice, Fertile imagination, honest, true, forgiving temperament, resourceful, sympathetic, banker, advocate, judge, traveller, sailor, dealer in fluid, nurse, midwife,watersupply, Tuberculosis`,
    kpPathogenicEffects: `Asthma - T.B. Breathing Troubles`
  },
  {
    id: 64,
    rashiIndex: 3,
    rashi: 'Cancer',
    kpRashiBodyParts: `Breast, Chest, Epigastric Region Bones & Ribs ~ Stomach, Digestive Organs`,
    kpSubBodyParts: `Clavicle (Area behind the collar bone)`,
    nakshatraIndex: 6,
    nakshatra: 'Punarvasu',
    pada: '4',
    startsAt: `00°33'20"`,
    endsAt: `01°20'00"`,
    sign: 'Moon',
    star: 'Jupiter',
    sub: 'Mars',
    profession: ``,
    character: ``,
    epilogue: `Pancreatic gland, Mammae, diaphragm, Beriberi, irregular appetite, corrupt blood, liver complaint, gourmandize, appreciates beauty, effective argument, good vitality and fertility, politician, born a prince, banker, physician, religious head, statistics, judge, professor, Manager of Public conveyance`,
    kpPathogenicEffects: `Shooting pain at the collar bone`
  },
  {
    id: 65,
    rashiIndex: 3,
    rashi: 'Cancer',
    kpRashiBodyParts: `Breast, Chest, Epigastric Region Bones & Ribs ~ Stomach, Digestive Organs`,
    kpSubBodyParts: `Bronchial Tube (Breathing tube)`,
    nakshatraIndex: 6,
    nakshatra: 'Punarvasu',
    pada: '4',
    startsAt: `01°20'00"`,
    endsAt: `03°20'00"`,
    sign: 'Moon',
    star: 'Jupiter',
    sub: 'Rahu',
    profession: ``,
    character: ``,
    epilogue: `Stomach, oesophagus, Thoracic, stomach upset, TB., dyspepsia, reliable, resourceful, compassionate, politician, economics, Principal, Sailor, dealer in fluid, Salesman, female official, Jail for women`,
    kpPathogenicEffects: `Mucour in the bronchial trouble cough - pasty phlem`
  },
  {
    id: 66,
    rashiIndex: 3,
    rashi: 'Cancer',
    kpRashiBodyParts: `Breast, Chest, Epigastric Region Bones & Ribs ~ Stomach, Digestive Organs`,
    kpSubBodyParts: `The first proximal portion of the small intestines, Duodenum, 1st rib`,
    nakshatraIndex: 7,
    nakshatra: 'Pushya',
    pada: '1',
    startsAt: `03°20'00"`,
    endsAt: `05°26'40"`,
    sign: 'Moon',
    star: 'Saturn',
    sub: 'Saturn',
    profession: ``,
    character: ``,
    epilogue: `Lungs ribs, TB. obstructions, cancer, eczema, pyorrhea, economical, contemplative, patient, persevering, deals in kerosene, canals, Jailer, tunnels, works in submarine, driver`,
    kpPathogenicEffects: `Shrinking of the Revodenum - chronic pain`
  },
  {
    id: 67,
    rashiIndex: 3,
    rashi: 'Cancer',
    kpRashiBodyParts: `Breast, Chest, Epigastric Region Bones & Ribs ~ Stomach, Digestive Organs`,
    kpSubBodyParts: `Thoracic (Lower) pertaining to chest - 2nd rib`,
    nakshatraIndex: 7,
    nakshatra: 'Pushya',
    pada: '1',
    startsAt: `05°26'40"`,
    endsAt: `07°20'00"`,
    sign: 'Moon',
    star: 'Saturn',
    sub: 'Mercury',
    profession: ``,
    character: ``,
    epilogue: `Both l-nK3 affected, Nausea, Phthisis, dyspepsia, Self-reliance, systematic and intelligent action, position of trust, barely, Canals, water works engineer, Pumping set dealer, constructing bridges, kerosene agent`,
    kpPathogenicEffects: `Nervous disorder around the thoracing(thoracic outlet) - Severe chest pain`
  },
  {
    id: 68,
    rashiIndex: 3,
    rashi: 'Cancer',
    kpRashiBodyParts: `Breast, Chest, Epigastric Region Bones & Ribs ~ Stomach, Digestive Organs`,
    kpSubBodyParts: `Gastric (Originating In the stomach) - 3rd rib`,
    nakshatraIndex: 7,
    nakshatra: 'Pushya',
    pada: '1-2',
    startsAt: `07°20'00"`,
    endsAt: `08°06'40"`,
    sign: 'Moon',
    star: 'Saturn',
    sub: 'Ketu',
    profession: ``,
    character: ``,
    epilogue: `Gallaping, tuberculosis, Belching, scurvy, Jaundice, pyorrhea, fisherman, deals in mine products or agricultural lands, plumber, grave digger`,
    kpPathogenicEffects: `Stomach pain and disorders`
  },
  {
    id: 69,
    rashiIndex: 3,
    rashi: 'Cancer',
    kpRashiBodyParts: `Breast, Chest, Epigastric Region Bones & Ribs ~ Stomach, Digestive Organs`,
    kpSubBodyParts: `Thoracic (Upper) pertaining to chest - 4th rib `,
    nakshatraIndex: 7,
    nakshatra: 'Pushya',
    pada: '2',
    startsAt: `08°06'40"`,
    endsAt: `10°20'00"`,
    sign: 'Moon',
    star: 'Saturn',
    sub: 'Venus',
    profession: ``,
    character: ``,
    epilogue: `Bruises in the breasts, cough, eczema, prudent, careful, liked by all, wealthy, petrol, petroleum products, trenches, Engineers and draftsman, constructing dams`,
    kpPathogenicEffects: `Swollen chest chest pain`
  },
  {
    id: 70,
    rashiIndex: 3,
    rashi: 'Cancer',
    kpRashiBodyParts: `Breast, Chest, Epigastric Region Bones & Ribs ~ Stomach, Digestive Organs`,
    kpSubBodyParts: `Sternum - Bone at the anterior of the Thorax - 5th rib`,
    nakshatraIndex: 7,
    nakshatra: 'Pushya',
    pada: '2',
    startsAt: `10°20'00"`,
    endsAt: `11°00'00"`,
    sign: 'Moon',
    star: 'Saturn',
    sub: 'Sun',
    profession: ``,
    character: ``,
    epilogue: `Ulceration in the respiratory-system gallstone, methodical action, attains position of trust, learner, mine ores, copper, Sexton, those who work underground`,
    kpPathogenicEffects: `Severe burning pain where the chest bone ends`
  },
  {
    id: 71,
    rashiIndex: 3,
    rashi: 'Cancer',
    kpRashiBodyParts: `Breast, Chest, Epigastric Region Bones & Ribs ~ Stomach, Digestive Organs`,
    kpSubBodyParts: `Supra renal glands - Situated above the kidney - 6th rib`,
    nakshatraIndex: 7,
    nakshatra: 'Pushya',
    pada: '2-3',
    startsAt: `11°00'00"`,
    endsAt: `12°06'40"`,
    sign: 'Moon',
    star: 'Saturn',
    sub: 'Moon',
    profession: ``,
    character: ``,
    epilogue: `Tuberculosis Nausea, obstructions, attentive, Contemplative, fisherman, kerosene, agricultural, digging wells, constructing tanks and impounded reservoirs, those working in the night`,
    kpPathogenicEffects: `Malfunction of the Supra nenal glands leading to heart and troubles`
  },
  {
    id: 72,
    rashiIndex: 3,
    rashi: 'Cancer',
    kpRashiBodyParts: `Breast, Chest, Epigastric Region Bones & Ribs ~ Stomach, Digestive Organs`,
    kpSubBodyParts: `Liver - The biggest gland that stores blood and produces bile - 7th rib`,
    nakshatraIndex: 7,
    nakshatra: 'Pushya',
    pada: '3',
    startsAt: `12°06'40"`,
    endsAt: `12°53'20"`,
    sign: 'Moon',
    star: 'Saturn',
    sub: 'Mars',
    profession: ``,
    character: ``,
    epilogue: `Ulceration in the respiratory system, injury in ribs, gastric ulcer, bruises in the breast, Petroleum products, coal, lands excavations, Canals, trenches, tunnels`,
    kpPathogenicEffects: `Inflammation of the fiver - Jaundice and hepatic disorders`
  },
  {
    id: 73,
    rashiIndex: 3,
    rashi: 'Cancer',
    kpRashiBodyParts: `Breast, Chest, Epigastric Region Bones & Ribs ~ Stomach, Digestive Organs`,
    kpSubBodyParts: `Bile duet - The tube that empties the bile into the small Intestines - 8th rib `,
    nakshatraIndex: 7,
    nakshatra: 'Pushya',
    pada: '3-4',
    startsAt: `12°53'20"`,
    endsAt: `14°53'20"`,
    sign: 'Moon',
    star: 'Saturn',
    sub: 'Rahu',
    profession: ``,
    character: ``,
    epilogue: `Gallstone, tuberculosis, hiccough, agriculturist, Jailer, grave digger, dealer in oil`,
    kpPathogenicEffects: `The malfunction of the bile duct`
  },
  {
    id: 74,
    rashiIndex: 3,
    rashi: 'Cancer',
    kpRashiBodyParts: `Breast, Chest, Epigastric Region Bones & Ribs ~ Stomach, Digestive Organs`,
    kpSubBodyParts: `Scapula - The triangular flat bone at the back of the shoulder - 9th rib`,
    nakshatraIndex: 7,
    nakshatra: 'Pushya',
    pada: '4',
    startsAt: `14°53'20"`,
    endsAt: `16°40'00"`,
    sign: 'Moon',
    star: 'Saturn',
    sub: 'Jupiter',
    profession: ``,
    character: ``,
    epilogue: `Gastric trouble, Ulcer on the breasts, Jaundice, economical, conservative, liked by all, learned, wealthy, virtuous, agriculturist, hold position of trust, works in the head of the department, deals in mines`,
    kpPathogenicEffects: `The swelling and tumour at the shoulder blades`
  },
  {
    id: 75,
    rashiIndex: 3,
    rashi: 'Cancer',
    kpRashiBodyParts: `Breast, Chest, Epigastric Region Bones & Ribs ~ Stomach, Digestive Organs`,
    kpSubBodyParts: `Pancreas - Large elongated gland behind the stomach & spleen - 10th rib.`,
    nakshatraIndex: 8,
    nakshatra: 'Ashlesha',
    pada: '1',
    startsAt: `16°40'00"`,
    endsAt: `18°33'21"`,
    sign: 'Moon',
    star: 'Mercury',
    sub: 'Mercury',
    profession: ``,
    character: ``,
    epilogue: `Both the lungs and the stomach will be defective. Gas forming in the stomach will push the diaphragm up and breathing will be difficult, Vitamin B deficient, hysteria, quick wit, versatile, mimicry, clown, fond of travels, hypocrite, agent, commerce correspondent, dealer in yarn, ink, water diviner`,
    kpPathogenicEffects: `The failure and malfunction of the pancreas that produces Insulin`
  },
  {
    id: 76,
    rashiIndex: 3,
    rashi: 'Cancer',
    kpRashiBodyParts: `Breast, Chest, Epigastric Region Bones & Ribs ~ Stomach, Digestive Organs`,
    kpSubBodyParts: `Intestines (Upper part) Gall bladder - Reservolr of the bile - 11th rib`,
    nakshatraIndex: 8,
    nakshatra: 'Ashlesha',
    pada: '1',
    startsAt: `18°33'21"`,
    endsAt: `19°20'00"`,
    sign: 'Moon',
    star: 'Mercury',
    sub: 'Ketu',
    profession: ``,
    character: ``,
    epilogue: `Hysteria, fear complex, dull liver, acquires other languages easily, failure, ungrateful, sinful, guide, hostess, midwife, nurse, plurality in everything`,
    kpPathogenicEffects: `Bile mixing in the blood stream causing Jaundice, Fever and Headache`
  },
  {
    id: 77,
    rashiIndex: 3,
    rashi: 'Cancer',
    kpRashiBodyParts: `Breast, Chest, Epigastric Region Bones & Ribs ~ Stomach, Digestive Organs`,
    kpSubBodyParts: `Colic - Large part of the intestine - 12th rib`,
    nakshatraIndex: 8,
    nakshatra: 'Ashlesha',
    pada: '1-2',
    startsAt: `19°20'00"`,
    endsAt: `21°33'20"`,
    sign: 'Moon',
    star: 'Mercury',
    sub: 'Venus',
    profession: ``,
    character: ``,
    epilogue: `Windiness, drunkenness, hypochondria, dropsy, imitates other, good in music, art, insincere, fond of honeymoon, picnic, other's company, international trade, paints, ambassador, traveling, agent, midwife, hostess, nurse, very good painter`,
    kpPathogenicEffects: `Swelling and pus In the intestines`
  },
  {
    id: 78,
    rashiIndex: 3,
    rashi: 'Cancer',
    kpRashiBodyParts: `Breast, Chest, Epigastric Region Bones & Ribs ~ Stomach, Digestive Organs`,
    kpSubBodyParts: `Lungs (upper lobe) organs of respiration`,
    nakshatraIndex: 8,
    nakshatra: 'Ashlesha',
    pada: '2',
    startsAt: `21°33'20"`,
    endsAt: `22°13'20"`,
    sign: 'Moon',
    star: 'Mercury',
    sub: 'Sun',
    profession: ``,
    character: ``,
    epilogue: `Dull liver, poor digestion, constipation, jaundice, Textile Department, Nurse, Mental Hospital`,
    kpPathogenicEffects: `T.B, Fever`
  },
  {
    id: 79,
    rashiIndex: 3,
    rashi: 'Cancer',
    kpRashiBodyParts: `Breast, Chest, Epigastric Region Bones & Ribs ~ Stomach, Digestive Organs`,
    kpSubBodyParts: `Lungs - Organs of respiration`,
    nakshatraIndex: 8,
    nakshatra: 'Ashlesha',
    pada: '2',
    startsAt: `22°13'20"`,
    endsAt: `23°20'00"`,
    sign: 'Moon',
    star: 'Mercury',
    sub: 'Moon',
    profession: ``,
    character: ``,
    epilogue: `Cold, drunkenness, hysteria, dropsy, imitates others, mimicry, salesman, ink, artist, water supply engineer, textile engineer, midwife, versatile`,
    kpPathogenicEffects: `T.B. Cough and breathing trouble`
  },
  {
    id: 80,
    rashiIndex: 3,
    rashi: 'Cancer',
    kpRashiBodyParts: `Breast, Chest, Epigastric Region Bones & Ribs ~ Stomach, Digestive Organs`,
    kpSubBodyParts: `Diaphragm musculo membraneous portion separating the abdominal and Thoracic regions. Inapiratory muscle `,
    nakshatraIndex: 8,
    nakshatra: 'Ashlesha',
    pada: '2-3',
    startsAt: `23°20'00"`,
    endsAt: `24°06'40"`,
    sign: 'Moon',
    star: 'Mercury',
    sub: 'Mars',
    profession: ``,
    character: ``,
    epilogue: `Flatulence, Nephritis, pain in the stomach, ulcer, correspondent, manufacturer of ink, textile, traveling agent`,
    kpPathogenicEffects: `Respiratory trouble`
  },
  {
    id: 81,
    rashiIndex: 3,
    rashi: 'Cancer',
    kpRashiBodyParts: `Breast, Chest, Epigastric Region Bones & Ribs ~ Stomach, Digestive Organs`,
    kpSubBodyParts: `Stomach (Lower portion) expanded portion of the alementary canal between the esophagus & the Duodenum`,
    nakshatraIndex: 8,
    nakshatra: 'Ashlesha',
    pada: '3',
    startsAt: `24°06'40"`,
    endsAt: `26°06'40"`,
    sign: 'Moon',
    star: 'Mercury',
    sub: 'Rahu',
    profession: ``,
    character: ``,
    epilogue: `Typhoid Vitamin 'B' deficiency, jaundice, phaent?, copious in speech, fond of travel, insincere, sinful, ungrateful, good businessman, depending on the position of Rahu predict the profession`,
    kpPathogenicEffects: `Stomach disorders - worms, Diarrohea - dysentry`
  },
  {
    id: 82,
    rashiIndex: 3,
    rashi: 'Cancer',
    kpRashiBodyParts: `Breast, Chest, Epigastric Region Bones & Ribs ~ Stomach, Digestive Organs`,
    kpSubBodyParts: `Stomach (Upper portion) expanded portion of the alementary canal between the esophagus & the Duodenum`,
    nakshatraIndex: 8,
    nakshatra: 'Ashlesha',
    pada: '3-4',
    startsAt: `26°06'40"`,
    endsAt: `27°53'20"`,
    sign: 'Moon',
    star: 'Mercury',
    sub: 'Jupiter',
    profession: ``,
    character: ``,
    epilogue: `Diaphragm, pancreas, liver, wind pressing the diaphragm, makes it difficult to breathe, dropsy, beriberi, good writer, learns art and literature, always travels, grateful, author of books, writer, international trade, commerce, banking, accounts, ambassador`,
    kpPathogenicEffects: `Extra growth inside the stomach - Tumour Ulcer etc`
  },
  {
    id: 83,
    rashiIndex: 3,
    rashi: 'Cancer',
    kpRashiBodyParts: `Breast, Chest, Epigastric Region Bones & Ribs ~ Stomach, Digestive Organs`,
    kpSubBodyParts: `Lungs (Lower lobe) organs of respiration. Spleen - the gland at the cardiac end of the stomach, and filters the blood, and removes any foreign body in the blood`,
    nakshatraIndex: 8,
    nakshatra: 'Ashlesha',
    pada: '4',
    startsAt: `27°53'20"`,
    endsAt: `30°00'00"`,
    sign: 'Moon',
    star: 'Mercury',
    sub: 'Saturn',
    profession: ``,
    character: ``,
    epilogue: `Lungs, stomach, Vitamin 'B' deficiency, Pains in knees and legs, phlegm, deceitful, underhand dealings, water diviner, manufacture of ink, service in textile department, hostess, nurse`,
    kpPathogenicEffects: `Chronic respiratory trouble`
  },
  {
    id: 84,
    rashiIndex: 4,
    rashi: 'Leo',
    kpRashiBodyParts: `HEART (Spine Upper)`,
    kpSubBodyParts: `Fossa ovalls - Cavlty in the chamber of the heart`,
    nakshatraIndex: 9,
    nakshatra: 'Magha',
    pada: '1',
    startsAt: `00°00'00"`,
    endsAt: `00°46'40"`,
    sign: 'Sun',
    star: 'Ketu',
    sub: 'Ketu',
    profession: ``,
    character: ``,
    epilogue: `Disease in the heart, Palpitation, Giddiness, Congestion, chemical, Medical, Government, Security in service, Physician`,
    kpPathogenicEffects: `Contraction and pain in the heart chamber, Giddiness`
  },
  {
    id: 85,
    rashiIndex: 4,
    rashi: 'Leo',
    kpRashiBodyParts: `HEART (Spine Upper)`,
    kpSubBodyParts: `Copius (प्रचंड) flow in and out of heart`,
    nakshatraIndex: 9,
    nakshatra: 'Magha',
    pada: '1',
    startsAt: `00°46'40"`,
    endsAt: `03°00'00"`,
    sign: 'Sun',
    star: 'Ketu',
    sub: 'Venus',
    profession: ``,
    character: ``,
    epilogue: `Spinal Meningitis, Syncope, Epilepsy, Swelling, Optician, Skin expert, Leucoderma, Leprosy, Transport, Automobile, Women & Children Hospital. Chemical`,
    kpPathogenicEffects: `Block in the free flow of blood`
  },
  {
    id: 86,
    rashiIndex: 4,
    rashi: 'Leo',
    kpRashiBodyParts: `HEART (Spine Upper)`,
    kpSubBodyParts: `Coronary artery (1st Thoracic vertebra) - The blood - vessel that empties pure blood to the nervous system of the heart`,
    nakshatraIndex: 9,
    nakshatra: 'Magha',
    pada: '1-2',
    startsAt: `03°00'00"`,
    endsAt: `03°40'00"`,
    sign: 'Sun',
    star: 'Ketu',
    sub: 'Sun',
    profession: ``,
    character: ``,
    epilogue: `Thrombosis, Sunstroke, Unconscious, Eye trouble, Medical, Hospital, Service, Permanency`,
    kpPathogenicEffects: `Inflammation in the coronary artery`
  },
  {
    id: 87,
    rashiIndex: 4,
    rashi: 'Leo',
    kpRashiBodyParts: `HEART (Spine Upper)`,
    kpSubBodyParts: `Pulmonary artery - The blood vessel that supplies pure blood to the lungs and chest`,
    nakshatraIndex: 9,
    nakshatra: 'Magha',
    pada: '2',
    startsAt: `03°40'00"`,
    endsAt: `04°46'40"`,
    sign: 'Sun',
    star: 'Ketu',
    sub: 'Moon',
    profession: ``,
    character: ``,
    epilogue: `Boils, Thrombosis, Headache, Trouble in Aorta, Vena Cavae, Neuralgia, Shipping, Navy, Boilers, Regurgitation in the heart, confusion`,
    kpPathogenicEffects: `Pulmonary complications`
  },
  {
    id: 88,
    rashiIndex: 4,
    rashi: 'Leo',
    kpRashiBodyParts: `HEART (Spine Upper)`,
    kpSubBodyParts: `Valves - The membraneous fold that prevents the reflux of blood passes through them`,
    nakshatraIndex: 9,
    nakshatra: 'Magha',
    pada: '2',
    startsAt: `04°46'40"`,
    endsAt: `05°33'20"`,
    sign: 'Sun',
    star: 'Ketu',
    sub: 'Mars',
    profession: ``,
    character: ``,
    epilogue: `Epilepsy, Heart Disease, Locomotor Ataxia, interspinal muscles, Spinal marrow, Dispute, litigation, Defence, Police, industry`,
    kpPathogenicEffects: `Swelling and sudden failure of valves`
  },
  {
    id: 89,
    rashiIndex: 4,
    rashi: 'Leo',
    kpRashiBodyParts: `HEART (Spine Upper)`,
    kpSubBodyParts: `Pulmonary veins - The blood vessel that brings Impure blood from the lungs & chest`,
    nakshatraIndex: 9,
    nakshatra: 'Magha',
    pada: '2-3',
    startsAt: `05°33'20"`,
    endsAt: `07°33'20"`,
    sign: 'Sun',
    star: 'Ketu',
    sub: 'Rahu',
    profession: ``,
    character: ``,
    epilogue: `Note what Rahu indicates to that native. Disease, Blood Poisoning, Wrong Medicine, Black-magic, Meningitis, Dorsal Vertebra, Jail Department, Lethal Chamber, Fear, Depression, Disharmony`,
    kpPathogenicEffects: `Pulmonary complications`
  },
  {
    id: 90,
    rashiIndex: 4,
    rashi: 'Leo',
    kpRashiBodyParts: `HEART (Spine Upper)`,
    kpSubBodyParts: `Subclavian artery - The blood vessel that supplies pure blood to the shoulders and hands`,
    nakshatraIndex: 9,
    nakshatra: 'Magha',
    pada: '3',
    startsAt: `07°33'20"`,
    endsAt: `09°20'00"`,
    sign: 'Sun',
    star: 'Ketu',
    sub: 'Jupiter',
    profession: ``,
    character: ``,
    epilogue: `Philosophical Religious, Cancer, Congestion, Enlargement, Regurgitation, Bank Administrator, Advocate, judge, Religious Endowment`,
    kpPathogenicEffects: `Tumour or extra growth in the sub clavian artery`
  },
  {
    id: 91,
    rashiIndex: 4,
    rashi: 'Leo',
    kpRashiBodyParts: `HEART (Spine Upper)`,
    kpSubBodyParts: `Aorta - Deposited at the level of 4th Vertebra and pure blood passes through it `,
    nakshatraIndex: 9,
    nakshatra: 'Magha',
    pada: '3-4',
    startsAt: `09°20'00"`,
    endsAt: `11°26'40"`,
    sign: 'Sun',
    star: 'Ketu',
    sub: 'Saturn',
    profession: ``,
    character: ``,
    epilogue: `Rheumatic fever, Rheumatic heart, Affection of bony system, Chronic ailment, High fever, smallpox, position of trust, head of the department, factory, copper, steel, mine, real estate, abortive, denial of children, irregular monthly periodicity, defect in generative system, homeopathy`,
    kpPathogenicEffects: `Chronic and prolonged ailment in the aorta`
  },
  {
    id: 92,
    rashiIndex: 4,
    rashi: 'Leo',
    kpRashiBodyParts: `HEART (Spine Upper)`,
    kpSubBodyParts: `Papillary muscle - The muscle that helps the heart beat`,
    nakshatraIndex: 9,
    nakshatra: 'Magha',
    pada: '4',
    startsAt: `11°26'40"`,
    endsAt: `13°20'00"`,
    sign: 'Sun',
    star: 'Ketu',
    sub: 'Mercury',
    profession: ``,
    character: ``,
    epilogue: `Nervous trouble, Palpitation of the heart, Meningitis, Giddiness, Pestilence, Ingenia ?, Auditor, petition, writer, typist, journalist, advertising - no issue, barren`,
    kpPathogenicEffects: `Convulsionary fits in the papillary muscle`
  },
  {
    id: 93,
    rashiIndex: 4,
    rashi: 'Leo',
    kpRashiBodyParts: `HEART (Spine Upper)`,
    kpSubBodyParts: `Copius flow in and out of heart`,
    nakshatraIndex: 10,
    nakshatra: 'PurvaPhalguni',
    pada: '1',
    startsAt: `13°20'00"`,
    endsAt: `15°33'20"`,
    sign: 'Sun',
    star: 'Venus',
    sub: 'Venus',
    profession: ``,
    character: ``,
    epilogue: `Good complexion, beautiful, fondness for company, pleasure, generous, eye defect, mother or wife falls ill, gains money through business, speculation, social affairs, music, fine arts and chemistry`,
    kpPathogenicEffects: `Irregular and painful flow of blood`
  },
  {
    id: 94,
    rashiIndex: 4,
    rashi: 'Leo',
    kpRashiBodyParts: `HEART (Spine Upper)`,
    kpSubBodyParts: `Coronary artery - (The blood vessel that empties pure blood to the nervous system of the heart).`,
    nakshatraIndex: 10,
    nakshatra: 'PurvaPhalguni',
    pada: '1',
    startsAt: `15°33'20"`,
    endsAt: `16°13'20"`,
    sign: 'Sun',
    star: 'Venus',
    sub: 'Sun',
    profession: ``,
    character: ``,
    epilogue: `Most generous, amiable, affectionate, eye-defect, palpitation of the heart, bright disease, service in Hospital, Chemistry department, music, radio, women and children hospital, government service, stock exchange`,
    kpPathogenicEffects: `Inflammation in the coronary artery`
  },
  {
    id: 95,
    rashiIndex: 4,
    rashi: 'Leo',
    kpRashiBodyParts: `HEART (Spine Upper)`,
    kpSubBodyParts: `Aortic valves - The valves that permits the blood pumped out by the heart`,
    nakshatraIndex: 10,
    nakshatra: 'PurvaPhalguni',
    pada: '1-2',
    startsAt: `16°13'20"`,
    endsAt: `17°20'00"`,
    sign: 'Sun',
    star: 'Venus',
    sub: 'Moon',
    profession: ``,
    character: ``,
    epilogue: `Pleasure, sociability, comfort, impressionable, warm attraction, love affairs, disease of ovaries, enlarged tonsils, mucous diseases, service in cosmetics, navy, shipping, petrol refineries`,
    kpPathogenicEffects: `Complications in the inferior Vena cava(vein. carries deoxygenated blood from the lower half of the body to the right atrium of the heart)`
  },
  {
    id: 96,
    rashiIndex: 4,
    rashi: 'Leo',
    kpRashiBodyParts: `HEART (Spine Upper)`,
    kpSubBodyParts: `Coronary sinus - The opening of the blood vessel that empties Impure blood In the heart`,
    nakshatraIndex: 10,
    nakshatra: 'PurvaPhalguni',
    pada: '2',
    startsAt: `17°20'00"`,
    endsAt: `18°06'40"`,
    sign: 'Sun',
    star: 'Venus',
    sub: 'Mars',
    profession: ``,
    character: ``,
    epilogue: `Fond of pleasure, adventure, amorous, sports, music, instrumental, artistic, extravagant, wastes money, venereal diseases, cataract, good for advertisements, display, automobile, independent, chemical engineering industry, transport, surgical instruments, petroleum products, medicinal soaps`,
    kpPathogenicEffects: `Sudden inflammation in the coronary`
  },
  {
    id: 97,
    rashiIndex: 4,
    rashi: 'Leo',
    kpRashiBodyParts: `HEART (Spine Upper)`,
    kpSubBodyParts: `Superior Vena Cava-The blood vessel that empties larger amount of Impure blood into the heart`,
    nakshatraIndex: 10,
    nakshatra: 'PurvaPhalguni',
    pada: '2',
    startsAt: `18°06'40"`,
    endsAt: `20°06'40"`,
    sign: 'Sun',
    star: 'Venus',
    sub: 'Rahu',
    profession: ``,
    character: ``,
    epilogue: `Find out the position of Rahu. One is to find out the health and the profession. If Rahu were to be in Moon star Mercury sub one will suffer from brain disorder. So it is necessary for us to note down what Rahu can do and the result must be modified`,
    kpPathogenicEffects: `Complications in the superior vena cava(vein. carries deoxygenated blood from the upper half of the body to the right atrium of the heart)`
  },
  {
    id: 98,
    rashiIndex: 4,
    rashi: 'Leo',
    kpRashiBodyParts: `HEART (Spine Upper)`,
    kpSubBodyParts: `Subclavian artery - The blood vessel that supplies pure blood to the shoulders and hands`,
    nakshatraIndex: 10,
    nakshatra: 'PurvaPhalguni',
    pada: '2-3',
    startsAt: `20°06'40"`,
    endsAt: `21°53'20"`,
    sign: 'Sun',
    star: 'Venus',
    sub: 'Jupiter',
    profession: ``,
    character: ``,
    epilogue: `Indicates that the native will have much bloods, obstructions, corrupt blood, fever, boils, tumours inflammations judge, income tax department, ladies college, women and children hospital, administrator in transport, animal husbandry`,
    kpPathogenicEffects: `Tumour and extra growth in the subclavian artery`
  },
  {
    id: 99,
    rashiIndex: 4,
    rashi: 'Leo',
    kpRashiBodyParts: `HEART (Spine Upper)`,
    kpSubBodyParts: `Bracbio cephalic Trunk - Spine (Upper)`,
    nakshatraIndex: 10,
    nakshatra: 'PurvaPhalguni',
    pada: '3',
    startsAt: `21°53'20"`,
    endsAt: `24°00'00"`,
    sign: 'Sun',
    star: 'Venus',
    sub: 'Saturn',
    profession: ``,
    character: ``,
    epilogue: `Much afflicted by bad things or poison, weakness, pains in the duct, leather, skin, hides, physician for skin diseases , lethal, chamber, slaughter house, canning the non vegetarian food`,
    kpPathogenicEffects: `Chronic pain in the upper Spinal column`
  },
  {
    id: 100,
    rashiIndex: 4,
    rashi: 'Leo',
    kpRashiBodyParts: `HEART (Spine Upper)`,
    kpSubBodyParts: `Papillary muscle - The muscle that helps the heart beat`,
    nakshatraIndex: 10,
    nakshatra: 'PurvaPhalguni',
    pada: '3-4',
    startsAt: `24°00'00"`,
    endsAt: `25°53'20"`,
    sign: 'Sun',
    star: 'Venus',
    sub: 'Mercury',
    profession: ``,
    character: ``,
    epilogue: `Tremblings, palpitation of the heart, pains in the back, nervous debility, sanitary engineer, chemical engineer, salesman for drugs`,
    kpPathogenicEffects: `Convulsions in the papillary muscle - shooting and gripping pain`
  },
  {
    id: 101,
    rashiIndex: 4,
    rashi: 'Leo',
    kpRashiBodyParts: `HEART (Spine Upper)`,
    kpSubBodyParts: `Fossa ovalis - Cavity In the chamber of the heart`,
    nakshatraIndex: 10,
    nakshatra: 'PurvaPhalguni',
    pada: '4',
    startsAt: `25°53'20"`,
    endsAt: `26°40'00"`,
    sign: 'Sun',
    star: 'Venus',
    sub: 'Ketu',
    profession: ``,
    character: ``,
    epilogue: `According to the position of Ketu, one is to give the results`,
    kpPathogenicEffects: `Shrinking of the cavities of the heart`
  },
  {
    id: 102,
    rashiIndex: 4,
    rashi: 'Leo',
    kpRashiBodyParts: `HEART (Spine Upper)`,
    kpSubBodyParts: `Coronary artery - The blood vessel that empties pure blood to the nervous system of the heart`,
    nakshatraIndex: 11,
    nakshatra: 'UttaraPhalguni',
    pada: '1',
    startsAt: `26°40'00"`,
    endsAt: `27°20'00"`,
    sign: 'Sun',
    star: 'Sun',
    sub: 'Sun',
    profession: ``,
    character: ``,
    epilogue: `Generally healthy constitution, rapid recovery when ill, seat of affection, heart, spinal column, thereby causing palpitation, heart disease, spinal meningitis, sunstroke, disease of eye, brain fever, typhoid, etc. Permanent position in life, seeks highest position in commerce or Government, Managing Director, Chief Administrator, ruler, dictator, gets cooperation from subordinates, dauntless speculator, earnest lover, passionate, jeweller, precious metals, physician, medical department, police, cinema and games etc`,
    kpPathogenicEffects: `Inflammation in the coronary artery`
  },
  {
    id: 103,
    rashiIndex: 4,
    rashi: 'Leo',
    kpRashiBodyParts: `HEART (Spine Upper)`,
    kpSubBodyParts: `Ventricles - The cavity in the heart containing impure blood`,
    nakshatraIndex: 11,
    nakshatra: 'UttaraPhalguni',
    pada: '1',
    startsAt: `27°20'00"`,
    endsAt: `28°26'40"`,
    sign: 'Sun',
    star: 'Sun',
    sub: 'Moon',
    profession: ``,
    character: ``,
    epilogue: `Blood pressure, dropsy, eruption on face, poxes,pus, dysentery, boils, pustules,cyst, abscess, blister.- Service in shipping, navy commander, ship master, deals in liquids, tonics, marine engineer, mechanical engineer`,
    kpPathogenicEffects: `Swelling and pain in the ventricles`
  },
  {
    id: 104,
    rashiIndex: 4,
    rashi: 'Leo',
    kpRashiBodyParts: `HEART (Spine Upper)`,
    kpSubBodyParts: `Valves - The membraneous fold that prevents the reflux of blood passes through them`,
    nakshatraIndex: 11,
    nakshatra: 'UttaraPhalguni',
    pada: '1-2',
    startsAt: `28°26'40"`,
    endsAt: `29°13'20"`,
    sign: 'Sun',
    star: 'Sun',
    sub: 'Mars',
    profession: ``,
    character: ``,
    epilogue: `Robust health, good appearance, fair complexion, potty disposition, energetic, very violent, over optimistic, bold, unfit for subordinate jobs, always tendency to boss over others, wealthy, stock-exchange, loss in lottery, war material. Military or police, defence department, military high command, successful surgeon, pain in back, venereal distemper, gives landed property, higher education, frequent long journey. Cardinal thrombosis or surgical aid, pain in the head, epilepsy, meningitis, injury in the head and chest, fits`,
    kpPathogenicEffects: `Sudden inflammation and failure of the valves`
  },
  {
    id: 105,
    rashiIndex: 4,
    rashi: 'Leo',
    kpRashiBodyParts: `HEART (Spine Upper)`,
    kpSubBodyParts: `Cardiac Vein - The blood vessel that brings impure blood from lungs and chest`,
    nakshatraIndex: 11,
    nakshatra: 'UttaraPhalguni',
    pada: '2',
    startsAt: `29°13'20"`,
    endsAt: `30°00'00"`,
    sign: 'Sun',
    star: 'Sun',
    sub: 'Rahu',
    profession: ``,
    character: ``,
    epilogue: `Leading tendency, disposed towards other's wife, plague, jail department, heart disease, giddiness, high fever, unpleasant domestic environments, palpitation, regurgitation`,
    kpPathogenicEffects: `Complications in the cardiac veins`
  },
  {
    id: 106,
    rashiIndex: 5,
    rashi: 'Virgo',
    kpRashiBodyParts: `External abdominal and umbilical region, intestines Spine lower`,
    kpSubBodyParts: `Pelvis - Lower portion of the Trunk of the body at the side of Coccyx`,
    nakshatraIndex: 11,
    nakshatra: 'UttaraPhalguni',
    pada: '2',
    startsAt: `00°00'00"`,
    endsAt: `01°13'20"`,
    sign: 'Mercury',
    star: 'Sun',
    sub: 'Rahu',
    profession: ``,
    character: ``,
    epilogue: `Careless about diet, abdominal diseases intestinal trouble, typhoid, cough due to gas, a little nervous debility, accountant in jail or in such department indicated by Rahu according to its position in horoscope, medical department, nervous system, designer, engineer, consultant, contractor for supplies to the above departments`,
    kpPathogenicEffects: `Pain at the pelvic bone`
  },
  {
    id: 107,
    rashiIndex: 5,
    rashi: 'Virgo',
    kpRashiBodyParts: `External abdominal and umbilical region, intestines Spine lower`,
    kpSubBodyParts: `Pubis - Area in front of the side of the Coccyx`,
    nakshatraIndex: 11,
    nakshatra: 'UttaraPhalguni',
    pada: '2-3',
    startsAt: `01°13'20"`,
    endsAt: `03°00'00"`,
    sign: 'Mercury',
    star: 'Sun',
    sub: 'Jupiter',
    profession: ``,
    character: ``,
    epilogue: `Flatulence, never careful about diet, overeating, defect in assimilation on digestive system, schoolmaster, interpreter, registrar, journalist, inspector of schools, banks, income tax office, revenue department, preacher of religion`,
    kpPathogenicEffects: `Tumour tn the public bone`
  },
  {
    id: 108,
    rashiIndex: 5,
    rashi: 'Virgo',
    kpRashiBodyParts: `External abdominal and umbilical region, intestines Spine lower`,
    kpSubBodyParts: `Lumbar - The part of the back between Thorax & Pelvis`,
    nakshatraIndex: 11,
    nakshatra: 'UttaraPhalguni',
    pada: '3',
    startsAt: `03°00'00"`,
    endsAt: `05°06'40"`,
    sign: 'Mercury',
    star: 'Sun',
    sub: 'Saturn',
    profession: ``,
    character: ``,
    epilogue: `Reckless about diet, eats anything and everything, tapeworm (it is only in those who take mutton) mines engineer, coal dealers, watchmen night workers. In press, they deal with lead, that is linotypist. composer, handwriting expert, forgery`,
    kpPathogenicEffects: `Chronic back pain`
  },
  {
    id: 109,
    rashiIndex: 5,
    rashi: 'Virgo',
    kpRashiBodyParts: `External abdominal and umbilical region, intestines Spine lower`,
    kpSubBodyParts: `Appendix - The part in the lower abdominal quadrant without any function`,
    nakshatraIndex: 11,
    nakshatra: 'UttaraPhalguni',
    pada: '3-4',
    startsAt: `05°06'40"`,
    endsAt: `07°00'00"`,
    sign: 'Mercury',
    star: 'Sun',
    sub: 'Mercury',
    profession: ``,
    character: ``,
    epilogue: `Nervous breakdown, ulcer in mouth due to ulcer in stomach, irregular intake of food at short intervals, writer, literature, literary people, interpreter, messenger, postman`,
    kpPathogenicEffects: `Appendicititis`
  },
  {
    id: 110,
    rashiIndex: 5,
    rashi: 'Virgo',
    kpRashiBodyParts: `External abdominal and umbilical region, intestines Spine lower`,
    kpSubBodyParts: `Ventral - Cavity at the lower chamber of the heart`,
    nakshatraIndex: 11,
    nakshatra: 'UttaraPhalguni',
    pada: '4',
    startsAt: `07°00'00"`,
    endsAt: `07°46'40"`,
    sign: 'Mercury',
    star: 'Sun',
    sub: 'Ketu',
    profession: ``,
    character: ``,
    epilogue: `Food poisoning, diarrhea, sprue. For profession see the position of Ketu in the horoscope and then predict`,
    kpPathogenicEffects: `Complication of the heart`
  },
  {
    id: 111,
    rashiIndex: 5,
    rashi: 'Virgo',
    kpRashiBodyParts: `External abdominal and umbilical region, intestines Spine lower`,
    kpSubBodyParts: ``,
    nakshatraIndex: 11,
    nakshatra: 'UttaraPhalguni',
    pada: '4',
    startsAt: `07°46'40"`,
    endsAt: `10°00'00"`,
    sign: 'Mercury',
    star: 'Sun',
    sub: 'Venus',
    profession: `Seminal Sac - The sac collecting the semen`,
    character: ``,
    epilogue: `Good diet, very active, good health, vitamin 'B' deficiency and gas formation. Dance, artist, worker, sweet-maker, confectionery`,
    kpPathogenicEffects: `Pain and swelling of the seminal`
  },
  {
    id: 112,
    rashiIndex: 5,
    rashi: 'Virgo',
    kpRashiBodyParts: `External abdominal and umbilical region, intestines Spine lower`,
    kpSubBodyParts: `Urethral Sac - The sac collecting urine`,
    nakshatraIndex: 12,
    nakshatra: 'Hasta',
    pada: '1',
    startsAt: `10°00'00"`,
    endsAt: `11°06'40"`,
    sign: 'Mercury',
    star: 'Moon',
    sub: 'Moon',
    profession: ``,
    character: ``,
    epilogue: `Trouble in the intestine and also in the breast. Hypochondria (think while walking and imagine being ever sick), Chyle defective, avoid worries and discontentment, avoid alcohol, clearing agency (mostly shipping), textile, engineer in waterworks`,
    kpPathogenicEffects: `Dullness and pain in the Urethral sac`
  },
  {
    id: 113,
    rashiIndex: 5,
    rashi: 'Virgo',
    kpRashiBodyParts: `External abdominal and umbilical region, intestines Spine lower`,
    kpSubBodyParts: `Diaphragm - The inspirational tissues assisting breathing`,
    nakshatraIndex: 12,
    nakshatra: 'Hasta',
    pada: '1',
    startsAt: `11°06'40"`,
    endsAt: `11°53'20"`,
    sign: 'Mercury',
    star: 'Moon',
    sub: 'Mars',
    profession: ``,
    character: ``,
    epilogue: `Bleeding piles, irritation, ulcer in intestines, dealers in fluids, boilers, mechanical engineers, and marine engineers, those who manufacture printing ink (press ink). Agent to supply fish, prefers very hot drink and food`,
    kpPathogenicEffects: `Sudden breathing trouble`
  },
  {
    id: 114,
    rashiIndex: 5,
    rashi: 'Virgo',
    kpRashiBodyParts: `External abdominal and umbilical region, intestines Spine lower`,
    kpSubBodyParts: `Umbilical - The portion attached to the fetus lying below the chest`,
    nakshatraIndex: 12,
    nakshatra: 'Hasta',
    pada: '1-2',
    startsAt: `11°53'20"`,
    endsAt: `13°53'20"`,
    sign: 'Mercury',
    star: 'Moon',
    sub: 'Rahu',
    profession: ``,
    character: ``,
    epilogue: `Predict according to the position of Rahu in the horoscope`,
    kpPathogenicEffects: `Swelling of the umbilical region. Abdominal T.B.`
  },
  {
    id: 115,
    rashiIndex: 5,
    rashi: 'Virgo',
    kpRashiBodyParts: `External abdominal and umbilical region, intestines Spine lower`,
    kpSubBodyParts: `Pancreas - The gland that secretes Insulin and lies at the side of spleen`,
    nakshatraIndex: 12,
    nakshatra: 'Hasta',
    pada: '2',
    startsAt: `13°53'20"`,
    endsAt: `15°40'00"`,
    sign: 'Mercury',
    star: 'Moon',
    sub: 'Jupiter',
    profession: ``,
    character: ``,
    epilogue: `Overeating, diarrhea, cancer in intestines, poor assimilation, (without Jupiter cancer cannot appear. Jupiter also always covers digestive system and gives excess, expansion fat etc.) Those who print for others, publisher, and gives royalty. Navy accountant, connected with port-trust and also manage in textile mill, cloth merchant or agent`,
    kpPathogenicEffects: `Failure of the pancreas - Leads to sugar complaints`
  },
  {
    id: 116,
    rashiIndex: 5,
    rashi: 'Virgo',
    kpRashiBodyParts: `External abdominal and umbilical region, intestines Spine lower`,
    kpSubBodyParts: `Bowels - The intestines`,
    nakshatraIndex: 12,
    nakshatra: 'Hasta',
    pada: '2',
    startsAt: `15°40'00"`,
    endsAt: `17°46'40"`,
    sign: 'Mercury',
    star: 'Moon',
    sub: 'Saturn',
    profession: ``,
    character: ``,
    epilogue: `Causes constipation,completelydriesup,flatulence, pain,chronic disease, gas formation. Diggers (of wells, canals). Excavators, geologists, mine engineers. Those who are agents to supply liquid fuel to railways, kerosene, diesel oil. Advisers to give courage to commit forgery`,
    kpPathogenicEffects: `Chronic bowel failure`
  },
  {
    id: 117,
    rashiIndex: 5,
    rashi: 'Virgo',
    kpRashiBodyParts: `External abdominal and umbilical region, intestines Spine lower`,
    kpSubBodyParts: `Kidney, The organ at the lumbar region filtering the blood (The membraneous canal conveying urine from the Bladder outside the body)`,
    nakshatraIndex: 12,
    nakshatra: 'Hasta',
    pada: '2-3',
    startsAt: `17°46'40"`,
    endsAt: `19°40'00"`,
    sign: 'Mercury',
    star: 'Moon',
    sub: 'Mercury',
    profession: ``,
    character: ``,
    epilogue: `Nervous breakdown, very poor digestion, very poor memory, feeling uneasy and restless, irregular timing for diet, disorder of bowels. Personal assistant, personal clerk, camp clerk, messenger, engaged orator (who are paid money for speeches), Engineer, salesman, midwife (moon for nurse and mercury for assistance)`,
    kpPathogenicEffects: `Complications of the kidney`
  },
  {
    id: 118,
    rashiIndex: 5,
    rashi: 'Virgo',
    kpRashiBodyParts: `External abdominal and umbilical region, intestines Spine lower`,
    kpSubBodyParts: `Loops of intestines - Sharp curves of intestines`,
    nakshatraIndex: 12,
    nakshatra: 'Hasta',
    pada: '3',
    startsAt: `19°40'00"`,
    endsAt: `20°26'40"`,
    sign: 'Mercury',
    star: 'Moon',
    sub: 'Ketu',
    profession: ``,
    character: ``,
    epilogue: `Predict after finding out the position of Ketu in the horoscope`,
    kpPathogenicEffects: `Pain and shrinking of intestinal loops`
  },
  {
    id: 119,
    rashiIndex: 5,
    rashi: 'Virgo',
    kpRashiBodyParts: `External abdominal and umbilical region, intestines Spine lower`,
    kpSubBodyParts: `Ovary - The sexual glands in female which produce the Ova`,
    nakshatraIndex: 12,
    nakshatra: 'Hasta',
    pada: '3-4',
    startsAt: `20°26'40"`,
    endsAt: `22°40'00"`,
    sign: 'Mercury',
    star: 'Moon',
    sub: 'Venus',
    profession: ``,
    character: ``,
    epilogue: `Excessive intake of greens, sweets, drinks, Round worms. Due to drinks upset of bowels, sugarcane juice rather all sweet juices, shipping, marine, textile engineers, manufacturers of glass or spectacles. Artificial textiles like silk (soft, bright, beautiful), painting on cloth`,
    kpPathogenicEffects: `Overian trouble in women`
  },
  {
    id: 120,
    rashiIndex: 5,
    rashi: 'Virgo',
    kpRashiBodyParts: `External abdominal and umbilical region, intestines Spine lower`,
    kpSubBodyParts: `Lumbar - The part of the back between Thorax & Pelvis`,
    nakshatraIndex: 12,
    nakshatra: 'Hasta',
    pada: '4',
    startsAt: `22°40'00"`,
    endsAt: `23°20'00"`,
    sign: 'Mercury',
    star: 'Moon',
    sub: 'Sun',
    profession: ``,
    character: ``,
    epilogue: `Mechanical engineer, marine engineer, nurse in medical department, agent to supply goods to Government, Nervous department in a Hospital`,
    kpPathogenicEffects: `Pain in the back`
  },
  {
    id: 121,
    rashiIndex: 5,
    rashi: 'Virgo',
    kpRashiBodyParts: `External abdominal and umbilical region, intestines Spine lower`,
    kpSubBodyParts: `Small intestines - The Bowels`,
    nakshatraIndex: 13,
    nakshatra: 'Chitra',
    pada: '1',
    startsAt: `23°20'00"`,
    endsAt: `24°06'40"`,
    sign: 'Mercury',
    star: 'Mars',
    sub: 'Mars',
    profession: ``,
    character: ``,
    epilogue: `Ulcer in intestinal part, surgical aid needed, mostly duodenal ulcer, takes care of diet, typing, printing press, military accounts, mechanical or military engineer, mind to save money by black market, attaches more value to money, finds fault with others`,
    kpPathogenicEffects: `Shooting of sudden stomach pain`
  },
  {
    id: 122,
    rashiIndex: 5,
    rashi: 'Virgo',
    kpRashiBodyParts: `External abdominal and umbilical region, intestines Spine lower`,
    kpSubBodyParts: `Rectum - The distal portion of the large intestine which excavates the digested food outside of the body`,
    nakshatraIndex: 13,
    nakshatra: 'Chitra',
    pada: '1',
    startsAt: `24°06'40"`,
    endsAt: `26°06'40"`,
    sign: 'Mercury',
    star: 'Mars',
    sub: 'Rahu',
    profession: ``,
    character: ``,
    epilogue: `Note which planet is represented by Rahu and then whatever that planet and Mars and Mercury combination indicate is the result. Suppose the sublord is Venus, this combination is in GEMINI so the result will be given accordingly. Suppose sublord is Saturn then this combination is in VIRGO and result is given accordingly. This is the way how you should proceed in the case when node is a sublord of any combination in any sign of the Zodiac`,
    kpPathogenicEffects: `Piles - Complication during motion`
  },
  {
    id: 123,
    rashiIndex: 5,
    rashi: 'Virgo',
    kpRashiBodyParts: `External abdominal and umbilical region, intestines Spine lower`,
    kpSubBodyParts: `Ilium - The expansive, superior portion of the hip bone`,
    nakshatraIndex: 13,
    nakshatra: 'Chitra',
    pada: '1-2',
    startsAt: `26°06'40"`,
    endsAt: `27°53'20"`,
    sign: 'Mercury',
    star: 'Mars',
    sub: 'Jupiter',
    profession: ``,
    character: ``,
    epilogue: `Mentally very quick, commercial instinct (Mercury-instinct, lord of 1 and 10), Jupiter (Bank Administration and lord of 4 and 7 and Mars industry) Good health, if Jupiter, the sublord is also a significator of 6th house, then only Cancer in old age .Profitable investment, automatic accumulation of money. Has own ideals in selecting a partner in business or wife/ husband. Publisher, accountant in a bank, vice principal, professor, administrative department in engineering, accounts or defence department. A perSon who goes round and round and preaches religion`,
    kpPathogenicEffects: `Tumour in the glium`
  },
  {
    id: 124,
    rashiIndex: 5,
    rashi: 'Virgo',
    kpRashiBodyParts: `External abdominal and umbilical region, intestines Spine lower`,
    kpSubBodyParts: `Coccyx - The extreme end of the vertebral coloumn`,
    nakshatraIndex: 13,
    nakshatra: 'Chitra',
    pada: '2',
    startsAt: `27°53'20"`,
    endsAt: `30°00'00"`,
    sign: 'Mercury',
    star: 'Mars',
    sub: 'Saturn',
    profession: ``,
    character: ``,
    epilogue: `Most selfish, commits forgery, theft, black market, Health not good, worms in intestines constipation, works very hard, miserly, feels shy in a crowd, avoids or shuns society. Good in mathematics, statistics, physics, dynamics, mines engineering, Hookworm, chronic disease, (finger print office, CID, CBI (for government service SUN should also be connected) If ascendant falls at this point he himself is a thief, forger and if 6th or 10th houses are connected then in CID / CBI department`,
    kpPathogenicEffects: `Chronic pain at the bottom of the back`
  },
  {
    id: 125,
    rashiIndex: 6,
    rashi: 'Libra',
    kpRashiBodyParts: `LUMBAR REGION, SKIN, KIDNEYS`,
    kpSubBodyParts: `12th Rib - Lumbar - The last rib of the chest`,
    nakshatraIndex: 13,
    nakshatra: 'Chitra',
    pada: '2',
    startsAt: `00°00'00"`,
    endsAt: `01°53'20"`,
    sign: 'Venus',
    star: 'Mars',
    sub: 'Mercury',
    profession: ``,
    character: ``,
    epilogue: `Care more fo peace and pleasure and harmony. (Libra being for balance) mental equilibrium, Compares and contrasts, correct intuition. Brilliant, good health. Boring people by giving meticulous details. Very good to write and publish books. (Mercury to write and paper, Mars and Mercury to print), Hernia. Being 7th sign of the Zodiac, business with partners as sublord mercury is for plurality, advises and assists hence a good adviser. Story writer, Venus for love and beauty and passion and the 7th sign hence good in love affairs. Mercury being wavering and lord of 12th to this sign, he never gives his opinion, keeps it secret and never makes selection. Uterus removal why, because this sign shows the part and sub lord Mercury being lord of 12 is for loss and Mars is to cut, hence removal`,
    kpPathogenicEffects: `Tuberculosis`
  },
  {
    id: 126,
    rashiIndex: 6,
    rashi: 'Libra',
    kpRashiBodyParts: `LUMBAR REGION, SKIN, KIDNEYS`,
    kpSubBodyParts: `Inguinal Ring - The ring at the junction of the abdomen & thlgh - Hair matrix (inter cellular tissue of the Hair)`,
    nakshatraIndex: 13,
    nakshatra: 'Chitra',
    pada: '2-3',
    startsAt: `01°53'20"`,
    endsAt: `02°40'00"`,
    sign: 'Venus',
    star: 'Mars',
    sub: 'Ketu',
    profession: ``,
    character: ``,
    epilogue: `To whomsoever KETHU represents in the horoscope that planet along Mars and Venus should indicate the result. Spines would be affected`,
    kpPathogenicEffects: `Pain and swelling at this part`
  },
  {
    id: 127,
    rashiIndex: 6,
    rashi: 'Libra',
    kpRashiBodyParts: `LUMBAR REGION, SKIN, KIDNEYS`,
    kpSubBodyParts: `Coccygeus muscle (The muscle adjoining the coccyx)-The Hair (A long slender filament appended to the skin)`,
    nakshatraIndex: 13,
    nakshatra: 'Chitra',
    pada: '3',
    startsAt: `02°40'00"`,
    endsAt: `04°53'20"`,
    sign: 'Venus',
    star: 'Mars',
    sub: 'Venus',
    profession: ``,
    character: ``,
    epilogue: `Level headed dispassionate personal comforts, helps others, pleasant nature, fond of opposite sex, (Mars & Venus indicate greens) Venus shows eatables hence appendicitis due to eating of green vegetables etc., spendthrift, able salesman, popular. Business with partners. Why? Because Venus is lord of 1 and 8 (partner's money and Mars lord of 2 and 7, your money and 1 and 6 show self and partner. Dealer in 2nd hand goods (vehicles Venus and mars for 2nd hand goods and their repairs). Venus being indicator of pleasantness and Mars lord of 2 and 7 (2nd is for speech) so when both speak it is conversation hence pleasant conversationalist. Sincere, Enjoys in full`,
    kpPathogenicEffects: `Muscle catch - pain at this region`
  },
  {
    id: 128,
    rashiIndex: 6,
    rashi: 'Libra',
    kpRashiBodyParts: `LUMBAR REGION, SKIN, KIDNEYS`,
    kpSubBodyParts: `Hypogastric - part situated below the stomach - Epidermis`,
    nakshatraIndex: 13,
    nakshatra: 'Chitra',
    pada: '3-4',
    startsAt: `04°53'20"`,
    endsAt: `05°33'20"`,
    sign: 'Venus',
    star: 'Mars',
    sub: 'Sun',
    profession: ``,
    character: ``,
    epilogue: `Ulcer in the urinary tract, lower abdominal region, Transport department (Sun for Government office, Venus for vehicle and Mars for authority, administration). Loco-shed, military truck / van, magnanimous and sincere. Mars is for muscles and Sun for energy hence very good health. Such people should not employ opposite sex as their private secretary because they have no control. Here if the sublord Sun is deposited in the constellation of a planet in fixed sign then locoshed service as fixed is for service which gives fixed income. If it is deposited in the constellation of a common sign they fly, goes and comes back, if it is in movable sign then he leaves and takes that job. Movable sign shows business`,
    kpPathogenicEffects: `Pain and swelling in the stomach, Burning sensation`
  },
  {
    id: 129,
    rashiIndex: 6,
    rashi: 'Libra',
    kpRashiBodyParts: `LUMBAR REGION, SKIN, KIDNEYS`,
    kpSubBodyParts: `Capsule (Capsule enclosing the adrenal glands)`,
    nakshatraIndex: 13,
    nakshatra: 'Chitra',
    pada: '4',
    startsAt: `05°33'20"`,
    endsAt: `06°40'00"`,
    sign: 'Venus',
    star: 'Mars',
    sub: 'Moon',
    profession: ``,
    character: ``,
    epilogue: `Helps others, politician, fertile imagination, gentile, susceptible to all disease as there is no resistance, If moon is a significator of 6th house then difficulty in monthly period for Ladies. Satisfies the partner. Most lovable. If Moon is the sublord of 5 h cusp, then sincere in love affairs`,
    kpPathogenicEffects: `Failure of Adrenal glands`
  },
  {
    id: 130,
    rashiIndex: 6,
    rashi: 'Libra',
    kpRashiBodyParts: `LUMBAR REGION, SKIN, KIDNEYS`,
    kpSubBodyParts: `Inguinal Ring - Ring at the junction of abdomen & thigh - Duct of sweat glands (The duct that secretes sweats)`,
    nakshatraIndex: 14,
    nakshatra: 'Swati',
    pada: '1',
    startsAt: `06°40'00"`,
    endsAt: `08°40'00"`,
    sign: 'Venus',
    star: 'Rahu',
    sub: 'Rahu',
    profession: ``,
    character: ``,
    epilogue: `Whatever plane is represented by Rahu, that planet and the combination of Venus should offer the result, Venus and Rahu go in for not productive and barren hence birth control. Jupiter & Rahu is for birth control and if Rahu is connected with mars then they will have surgical aid to see that no more child is produced. Similarly see what other planets are connected with Rahu and predict accordingly.`,
    kpPathogenicEffects: `Pain and swelling in this part`
  },
  {
    id: 131,
    rashiIndex: 6,
    rashi: 'Libra',
    kpRashiBodyParts: `LUMBAR REGION, SKIN, KIDNEYS`,
    kpSubBodyParts: `Lumbar - Trigone Triangular area at the lumbar region`,
    nakshatraIndex: 14,
    nakshatra: 'Swati',
    pada: '1',
    startsAt: `08°40'00"`,
    endsAt: `10°26'40"`,
    sign: 'Venus',
    star: 'Rahu',
    sub: 'Jupiter',
    profession: ``,
    character: ``,
    epilogue: `~~~ to ->Septic throat, ear trouble, mums, ingenious, scholar, good character, reader, stock keeper, writer, explorer, finance broker, statistician`,
    kpPathogenicEffects: `Tumour and extra growth at this region`
  },
  {
    id: 132,
    rashiIndex: 6,
    rashi: 'Libra',
    kpRashiBodyParts: `LUMBAR REGION, SKIN, KIDNEYS`,
    kpSubBodyParts: `Pelvis - The bone below the abdomen`,
    nakshatraIndex: 14,
    nakshatra: 'Swati',
    pada: '1-2',
    startsAt: `10°26'40"`,
    endsAt: `12°33'20"`,
    sign: 'Venus',
    star: 'Rahu',
    sub: 'Saturn',
    profession: ``,
    character: ``,
    epilogue: `~~~ to ->Asthma, puss in the ear education poor, hand writing expert, or committing forgery, finger print expert, physics`,
    kpPathogenicEffects: `Chronic ailments in the pelvic bone`
  },
  {
    id: 133,
    rashiIndex: 6,
    rashi: 'Libra',
    kpRashiBodyParts: `LUMBAR REGION, SKIN, KIDNEYS`,
    kpSubBodyParts: `Cortex - External layer of the adrenal glands`,
    nakshatraIndex: 14,
    nakshatra: 'Swati',
    pada: '2',
    startsAt: `12°33'20"`,
    endsAt: `14°26'40"`,
    sign: 'Venus',
    star: 'Rahu',
    sub: 'Mercury',
    profession: ``,
    character: ``,
    epilogue: `~~~ to ->Hiccough (hiccup), ear trouble, active mind, critical scholar, salesman, communication department, transport, aerial, atomic energy, writer, author, dynamics`,
    kpPathogenicEffects: `The infection of the layer over the adrenal glands.`
  },
  {
    id: 134,
    rashiIndex: 6,
    rashi: 'Libra',
    kpRashiBodyParts: `LUMBAR REGION, SKIN, KIDNEYS`,
    kpSubBodyParts: `Medulla - Inner most portion of the hair - Hair follicle (Cavity where the hair Is deposited`,
    nakshatraIndex: 14,
    nakshatra: 'Swati',
    pada: '2',
    startsAt: `14°26'40"`,
    endsAt: `15°13'20"`,
    sign: 'Venus',
    star: 'Rahu',
    sub: 'Ketu',
    profession: ``,
    character: ``,
    epilogue: `~~~ to ->Septic throat, diphtheria, jealousy, adulterer, thief, cruel minded, pseudonymous, petition writer, ungrateful, no child birth, research department, deals in poisonous drugs, canned goods, gravitation`,
    kpPathogenicEffects: `Infection of this part leads to falling of hairs`
  },
  {
    id: 135,
    rashiIndex: 6,
    rashi: 'Libra',
    kpRashiBodyParts: `LUMBAR REGION, SKIN, KIDNEYS`,
    kpSubBodyParts: `Piriformis muscle - (Pear shaped muscle at the Coccyx)`,
    nakshatraIndex: 14,
    nakshatra: 'Swati',
    pada: '2-3',
    startsAt: `15°13'20"`,
    endsAt: `17°26'40"`,
    sign: 'Venus',
    star: 'Rahu',
    sub: 'Venus',
    profession: ``,
    character: ``,
    epilogue: `~~~ to ->Septic throat, dry cough, eartrouble, ingenious, humorous, artist, sales man, post and telegraph department, transport, radio, bus`,
    kpPathogenicEffects: `Pain and swelling at this part of the muscle`
  },
  {
    id: 136,
    rashiIndex: 6,
    rashi: 'Libra',
    kpRashiBodyParts: `LUMBAR REGION, SKIN, KIDNEYS`,
    kpSubBodyParts: `Pryramid - Renal part in the form of pyramid`,
    nakshatraIndex: 14,
    nakshatra: 'Swati',
    pada: '3',
    startsAt: `17°26'40"`,
    endsAt: `18°06'40"`,
    sign: 'Venus',
    star: 'Rahu',
    sub: 'Sun',
    profession: ``,
    character: ``,
    epilogue: `~~~ to ->Eosinophilia, pain in the shoulder, cruel minded, man versed in the art pertaining to boggling-amazements, holy, perfidious, atomic energy, research department, public appointment.`,
    kpPathogenicEffects: `Burning and shooting pain in the pyramid`
  },
  {
    id: 137,
    rashiIndex: 6,
    rashi: 'Libra',
    kpRashiBodyParts: `LUMBAR REGION, SKIN, KIDNEYS`,
    kpSubBodyParts: `Kidney - The small organ at the lumbar region to filter the blood`,
    nakshatraIndex: 14,
    nakshatra: 'Swati',
    pada: '3-4',
    startsAt: `18°06'40"`,
    endsAt: `19°13'20"`,
    sign: 'Venus',
    star: 'Rahu',
    sub: 'Moon',
    profession: ``,
    character: ``,
    epilogue: `~~~ to ->Ear trouble, puss in the ear, asthma, intuitive, thief, boatman, deals in drugs, explorer, nurse, engineer`,
    kpPathogenicEffects: `Affection of Kidneys, leading to urinary troubles`
  },
  {
    id: 138,
    rashiIndex: 6,
    rashi: 'Libra',
    kpRashiBodyParts: `LUMBAR REGION, SKIN, KIDNEYS`,
    kpSubBodyParts: `Mesenteric - Membraneous fold attaching the small intestines to the wall of the body - (Meissner's Corpuscle - Corpuscular tactus sensitive muscle at the end of the Intestines)`,
    nakshatraIndex: 14,
    nakshatra: 'Swati',
    pada: '4',
    startsAt: `19°13'20"`,
    endsAt: `20°00'00"`,
    sign: 'Venus',
    star: 'Rahu',
    sub: 'Mars',
    profession: ``,
    character: ``,
    epilogue: `~~~ to ->Septic throat, injury in the shoulder, critic, murderer, robber, rogue, mischievous, mechanical engineer, handwriting expert, finger print expert, police department`,
    kpPathogenicEffects: `Sudden intestinal afflictions`
  },
  {
    id: 139,
    rashiIndex: 6,
    rashi: 'Libra',
    kpRashiBodyParts: `LUMBAR REGION, SKIN, KIDNEYS`,
    kpSubBodyParts: `Appendicular - Pertaining to the Vermiformis of the appendix`,
    nakshatraIndex: 15,
    nakshatra: 'Vishakha',
    pada: '1',
    startsAt: `20°00'00"`,
    endsAt: `21°46'40"`,
    sign: 'Venus',
    star: 'Jupiter',
    sub: 'Jupiter',
    profession: ``,
    character: ``,
    epilogue: `Health very good, spend thrift, beautiful and a charming figure, very generous and noble, always for plenty, ifJupiter is significator of 6th house then the diseases it gives is Cancer. Hernia, enlargement of glands in lower abdominal region. Judge, income tax / hire purchase, broker, money lender, professor in ladies college, cashier in ladies club. True and honest people, marries one who may love`,
    kpPathogenicEffects: `Appendicitis shooting pain in the appendix resulting in the removal of the appendix`
  },
  {
    id: 140,
    rashiIndex: 6,
    rashi: 'Libra',
    kpRashiBodyParts: `LUMBAR REGION, SKIN, KIDNEYS`,
    kpSubBodyParts: `Renal (Part pertaining to the Kidney)`,
    nakshatraIndex: 15,
    nakshatra: 'Vishakha',
    pada: '1',
    startsAt: `21°46'40"`,
    endsAt: `23°53'20"`,
    sign: 'Venus',
    star: 'Jupiter',
    sub: 'Saturn',
    profession: ``,
    character: ``,
    epilogue: `If Saturn is significator of 2, 7 and badakasthana then infantile mortality otherwise very good life with all comforts. Chronic (SAT) disease, kidney, loins trouble, internal part damaged hence uterus removed. Insincere, unreliable, Most diplomatic, hypocrite, Never an extreme, Selfish, self centered. Any subordinate in revenue department, bank, court, law, transport departments as Saturn is for servant, Jupiter for administration, Skin / hides merchant as Venus is for skin, Saturn for death, Jupiter for trade / shop. If Jupiter is significator of 2nd house, he deals with money purse, 3rd with gloves. 12th shoes and 7th belts. Hence supplier / manufacturer / shopkeeper dealing with these items.`,
    kpPathogenicEffects: `Chronic affliction of the kidney`
  },
  {
    id: 141,
    rashiIndex: 6,
    rashi: 'Libra',
    kpRashiBodyParts: `LUMBAR REGION, SKIN, KIDNEYS`,
    kpSubBodyParts: `Papillary duct (Nipple like duct at the lumbar region)`,
    nakshatraIndex: 15,
    nakshatra: 'Vishakha',
    pada: '1-2',
    startsAt: `23°53'20"`,
    endsAt: `25°46'40"`,
    sign: 'Venus',
    star: 'Jupiter',
    sub: 'Mercury',
    profession: ``,
    character: ``,
    epilogue: `Supremel intelligent. Very noble master for his servants, always- touring, pleasant conversationalist, enjoys life in full. Most lovable. Very good adviser - legal or Income-tax. Takes enough precaution (mercury) hence avoids diseases, especially epidemic. Able salesman, comedy/novel writer. Propaganda, publicity. If mercury is the sublord of 5th house then many children, or love affairs with many, Wealthy, Income-tax, high-court, AGCR, audit / accounts departments, twin birth, plastic, glass, mirror, engineers`,
    kpPathogenicEffects: `Convulsion in this part of the duct`
  },
  {
    id: 142,
    rashiIndex: 6,
    rashi: 'Libra',
    kpRashiBodyParts: `LUMBAR REGION, SKIN, KIDNEYS`,
    kpSubBodyParts: `Ureter - The urinal track`,
    nakshatraIndex: 15,
    nakshatra: 'Vishakha',
    pada: '2',
    startsAt: `25°46'40"`,
    endsAt: `26°33'20"`,
    sign: 'Venus',
    star: 'Jupiter',
    sub: 'Ketu',
    profession: ``,
    character: ``,
    epilogue: `Ketu is for abortion, Faces difficulties, blackmailing, secret enemies, signs papers which he should not have signed and gets into trouble`,
    kpPathogenicEffects: `Urethral com plications`
  },
  {
    id: 143,
    rashiIndex: 6,
    rashi: 'Libra',
    kpRashiBodyParts: `LUMBAR REGION, SKIN, KIDNEYS`,
    kpSubBodyParts: `Portal - (The opening of the embryonic foregut) Capillary Loops: Nervous structure around the Urethra`,
    nakshatraIndex: 15,
    nakshatra: 'Vishakha',
    pada: '2',
    startsAt: `26°33'20"`,
    endsAt: `28°46'40"`,
    sign: 'Venus',
    star: 'Jupiter',
    sub: 'Venus',
    profession: ``,
    character: ``,
    epilogue: `Ever trying for peace, never quarreling, proper judgement, correct action, good judge, assessment in Income-tax office. Transport or Loan department in a bank. Air travel / Airport as Jupiter is for Air, Ether, Akasa. Very good health, normally does not suffer from disease, everything takes easy and everything is prearranged for him, has all comforts, becomes very rich. Neither with brother nor with neighbours he will have peaceful life`,
    kpPathogenicEffects: `Pus and swelling in the urethra`
  },
  {
    id: 144,
    rashiIndex: 6,
    rashi: 'Libra',
    kpRashiBodyParts: `LUMBAR REGION, SKIN, KIDNEYS`,
    kpSubBodyParts: `Spleen (The gland at the cardiac end of the stomach, and filters blood and removes any foreign body In the blood`,
    nakshatraIndex: 15,
    nakshatra: 'Vishakha',
    pada: '2-3',
    startsAt: `28°46'40"`,
    endsAt: `29°26'40"`,
    sign: 'Venus',
    star: 'Jupiter',
    sub: 'Sun',
    profession: ``,
    character: ``,
    epilogue: `Robust health Very beautiful to look at, generous and magnanimous, chemical / drugs / pharmaceutical dealer, income tax, salestax, revenue department, court, religious endowment, hospitals, (nurse-sun and moon for common cusps for this), Marries one whom he loves, Jupiter for development, sun and Venus a combination for social gathering. Security in service because of Sun (Steady, Stability).`,
    kpPathogenicEffects: `Swelling and pain in the spleen`
  },
  {
    id: 145,
    rashiIndex: 6,
    rashi: 'Libra',
    kpRashiBodyParts: `LUMBAR REGION, SKIN, KIDNEYS`,
    kpSubBodyParts: `Appendicular - pertaining to the Vermiformis of the appendix`,
    nakshatraIndex: 15,
    nakshatra: 'Vishakha',
    pada: '3',
    startsAt: `29°26'40"`,
    endsAt: `30°00'00"`,
    sign: 'Venus',
    star: 'Jupiter',
    sub: 'Moon',
    profession: ``,
    character: ``,
    epilogue: `Nurse, midwife, Navy/shipping as moon is for liquid, water, politician because Jupiter and Venus are called celestial ministers, kidney trouble, bladder trouble, puss in urine if Saturn aspects; clubs, society, crowds etc. Administrative officer in petrol, liquids, refined oils. Moon, Sun and Venus being luminaries hence for vision, manufacturers of glasses, spectacles, mirrors etc. Moon is for business hence successful businessman`,
    kpPathogenicEffects: `Appendicitis swelling of the appendix necessitating its removal`
  },
  {
    id: 146,
    rashiIndex: 7,
    rashi: 'Scorpio',
    kpRashiBodyParts: `URINARY & SEXUAL ORGAN, Anus - Generative organ, Bladder, Pelvic bones`,
    kpSubBodyParts: `Bladder - The sac that collects urine`,
    nakshatraIndex: 15,
    nakshatra: 'Vishakha',
    pada: '3-4',
    startsAt: `00°00'00"`,
    endsAt: `00°33'20"`,
    sign: 'Mars',
    star: 'Jupiter',
    sub: 'Moon',
    profession: ``,
    character: ``,
    epilogue: `Plumpy (Jup. is for fat) tall in figure. Very clever as Jupiter is for worldly wisdom, God's grace, Moon for mind and Mars for quickness, always optimistic, likes and dislikes strong. Disease in the bladder. For ladies, profuse bleeding during monthly period. Complex mood in love affairs, politics, banker, judge, vice principal as moon is for advice, Jupiter for education and Mars for authority, as also it is the 8th sign of the zodiac which shows him to be a family member of the institute / office he is employed in (7th)`,
    kpPathogenicEffects: `Swelling and pain in the bladder - frequent urination`
  },
  {
    id: 147,
    rashiIndex: 7,
    rashi: 'Scorpio',
    kpRashiBodyParts: `URINARY & SEXUAL ORGAN, Anus - Generative organ, Bladder, Pelvic bones`,
    kpSubBodyParts: `Ejaculation (The muscle that acts involunterily in ejecting out the semen)`,
    nakshatraIndex: 15,
    nakshatra: 'Vishakha',
    pada: '4',
    startsAt: `00°33'20"`,
    endsAt: `01°20'00"`,
    sign: 'Mars',
    star: 'Jupiter',
    sub: 'Mars',
    profession: ``,
    character: ``,
    epilogue: `Commanding (mars) appearance, sharp and curly hair. Muscular body (Mars) never mindful of obstacles because mars is for rash, dash and crash. Overcritical, self assertion, impulsive action. Get excited, quick recovery from disease as mars is for quickness as well as resistance and Jupiter is god's grace. Venereal distemper. Prostrate glands. Makes large money, No mind to save, fortune favours. Expects appreciation from lover. Keeps the partner in good cheer, Energetic`,
    kpPathogenicEffects: `Sudden pain in the seminal vesicle`
  },
  {
    id: 148,
    rashiIndex: 7,
    rashi: 'Scorpio',
    kpRashiBodyParts: `URINARY & SEXUAL ORGAN, Anus - Generative organ, Bladder, Pelvic bones`,
    kpSubBodyParts: `Urethra - The urinal track along the penis`,
    nakshatraIndex: 15,
    nakshatra: 'Vishakha',
    pada: '4',
    startsAt: `01°20'00"`,
    endsAt: `03°20'00"`,
    sign: 'Mars',
    star: 'Jupiter',
    sub: 'Rahu',
    profession: ``,
    character: ``,
    epilogue: `According to the planet which Rahu represents in his horoscope, prediction should be made`,
    kpPathogenicEffects: `Complication and Burning sensation in urinations`
  },
  {
    id: 149,
    rashiIndex: 7,
    rashi: 'Scorpio',
    kpRashiBodyParts: `URINARY & SEXUAL ORGAN, Anus - Generative organ, Bladder, Pelvic bones`,
    kpSubBodyParts: `Middle rectal (Middle of the rectum)`,
    nakshatraIndex: 16,
    nakshatra: 'Anuradha',
    pada: '1',
    startsAt: `03°20'00"`,
    endsAt: `05°26'40"`,
    sign: 'Mars',
    star: 'Saturn',
    sub: 'Saturn',
    profession: ``,
    character: ``,
    epilogue: `Lean (Sat tall,appear older than age (sat for old, chronic, hence hardworking, gossip, funky (sat for no interfering with others. (Scorpio being the sign of sexual organ and watery also) hence piles and ovary diseases, scanty flow of monthly to ladies. Very stingy (scorpion), Miserly (Saturn), Mine and its products (Sat. for underground), metals. As Saturn is for underground material and Scorpio is a Mars sign for lands and estate so also Saturn therefore, deals with agricultural estate and specifically for under ground bulbs like potatoes, onions, carrots, turnips, groundnut etc., lacks sympathy from lover`,
    kpPathogenicEffects: `Contraction of the rectum - piles`
  },
  {
    id: 150,
    rashiIndex: 7,
    rashi: 'Scorpio',
    kpRashiBodyParts: `URINARY & SEXUAL ORGAN, Anus - Generative organ, Bladder, Pelvic bones`,
    kpSubBodyParts: `Femur (The portion of the thigh)`,
    nakshatraIndex: 16,
    nakshatra: 'Anuradha',
    pada: '1',
    startsAt: `05°26'40"`,
    endsAt: `07°20'00"`,
    sign: 'Mars',
    star: 'Saturn',
    sub: 'Mercury',
    profession: ``,
    character: ``,
    epilogue: `Long nose (mercury), lean (Sat) thin chin (Sat lord of 3rd cusp for this lagna), ever wavering because of Mercury. Never idle because of Mars and Saturn, and Mercury lord of 8th and 11th, and 8th is for labour. Resourceful (Mars for authority, power, Saturn for confidence, trust and mercury for talk, contact) successful bargain. Mars and Mercury for forgery in talk and documents and Saturn knows no law. Service in fingerprint bureau, CBI, CID if meridian falls at this degree but if ascendant falls at this point then he himself a fifth columnist, spy, Saturn is always for stone and bone hence diseases he would have are gravel, stone in bladder, adenoids, (Mercury for paper) , inspection , accounts, plurity ? and being lord of 8 and 11, Mars lord of 6th house keeps more than one account to hide black money from government / partner in business etc. Gives expression to his attachment to the lover but wavering (Mercury), fluctuating bank position that is when 2nd cusp falls at this position in Scorpio then mercury is lord of 12th which shows expenses etc.`,
    kpPathogenicEffects: `Nervous pain in the thighs`
  },
  {
    id: 151,
    rashiIndex: 7,
    rashi: 'Scorpio',
    kpRashiBodyParts: `URINARY & SEXUAL ORGAN, Anus - Generative organ, Bladder, Pelvic bones`,
    kpSubBodyParts: `Rectum (The extreme opening of the alimentary canal)`,
    nakshatraIndex: 16,
    nakshatra: 'Anuradha',
    pada: '1-2',
    startsAt: `07°20'00"`,
    endsAt: `08°06'40"`,
    sign: 'Mars',
    star: 'Saturn',
    sub: 'Ketu',
    profession: ``,
    character: ``,
    epilogue: `Predict according to the planet which is represented by Ketu in his horoscope`,
    kpPathogenicEffects: `Arrogant piles resulting in surgery`
  },
  {
    id: 152,
    rashiIndex: 7,
    rashi: 'Scorpio',
    kpRashiBodyParts: `URINARY & SEXUAL ORGAN, Anus - Generative organ, Bladder, Pelvic bones`,
    kpSubBodyParts: `Penis - The male organ of copulation and of urinary excretion`,
    nakshatraIndex: 16,
    nakshatra: 'Anuradha',
    pada: '2',
    startsAt: `08°06'40"`,
    endsAt: `10°20'00"`,
    sign: 'Mars',
    star: 'Saturn',
    sub: 'Venus',
    profession: ``,
    character: ``,
    epilogue: `Good health, robust, venereal distemper as Scorpio denotes sexual organ and Saturn a chronic, Mars for boils and Venus kama hence ever dreaming other sex. Impulsive due to Mars, appears to be plain due to Venus but Saturn who knows no law and Mars is force, therefore actually he is not. Venus for Kama, Saturn for secrecy, Mars for force and therefore very loose in character, pleasant (due to Venus lord of 12) expenses. Sympathetic. Enjoys all comforts. Drinks much (Scorpio is a watery sign, Mars and Saturn for intoxication and Venus also for liquid. Service in slaughter house as Scorpio is 8th sign, (sign of death) and Saturn is also there to kill and Mars to use sharp weapon and also lord of 6th for service. Venus for skin, Saturn shows killed skin that is hide, Mars is for tanning hence tanning of leather/ skin/hides. Eversilver, meat shop again Mars to use weapon (sharp) and SAT to kill and 8th sign is for death. Also grave digger Scorpio for grave and Saturn is to dig and Mars for sharp metal, that is spade or any other such type`,
    kpPathogenicEffects: `Pus and swelling at the end of the penis`
  },
  {
    id: 153,
    rashiIndex: 7,
    rashi: 'Scorpio',
    kpRashiBodyParts: `URINARY & SEXUAL ORGAN, Anus - Generative organ, Bladder, Pelvic bones`,
    kpSubBodyParts: `Perineal - space between the anus & scrotum`,
    nakshatraIndex: 16,
    nakshatra: 'Anuradha',
    pada: '2',
    startsAt: `10°20'00"`,
    endsAt: `11°00'00"`,
    sign: 'Mars',
    star: 'Saturn',
    sub: 'Sun',
    profession: ``,
    character: ``,
    epilogue: `Healthy body, steady due to SUN, gets irritated due to Mars and Sun. Interested in psychic (8th sign) subjects. Never follows old custom, Deals in wool/ hair dealer as Mars is for trade and also to cut, Saturn for hair. 8th sign being a generative organ hence only when SUN is significator of 6th house. Sun is for Govt.. Dept., Saturn for under ground metal hence dealer in mines and metals. Mars for authority, Saturn for death and Sun for Govt. Dept., hence Death Registrar. Saturn for Secrecy, Mars for Police, Military and authority, power and Sun Govt, hence CID, CBI departments of the Govt., Blackmailing.`,
    kpPathogenicEffects: `False pain in the region - Inflammations`
  },
  {
    id: 154,
    rashiIndex: 7,
    rashi: 'Scorpio',
    kpRashiBodyParts: `URINARY & SEXUAL ORGAN, Anus - Generative organ, Bladder, Pelvic bones`,
    kpSubBodyParts: `Bladder — The sac that collects the urine`,
    nakshatraIndex: 16,
    nakshatra: 'Anuradha',
    pada: '2-3',
    startsAt: `11°00'00"`,
    endsAt: `12°06'40"`,
    sign: 'Mars',
    star: 'Saturn',
    sub: 'Moon',
    profession: ``,
    character: ``,
    epilogue: `Good personality, broad face, medication / concentration as Moon is lord of 9th Interest in mysteries of nature when 12th cusp falls here. Lazy due to lame Saturn and puts off things to the last moment. Proper intuition, prompt action, Puss (Moon - liquid and Saturn - Puss and Mars - boil/cut etc.,) Gnorrhea, chronic_ ailment. Renal stone (Sat for stone) Miserly, Moon for liquid Saturn for under ground and to pierce through it for boring/excavation etc., hence petrol, oil tank or well excavator. A little reserved, funky, partner leaves when Ascendant or lagna falls here. Steady in love affairs`,
    kpPathogenicEffects: `Swelling and pain in the bladder`
  },
  {
    id: 155,
    rashiIndex: 7,
    rashi: 'Scorpio',
    kpRashiBodyParts: `URINARY & SEXUAL ORGAN, Anus - Generative organ, Bladder, Pelvic bones`,
    kpSubBodyParts: `Vesicle - (The sac that collects the semen)`,
    nakshatraIndex: 16,
    nakshatra: 'Anuradha',
    pada: '3',
    startsAt: `12°06'40"`,
    endsAt: `12°53'20"`,
    sign: 'Mars',
    star: 'Saturn',
    sub: 'Mars',
    profession: ``,
    character: ``,
    epilogue: `Independent (Mars) Arrogant and revengeful (Mars) Intelligent, never mindful of obstacles, muscular body (Mars), good personality. If sixth cusp falls here then bleeding piles. (Mars for blood and boil and Saturn shows a chronic disease and Scorpio sign shows the part of the body.) Saturn for stone, bladder shown by the sign hence stone in bladder. Saturn is Yama, to cause death and level by piercing through the ground, Mars is for land and machinery hence bulldozer/tractor to plough and also level the ground/fields, Also all implements used to pierce the land like spade etc., Saturn also shows filth hence to lay pipes for drain and sewage underground. Saturn is through the ground and hidden and Mars is also for roads and building hence a hidden road is a tunnel. Proves to satisfy the partner. Deep meditation, working in cremation / burial ground. Scorpio is 8th sign (for death,) grave digger; Saturn is through the ground, to dig and also to do labour or service. Officials in Secret Police because Mars is for police, SAT for secrecy. Gallows, Jail, Causality ward, Scorpio 8th sign to show danger and injury by Mars. Bone fracture because Saturn is for bone. Remember 6th and 8th show disease and danger 6 and 10 for the doctor who cures that disease`,
    kpPathogenicEffects: `Sudden and shooting pain in the seminal vesicle`
  },
  {
    id: 156,
    rashiIndex: 7,
    rashi: 'Scorpio',
    kpRashiBodyParts: `URINARY & SEXUAL ORGAN, Anus - Generative organ, Bladder, Pelvic bones`,
    kpSubBodyParts: `Obturator / Obutrator (The disc that cloggs the intestines)`,
    nakshatraIndex: 16,
    nakshatra: 'Anuradha',
    pada: '3-4',
    startsAt: `12°53'20"`,
    endsAt: `14°53'20"`,
    sign: 'Mars',
    star: 'Saturn',
    sub: 'Rahu',
    profession: ``,
    character: ``,
    epilogue: `As Rahu indicates so shall be the prediction`,
    kpPathogenicEffects: `Complication and hernia of the Intestines`
  },
  {
    id: 157,
    rashiIndex: 7,
    rashi: 'Scorpio',
    kpRashiBodyParts: `URINARY & SEXUAL ORGAN, Anus - Generative organ, Bladder, Pelvic bones`,
    kpSubBodyParts: `Testes. The male gonad, egg-shaped, situated at the scrotum`,
    nakshatraIndex: 16,
    nakshatra: 'Anuradha',
    pada: '4',
    startsAt: `14°53'20"`,
    endsAt: `16°40'00"`,
    sign: 'Mars',
    star: 'Saturn',
    sub: 'Jupiter',
    profession: ``,
    character: ``,
    epilogue: `Well-built body, clever, good imagination. Manager / administrator, owner of mines. Philosopher (SAT). Interest in Psychic subjects / Will not accept any theory. Non-interfering Analytic, thoughtful and resourceful. Steady in love affairs and never a cheat JUPITER when sublord and a significator of 6th cusp, it gives CANCER. Incurable disease in the sexual organ denoted by Scorpio`,
    kpPathogenicEffects: `Abnormal swelling of the testes`
  },
  {
    id: 158,
    rashiIndex: 7,
    rashi: 'Scorpio',
    kpRashiBodyParts: `URINARY & SEXUAL ORGAN, Anus - Generative organ, Bladder, Pelvic bones`,
    kpSubBodyParts: `Rectum pad (The m uscular pad above the rectum)`,
    nakshatraIndex: 17,
    nakshatra: 'Jyeshtha',
    pada: '1',
    startsAt: `16°40'00"`,
    endsAt: `18°33'20"`,
    sign: 'Mars',
    star: 'Mercury',
    sub: 'Mercury',
    profession: ``,
    character: ``,
    epilogue: `Long nose, clever, over critical, sharp in intelligence, quick grasp, versatile, good lawyer / actor / salesman / Representative / liaison officer. Revengeful due to Mars. Typist, Proof Reader, Press (as Mercury is for paper, Type, print, publish and Mars is for machinery.)`,
    kpPathogenicEffects: `Pain during motion`
  },
  {
    id: 159,
    rashiIndex: 7,
    rashi: 'Scorpio',
    kpRashiBodyParts: `URINARY & SEXUAL ORGAN, Anus - Generative organ, Bladder, Pelvic bones`,
    kpSubBodyParts: `Rectum (The extreme opening of the alimentary canal)`,
    nakshatraIndex: 17,
    nakshatra: 'Jyeshtha',
    pada: '1',
    startsAt: `18°33'20"`,
    endsAt: `19°20'00"`,
    sign: 'Mars',
    star: 'Mercury',
    sub: 'Ketu',
    profession: ``,
    character: ``,
    epilogue: `As per Ketu you may offer the prediction`,
    kpPathogenicEffects: `Pain and swelling of therectum - piles`
  },
  {
    id: 160,
    rashiIndex: 7,
    rashi: 'Scorpio',
    kpRashiBodyParts: `URINARY & SEXUAL ORGAN, Anus - Generative organ, Bladder, Pelvic bones`,
    kpSubBodyParts: `Dorsal of Penis - Posterior trunk of the penis`,
    nakshatraIndex: 17,
    nakshatra: 'Jyeshtha',
    pada: '1-2',
    startsAt: `19°20'00"`,
    endsAt: `21°33'20"`,
    sign: 'Mars',
    star: 'Mercury',
    sub: 'Venus',
    profession: ``,
    character: ``,
    epilogue: `Beautiful, muscular body, marine engineer, good personality, intuitive, frank and plain. Fistula, complicated disease, venereal distemper, makes large money and spends much also. Fortunate, sympathetic, expects appreciation from partner. Most comfortable life, smooth life. Works in Power Flouse, Sanitary Engineer, Bridge construction. Lays bricks for lakes. Railway bridge construction. Tailor, ready-made cloth, Goldsmith`,
    kpPathogenicEffects: `Swelling of the whole of penis`
  },
  {
    id: 161,
    rashiIndex: 7,
    rashi: 'Scorpio',
    kpRashiBodyParts: `URINARY & SEXUAL ORGAN, Anus - Generative organ, Bladder, Pelvic bones`,
    kpSubBodyParts: `Perineal / perineum - space between the Anus & Scortum`,
    nakshatraIndex: 17,
    nakshatra: 'Jyeshtha',
    pada: '2',
    startsAt: `21°33'20"`,
    endsAt: `22°13'20"`,
    sign: 'Mars',
    star: 'Mercury',
    sub: 'Sun',
    profession: ``,
    character: ``,
    epilogue: `Military Engineer, Mechanical engineer, Adviser, Healthy, round face, intelligent, steady [Methodical, rational, practical. Quick recovery. Steady income and Steady expenses. No fluctuations, steadiness in love affairs. Govt. Press, Mint. Reserve Bank / incinerator to destroy currency notes. Mercury is for paper and print and currency and Mars a fiery planet to set fire to it. Sun and Mercury indicate notes and 8th sign is for death. Epileptic (MARS and MERCURY for fits), violent hysteria as MARS is for violence`,
    kpPathogenicEffects: `Inflammation in these parts`
  },
  {
    id: 162,
    rashiIndex: 7,
    rashi: 'Scorpio',
    kpRashiBodyParts: `URINARY & SEXUAL ORGAN, Anus - Generative organ, Bladder, Pelvic bones`,
    kpSubBodyParts: `Scrotum - The sac containing the testicles`,
    nakshatraIndex: 17,
    nakshatra: 'Jyeshtha',
    pada: '2',
    startsAt: `22°13'20"`,
    endsAt: `23°20'00"`,
    sign: 'Mars',
    star: 'Mercury',
    sub: 'Moon',
    profession: ``,
    character: ``,
    epilogue: `Very healthy body, changeability due to Moon. Crossing floor. Fistula, bleeding piles. Fisher in rectum. Moon & Mercury for textile, electric engineering, powerhouse engineering, boiler and its inspector. Ink, (Mercury to write, Moon the liquid and Mars for ribbon) dye, bridge / construction contractor`,
    kpPathogenicEffects: `The sac swollen and ugly`
  },
  {
    id: 163,
    rashiIndex: 7,
    rashi: 'Scorpio',
    kpRashiBodyParts: `URINARY & SEXUAL ORGAN, Anus - Generative organ, Bladder, Pelvic bones`,
    kpSubBodyParts: `Vesicle - (The sac that collects the semen)`,
    nakshatraIndex: 17,
    nakshatra: 'Jyeshtha',
    pada: '2-3',
    startsAt: `23°20'00"`,
    endsAt: `24°06'40"`,
    sign: 'Mars',
    star: 'Mercury',
    sub: 'Mars',
    profession: ``,
    character: ``,
    epilogue: `Well built body, short and curly hair, intense feeling, emotion, self-assertion, impulsive action, surgeon, stone, in bladder, kidney, Surgical aid for the womb/ ovaries. Extravagant, ever borrowing, purchases doubly (in multiplicity, each item in plural numbers). Mechanical engineer. Press technology, Iron Bridge construction using girders. Swinging bridge, suspension bridge etc., Cost accountant, Inspector`,
    kpPathogenicEffects: `Sudden and shooting pain in the seminal vesicle`
  },
  {
    id: 164,
    rashiIndex: 7,
    rashi: 'Scorpio',
    kpRashiBodyParts: `URINARY & SEXUAL ORGAN, Anus - Generative organ, Bladder, Pelvic bones`,
    kpSubBodyParts: `Urethra (male) The urinal track along the penis (Vagina female)`,
    nakshatraIndex: 17,
    nakshatra: 'Jyeshtha',
    pada: '3',
    startsAt: `24°06'40"`,
    endsAt: `26°06'40"`,
    sign: 'Mars',
    star: 'Mercury',
    sub: 'Rahu',
    profession: ``,
    character: ``,
    epilogue: `Typhoid, warden / superintendent in Jail. Apart form this any other result given by that planet which Rahu represents`,
    kpPathogenicEffects: `Complication and burning sensation in urinating`
  },
  {
    id: 165,
    rashiIndex: 7,
    rashi: 'Scorpio',
    kpRashiBodyParts: `URINARY & SEXUAL ORGAN, Anus - Generative organ, Bladder, Pelvic bones`,
    kpSubBodyParts: `Pelvis - The bone below the abdomen`,
    nakshatraIndex: 17,
    nakshatra: 'Jyeshtha',
    pada: '3-4',
    startsAt: `26°06'40"`,
    endsAt: `27°53'20"`,
    sign: 'Mars',
    star: 'Mercury',
    sub: 'Jupiter',
    profession: ``,
    character: ``,
    epilogue: `Strong and healthy, stalwart. Talkative, versatile. Meditation (preacher and not practising philosophy as JUPITER is to preach and SATURN to practise it). Income-tax officer, auditor, chartered accountant, Press Manager, Administration Department of engineering. Head in postal department. Tele, cable and all forms of communication. Incurable disease-complicated disease`,
    kpPathogenicEffects: `Tumourous growth in the palvis`
  },
  {
    id: 166,
    rashiIndex: 7,
    rashi: 'Scorpio',
    kpRashiBodyParts: `URINARY & SEXUAL ORGAN, Anus - Generative organ, Bladder, Pelvic bones`,
    kpSubBodyParts: `Opening of Penis - The extreme end of penis`,
    nakshatraIndex: 17,
    nakshatra: 'Jyeshtha',
    pada: '4',
    startsAt: `27°53'20"`,
    endsAt: `30°00'00"`,
    sign: 'Mars',
    star: 'Mercury',
    sub: 'Saturn',
    profession: ``,
    character: ``,
    epilogue: `Eyes deep set, long nose, no cheek at all. Mercury is for both sides, Saturn is for emaciation. Injury in hip bone. Chronic piles. Stone in bladder. No comfort of bedding. No good furniture. Great interest in mysteries of nature. Philosophical. Can meditate, concentrate, pray and also hypnotise others. Forgery master. Handwriting experts. Service in press. Mines engineer., Metal dealer. Stenographer MARS & MERCURY for typing and SATURN to shorten. Deals in lead (SATURN), drainage, sewerage. SATURN for cold, ice and watery sign also hence frigidaire. MARS and MERCURY for mechanical engineering`,
    kpPathogenicEffects: `Chronic pain in the end of the penis while urinating`
  },
  {
    id: 167,
    rashiIndex: 8,
    rashi: 'Sagittarius',
    kpRashiBodyParts: `HIPS & THIGHS, Arterial System - Nerves`,
    kpSubBodyParts: `Sacrum - The lower joints of the Vertebrae`,
    nakshatraIndex: 18,
    nakshatra: 'Mula',
    pada: '1',
    startsAt: `00°00'00"`,
    endsAt: `00°46'40"`,
    sign: 'Jupiter',
    star: 'Ketu',
    sub: 'Ketu',
    profession: `Physician: Health Department`,
    character: ``,
    epilogue: `High eyebrows and bushy hair. KETHU is for hair and abortion and this sign being dual in nature it may be two abortions and also it may be still born child and only delayed menses and no child, at all. Bold, greedy, God fearing, Karma yoga, lung trouble, hiccough, asthma, physician, speculation, spends much, cares more for society than for family life. Allows much freedom to wife`,
    kpPathogenicEffects: `Pain at the sacrum bone`
  },
  {
    id: 168,
    rashiIndex: 8,
    rashi: 'Sagittarius',
    kpRashiBodyParts: `HIPS & THIGHS, Arterial System - Nerves`,
    kpSubBodyParts: `Anterior Nervous system of the face`,
    nakshatraIndex: 18,
    nakshatra: 'Mula',
    pada: '1',
    startsAt: `00°46'40"`,
    endsAt: `03°00'00"`,
    sign: 'Jupiter',
    star: 'Ketu',
    sub: 'Venus',
    profession: `Priest Goddess Temple`,
    character: ``,
    epilogue: `Well proportional body, beautiful, enthusiastic and energetic, sincere, true, honest, diabetes, earns by fair means, no black money, cares equally for society and for wife`,
    kpPathogenicEffects: `Swelling, itches of the face`
  },
  {
    id: 169,
    rashiIndex: 8,
    rashi: 'Sagittarius',
    kpRashiBodyParts: `HIPS & THIGHS, Arterial System - Nerves`,
    kpSubBodyParts: `Coccyx - The extreme lower end of the Vertebrae`,
    nakshatraIndex: 18,
    nakshatra: 'Mula',
    pada: '1-2',
    startsAt: `03°00'00"`,
    endsAt: `03°40'00"`,
    sign: 'Jupiter',
    star: 'Ketu',
    sub: 'Sun',
    profession: `Druggist Chemist`,
    character: ``,
    epilogue: `Well developed body, broad eyes, aspiring, ambitious, honest good vitality, good health, quick recovery, bank, education, revenue, religious Departments, steady in love affairs`,
    kpPathogenicEffects: `Pain and swelling near the anus`
  },
  {
    id: 170,
    rashiIndex: 8,
    rashi: 'Sagittarius',
    kpRashiBodyParts: `HIPS & THIGHS, Arterial System - Nerves`,
    kpSubBodyParts: `Anterior Nervous system of the lungs`,
    nakshatraIndex: 18,
    nakshatra: 'Mula',
    pada: '2',
    startsAt: `03°40'00"`,
    endsAt: `04°46'40"`,
    sign: 'Jupiter',
    star: 'Ketu',
    sub: 'Moon',
    profession: `One who deals in tonics`,
    character: ``,
    epilogue: `Timid, lack of confidence, plumpy body yet charming appearance, flickering, lacks decision, changeability, leading toT.B. Politics, bank-export, long journey, change of residence, lacking morality, cannot be relied upon in love affairs`,
    kpPathogenicEffects: `Shooting pain in the lungs`
  },
  {
    id: 171,
    rashiIndex: 8,
    rashi: 'Sagittarius',
    kpRashiBodyParts: `HIPS & THIGHS, Arterial System - Nerves`,
    kpSubBodyParts: `Acetabulum - The large cup shaped cavity in which the femur articulates`,
    nakshatraIndex: 18,
    nakshatra: 'Mula',
    pada: '2',
    startsAt: `04°46'40"`,
    endsAt: `05°53'20"`,
    sign: 'Jupiter',
    star: 'Ketu',
    sub: 'Mars',
    profession: `Ayurveda`,
    character: ``,
    epilogue: `Well proportioned body, muscular, optimistic, bold, dauntless, over confident, invalid children, eosinophilia. Blood poisoning, surgeon, makes plenty of money and equally spending it. Speculation fails. Abortion, anemic/ weak wife, impulsive. Neither integrity nor morality. Manager / Director / traveller makes fortune in a foreign place`,
    kpPathogenicEffects: `Burning pain at the hip joints`
  },
  {
    id: 172,
    rashiIndex: 8,
    rashi: 'Sagittarius',
    kpRashiBodyParts: `HIPS & THIGHS, Arterial System - Nerves`,
    kpSubBodyParts: `Arteries & Nervous system of nose`,
    nakshatraIndex: 18,
    nakshatra: 'Mula',
    pada: '2-3',
    startsAt: `05°53'20"`,
    endsAt: `07°33'20"`,
    sign: 'Jupiter',
    star: 'Ketu',
    sub: 'Rahu',
    profession: `Jail Department`,
    character: ``,
    epilogue: `Find out significators of Rahu and Ketu and offer the prediction accordingly`,
    kpPathogenicEffects: `Swelling and pain at the nasal bones`
  },
  {
    id: 173,
    rashiIndex: 8,
    rashi: 'Sagittarius',
    kpRashiBodyParts: `HIPS & THIGHS, Arterial System - Nerves`,
    kpSubBodyParts: `Arteries & Nervous system of hips`,
    nakshatraIndex: 18,
    nakshatra: 'Mula',
    pada: '3',
    startsAt: `07°33'20"`,
    endsAt: `09°20'00"`,
    sign: 'Jupiter',
    star: 'Ketu',
    sub: 'Jupiter',
    profession: `Teacher-Education Department, Priest-religious endowment`,
    character: ``,
    epilogue: `Well built body commanding appearance, ambitious, confident, enthusiastic, never gets disheartened, lumbago, trouble in lungs, CANCER, earns by fair means, false prestige, donates much, revenue, religion, college, physician`,
    kpPathogenicEffects: `Tumour or extra growth at the hip joints`
  },
  {
    id: 174,
    rashiIndex: 8,
    rashi: 'Sagittarius',
    kpRashiBodyParts: `HIPS & THIGHS, Arterial System - Nerves`,
    kpSubBodyParts: `Femur - The big thigh bone`,
    nakshatraIndex: 18,
    nakshatra: 'Mula',
    pada: '3-4',
    startsAt: `09°20'00"`,
    endsAt: `11°26'40"`,
    sign: 'Jupiter',
    star: 'Ketu',
    sub: 'Saturn',
    profession: `Gallows-Slaughter house`,
    character: ``,
    epilogue: `High and bushy eyebrows, lean, beautiful, poor vitality, lazy, lethargic, failures, obstacles, fracture in hip, rheumatic pain, asthma philosopher, black money, speculation failure, miserly, beneficial friends, very jealous of others, keeps accounts of other's money, suspicious about wife / partner in business activities / character`,
    kpPathogenicEffects: `Chronic pain in the thigh bone`
  },
  {
    id: 175,
    rashiIndex: 8,
    rashi: 'Sagittarius',
    kpRashiBodyParts: `HIPS & THIGHS, Arterial System - Nerves`,
    kpSubBodyParts: `Arteries & Nervous system of the brain`,
    nakshatraIndex: 18,
    nakshatra: 'Mula',
    pada: '4',
    startsAt: `11°26'40"`,
    endsAt: `13°20'00"`,
    sign: 'Jupiter',
    star: 'Ketu',
    sub: 'Mercury',
    profession: `Advertisement, Publish-press`,
    character: ``,
    epilogue: `Graceful look, beautiful, lacking decision, versatile, crossing of floor, affection of lungs, asthma, earns by all means. Many accounts to hide black money. Successful speculation, gains through partner in business, interest in games. Gives freedom to his wife. Accountant, author, revenue/bank, teacher, journalist, astrologer`,
    kpPathogenicEffects: `Complicated brain disorders`
  },
  {
    id: 176,
    rashiIndex: 8,
    rashi: 'Sagittarius',
    kpRashiBodyParts: `HIPS & THIGHS, Arterial System - Nerves`,
    kpSubBodyParts: `Arteries & Nervous system of the neck`,
    nakshatraIndex: 19,
    nakshatra: 'PurvaAshadha',
    pada: '1',
    startsAt: `13°20'00"`,
    endsAt: `15°33'20"`,
    sign: 'Jupiter',
    star: 'Venus',
    sub: 'Venus',
    profession: `Transport`,
    character: ``,
    epilogue: `Very handsome, well proportioned body, charming appearance, graceful look, victory over enemies, becoming more and more confident, sincere, not wavering, diabetes, gains in speculation, lottery, Midwife, good in business, profitable, true to wife`,
    kpPathogenicEffects: `Swelling of the neck`
  },
  {
    id: 177,
    rashiIndex: 8,
    rashi: 'Sagittarius',
    kpRashiBodyParts: `HIPS & THIGHS, Arterial System - Nerves`,
    kpSubBodyParts: `Arteries & Nervous system of the eyes`,
    nakshatraIndex: 19,
    nakshatra: 'PurvaAshadha',
    pada: '1',
    startsAt: `15°33'20"`,
    endsAt: `16°13'20"`,
    sign: 'Jupiter',
    star: 'Venus',
    sub: 'Sun',
    profession: `Income Tax`,
    character: ``,
    epilogue: `Round face, broad eyes, good complexion, energetic, good vitality magnanimous, hiccough, long journey, higher studies, success in competitive examinations, steady income, profitable speculation, true to wife, integrity and morale`,
    kpPathogenicEffects: `Burning pain around the eyes`
  },
  {
    id: 178,
    rashiIndex: 8,
    rashi: 'Sagittarius',
    kpRashiBodyParts: `HIPS & THIGHS, Arterial System - Nerves`,
    kpSubBodyParts: `Arteries & Nervous system of the tongue`,
    nakshatraIndex: 19,
    nakshatra: 'PurvaAshadha',
    pada: '1-2',
    startsAt: `16°13'20"`,
    endsAt: `17°20'00"`,
    sign: 'Jupiter',
    star: 'Venus',
    sub: 'Moon',
    profession: `Tourist, Shipping`,
    character: ``,
    epilogue: `Plumpy body, ear trouble, puss in ear, little, timid, fears unnecessarily, diabetes, TB., slow recovery, unreliable, many love affairs, makes money by all means. Satisfactory income, speculation, failure, false prestige. Petrol pump, deals in rubber and milk`,
    kpPathogenicEffects: `Tasteless in tongue. Pain at the throat while swallowing food`
  },
  {
    id: 179,
    rashiIndex: 8,
    rashi: 'Sagittarius',
    kpRashiBodyParts: `HIPS & THIGHS, Arterial System - Nerves`,
    kpSubBodyParts: `Arteries & Nervous system of the sexual organs`,
    nakshatraIndex: 19,
    nakshatra: 'PurvaAshadha',
    pada: '2',
    startsAt: `17°20'00"`,
    endsAt: `18°06'40"`,
    sign: 'Jupiter',
    star: 'Venus',
    sub: 'Mars',
    profession: `Animal Husbandry`,
    character: ``,
    epilogue: `Well developed body, graceful look, commanding appearance, most enthusiastic, greedy, courageous, stealthy mind, quick recovery from disease. Vomiting blood, loss by speculation earns by all means, most extravagant, temper flares up. Both husband and wife very free. Most social, person of non-integrity and no morals, Automobile, transport, auditor, income tax officer, agent of bank, principal of a college, religious head`,
    kpPathogenicEffects: `Swelling of the sexual system`
  },
  {
    id: 180,
    rashiIndex: 8,
    rashi: 'Sagittarius',
    kpRashiBodyParts: `HIPS & THIGHS, Arterial System - Nerves`,
    kpSubBodyParts: `Arteries & Nervous system of the abdomen`,
    nakshatraIndex: 19,
    nakshatra: 'PurvaAshadha',
    pada: '2',
    startsAt: `18°06'40"`,
    endsAt: `20°06'40"`,
    sign: 'Jupiter',
    star: 'Venus',
    sub: 'Rahu',
    profession: `Jail for Women`,
    character: ``,
    epilogue: `Predict according to the planet Rahu signifies`,
    kpPathogenicEffects: `Abdominal disorders - Hernia`
  },
  {
    id: 181,
    rashiIndex: 8,
    rashi: 'Sagittarius',
    kpRashiBodyParts: `HIPS & THIGHS, Arterial System - Nerves`,
    kpSubBodyParts: `Ilium (The hip bones) - Arteries & Nervous system of the stomach`,
    nakshatraIndex: 19,
    nakshatra: 'PurvaAshadha',
    pada: '2-3',
    startsAt: `20°06'40"`,
    endsAt: `21°53'20"`,
    sign: 'Jupiter',
    star: 'Venus',
    sub: 'Jupiter',
    profession: `Banker-Revenue Department, Company Law,  Advocate`,
    character: ``,
    epilogue: `Frumpy body, charming appearance, tail, gigantic figure, very fair complexion, bold, pushful, overconfident, GODDESS, fearing, most religious, traditional, conventional, law abiding, true, sincere, most enthusiastic and optimistic, quick recovery , CANCER in lungs, earns by fair means, possesses estates but broker in estates if 7th cusp falls here. Man of sterling character. Most harmonious wedded life, affectionate, Judge, assessment officer, estimate officer, architect, designer, good in art, music drawing, Animal Husbandry, breeding and expanding, Manager, choultry to feed others, minister, popular, successful politician`,
    kpPathogenicEffects: `Ulcer and tumour in the stomach`
  },
  {
    id: 182,
    rashiIndex: 8,
    rashi: 'Sagittarius',
    kpRashiBodyParts: `HIPS & THIGHS, Arterial System - Nerves`,
    kpSubBodyParts: `Pubis - (The frontal bones of the hip bones) - Arteries & Nervous system of the feet`,
    nakshatraIndex: 19,
    nakshatra: 'PurvaAshadha',
    pada: '3',
    startsAt: `21°53'20"`,
    endsAt: `24°00'00"`,
    sign: 'Jupiter',
    star: 'Venus',
    sub: 'Saturn',
    profession: `Banker-Finance Department, Mines-Mine ores, Death duty`,
    character: ``,
    epilogue: `Very fair but lean, Asthma, fracture of hips of bones. A man who has no sperms; zoospermia, hence barren and cannot produce children. Also cannot satisfy the partner in life. Stealthy connections slaughter house, abortions, mine and its products, transport, draftsman (SAT and VENUS for drawing), statistics, intelligence department in the Revenue department, enforcement staff in foreign exchange (Mars also must be connected). Very mean in love affairs. Blackmailing, Writing anonymous letter`,
    kpPathogenicEffects: `Chronic pain in the public bone and small bones of the feet`
  },
  {
    id: 183,
    rashiIndex: 8,
    rashi: 'Sagittarius',
    kpRashiBodyParts: `HIPS & THIGHS, Arterial System - Nerves`,
    kpSubBodyParts: `Arteries & Nervous system of the Kidney`,
    nakshatraIndex: 19,
    nakshatra: 'PurvaAshadha',
    pada: '3-4',
    startsAt: `24°00'00"`,
    endsAt: `25°53'20"`,
    sign: 'Jupiter',
    star: 'Venus',
    sub: 'Mercury',
    profession: `Auditor, Inspector in a Bank, Civil Engineer, Income Tax`,
    character: ``,
    epilogue: `Long nose, impressive eyes, charming appearance, changing ideas, very bad subordinates as PA/PS/peon if the ascendant falls in this position. Railway eng., accountant, auditor, income tax, vice principal, vice chancellor, All India Radio (propagating and giving information etc.). JUPITER & MERCURY for journalist, Mercury for music. Engineering, transport, income tax and Revenue departments, Assistant, deputy, joint, additional secretary or secretary himself, mint, currency, asst, editor`,
    kpPathogenicEffects: `Failure of kidney - urine mixing with the blood system`
  },
  {
    id: 184,
    rashiIndex: 8,
    rashi: 'Sagittarius',
    kpRashiBodyParts: `HIPS & THIGHS, Arterial System - Nerves`,
    kpSubBodyParts: `Arteries & Nervous system of the hip bone`,
    nakshatraIndex: 19,
    nakshatra: 'PurvaAshadha',
    pada: '4',
    startsAt: `25°53'20"`,
    endsAt: `26°40'00"`,
    sign: 'Jupiter',
    star: 'Venus',
    sub: 'Ketu',
    profession: ``,
    character: ``,
    epilogue: `Find out what Ketu signifies and predict accordingly`,
    kpPathogenicEffects: `Swelling and pain in the Ischium`
  },
  {
    id: 185,
    rashiIndex: 8,
    rashi: 'Sagittarius',
    kpRashiBodyParts: `HIPS & THIGHS, Arterial System - Nerves`,
    kpSubBodyParts: `Arteries & Nervous system of the Testes`,
    nakshatraIndex: 20,
    nakshatra: 'UttaraAshadha',
    pada: '1',
    startsAt: `26°40'00"`,
    endsAt: `27°20'00"`,
    sign: 'Jupiter',
    star: 'Sun',
    sub: 'Sun',
    profession: `Reserve Bank, Physician, Education, College`,
    character: `Magnanimous, True`,
    epilogue: `Plumpy body, round face, commanding appearance, physician, medical department, highly qualified, foreign qualification, quick recovery from disease, much of vitality. In Reserve Bank, Government Colleges, nationalised banks, ever progressing, prosperous, no invalid child whereas in JUPITER, KETHU, MARS combination invalid child only when MARS is sublord of 5th cusp and lord of 5 and 12. That is, for SAGITTARIUS Lagnas, MARS is lord of 5 and 12`,
    kpPathogenicEffects: `Burning pain in the tester`
  },
  {
    id: 186,
    rashiIndex: 8,
    rashi: 'Sagittarius',
    kpRashiBodyParts: `HIPS & THIGHS, Arterial System - Nerves`,
    kpSubBodyParts: `Arteries & Nervous system of the Hands`,
    nakshatraIndex: 20,
    nakshatra: 'UttaraAshadha',
    pada: '1',
    startsAt: `27°20'00"`,
    endsAt: `28°26'40"`,
    sign: 'Jupiter',
    star: 'Sun',
    sub: 'Moon',
    profession: `Politician`,
    character: `Submissive to women, Does subversive activities`,
    epilogue: `Graceful look, fair complexion, changeability, never steady, never friendly with parents, hates relatives, slow recovery from disease, lung trouble, unsteady in love affairs, politician, minister, export/import, foreign trade, foreign assignment higher education, sudden death, interest in games and society`,
    kpPathogenicEffects: `Swelling in the hands, pus, boils etc`
  },
  {
    id: 187,
    rashiIndex: 8,
    rashi: 'Sagittarius',
    kpRashiBodyParts: `HIPS & THIGHS, Arterial System - Nerves`,
    kpSubBodyParts: `Arteries & Nervous system of the Palms`,
    nakshatraIndex: 20,
    nakshatra: 'UttaraAshadha',
    pada: '1-2',
    startsAt: `28°26'40"`,
    endsAt: `29°13'20"`,
    sign: 'Jupiter',
    star: 'Sun',
    sub: 'Mars',
    profession: `Mayor, Minister, Orator, Civilian in Military, Foreign Embassy, Judge`,
    character: `Bold-fond of bad deeds`,
    epilogue: `Well proportioned body, Commanding appearance, fair complexion, over optimistic, avaricious, energetic, injuries, venereal distemper, high fever, fracture of arms, officer of Govt, service, success in competitive examinations. Speculation failure, lawyer, judge, agent, love affairs with high-class people. Waste of money, overseas, fortune in a foreign place, divorce, cheat, industrialist, principal, chief judge, manager of a bank, Animal Husbandry`,
    kpPathogenicEffects: `Burning pain in the palm of the hands`
  },
  {
    id: 188,
    rashiIndex: 8,
    rashi: 'Sagittarius',
    kpRashiBodyParts: `HIPS & THIGHS, Arterial System - Nerves`,
    kpSubBodyParts: `Arteries & Nervous system of the Vertebrae`,
    nakshatraIndex: 20,
    nakshatra: 'UttaraAshadha',
    pada: '2',
    startsAt: `29°13'20"`,
    endsAt: `30°00'00"`,
    sign: 'Jupiter',
    star: 'Sun',
    sub: 'Rahu',
    profession: `Jail Department`,
    character: ``,
    epilogue: `You have to see the planet connected with Rahu. And then offer the prediction`,
    kpPathogenicEffects: `Back pain - Cracking pain in the back`
  },
  {
    id: 189,
    rashiIndex: 9,
    rashi: 'Capricorn',
    kpRashiBodyParts: `KNEES, BONES & JOINTS`,
    kpSubBodyParts: `Sacrum - The lower bones of the Vertebrae`,
    nakshatraIndex: 20,
    nakshatra: 'UttaraAshadha',
    pada: '2',
    startsAt: `00°00'00"`,
    endsAt: `01°13'20"`,
    sign: 'Saturn',
    star: 'Sun',
    sub: 'Rahu',
    profession: ``,
    character: ``,
    epilogue: `Predict according to the planet represented by RAHU. Rahu represents jails and this being a 10th sign, his profession may be connected with jails`,
    kpPathogenicEffects: `Pain and swelling at the anus - piles`
  },
  {
    id: 190,
    rashiIndex: 9,
    rashi: 'Capricorn',
    kpRashiBodyParts: `KNEES, BONES & JOINTS`,
    kpSubBodyParts: `The Radius - The bone at the outer side of the thumb`,
    nakshatraIndex: 20,
    nakshatra: 'UttaraAshadha',
    pada: '2-3',
    startsAt: `01°13'20"`,
    endsAt: `03°00'00"`,
    sign: 'Saturn',
    star: 'Sun',
    sub: 'Jupiter',
    profession: ``,
    character: ``,
    epilogue: `If ascendant falls here then the fellow should be magnanimous, materialistic, true, honest and sincere. Not thin and lean but fatty as JUPITER is for fatty bulky. Religious minded as SUN denotes uplift of soul, Saturn for concentration and JUPITER for religion. In Education Department, a philosopher, SUN for medical, JUPITER for progeny, SAT for science, hence biology department also. Religious preacher, fond of change. JUPITER being lord of 3 and 12 for this lagna Agent/ representative, touring job. when 2nd cusp falls here then Jupiter is lord of 1 and 4, receipt of money through agriculture and teaching , professions. When 4th cusp falls here JUPITER is lord of 6 and 3 and SUN lord of 11th house, gains through agency. Not good relations with his neighbours. When the 5th cusp falls here, then JUP is lord of 4 and 7, SUN lord of 12 and SATURN lord of 5 and 6th, hence children birth in, hospital under doctor's care. Speculative gains through estate broker ship. When 6th cusp falls here, it is definitely service in a bank (Nationalised or Reserve/State). As it is the movable sign and for 10th also, In a reputed bank with name, fame and reputation. Famous politician, economist, educationist, religious head or its cap, JUPITER lord of 5 and 8 Cancer in the knee and bone emaciation of fat at that part. Chronic gout, if 8th cusp fails here, then JUP is lord of 7 and 10 shows business in partnership. Ever changing place because it is a movable sign and JUPITER is lord of 3 and 12. SUN being lord of 8th , would meet with obstacles, 1,2,3,8 and 12 being the houses conjointly denoted by this combination, issue of cheque to the neighbour younger/brother/ sister is indicated. As far as name, fame and reputation shown by 10th sign of the zodiac are concerned, because of 8 and 12, loss of all this. No honour, no award. SATURN gives position of trust, Sun for Govt, Jupiter for religion, Education, Revenue, Law etc. also administrator, therefore, MLA, MLC, MP etc. but not a minister as Mars being absent he can't have any authority, Service in high-court, judge, education or revenue depts. Or religious endowment boards. Honest, municipality, health/ sanitary inspector, councillor. If JUPITER is significator of 6th cusp then CANCER in breast/lower part of lung or dislocation of knee cap etc., Timid partner promised with gains`,
    kpPathogenicEffects: `Pain and swelling of the Thumb`
  },
  {
    id: 191,
    rashiIndex: 9,
    rashi: 'Capricorn',
    kpRashiBodyParts: `KNEES, BONES & JOINTS`,
    kpSubBodyParts: `Patella - The disc like bone at the knee joint`,
    nakshatraIndex: 20,
    nakshatra: 'UttaraAshadha',
    pada: '3',
    startsAt: `03°00'00"`,
    endsAt: `05°06'40"`,
    sign: 'Saturn',
    star: 'Sun',
    sub: 'Saturn',
    profession: ``,
    character: ``,
    epilogue: `This combination denotes 1,2, 8. Ever in danger, SATURN, a death inflicting cold, chronic planet, chronic disease, structure of bold bones. Bushy eyebrows and profuse hair growth. Dealer in hair, cement, metals, geologist. Archives, monuments antiques etc. CID, CBI. Thin and lean, dishonest, cheat. Sun for meditation and Saturn for concentration, therefore concentrated meditation. Disease would be chronic due to SATURN, only when the 6th cusp falls at this point. It can be bone fracture at the knee joints etc. or fracture of ribs of breast, collapse of heart or lung, eosinophilia, pneumonia`,
    kpPathogenicEffects: `Chronic pain on the knee cap`
  },
  {
    id: 192,
    rashiIndex: 9,
    rashi: 'Capricorn',
    kpRashiBodyParts: `KNEES, BONES & JOINTS`,
    kpSubBodyParts: `Vertebral joints (Joints of the Vertebral column)`,
    nakshatraIndex: 20,
    nakshatra: 'UttaraAshadha',
    pada: '3-4',
    startsAt: `05°06'40"`,
    endsAt: `07°00'00"`,
    sign: 'Saturn',
    star: 'Sun',
    sub: 'Mercury',
    profession: ``,
    character: ``,
    epilogue: `If Ascendant falls here then MERCURY is lord of 6 and 9. Saturn is for unlawful, science, geology, bones, stones, cement, chronic etc. and SUN, lord of 8th. Tall, chronic sickness, fake currency, Gains from foreigners/father, long journeys, CID, CBI Depts, P & T Dept, Business in partnership. Nervous debility, speech affected, Talks less, underground tunnel/communication. Liar, Astrologer. Export of hairs, cough, chronic asthma, orator, Govt., secret propagandist, Govt. Publications. Scientific adviser to the Govt, heart attack. Inheritance of willed property of a stranger or father. Labour in IAC`,
    kpPathogenicEffects: `Complications in the vertebral joints`
  },
  {
    id: 193,
    rashiIndex: 9,
    rashi: 'Capricorn',
    kpRashiBodyParts: `KNEES, BONES & JOINTS`,
    kpSubBodyParts: `Discs in the vertebrae - The disc that lie between each vertebra`,
    nakshatraIndex: 20,
    nakshatra: 'UttaraAshadha',
    pada: '4',
    startsAt: `07°00'00"`,
    endsAt: `07°46'40"`,
    sign: 'Saturn',
    star: 'Sun',
    sub: 'Ketu',
    profession: ``,
    character: ``,
    epilogue: `See which planet is represented by KETHU and then offer the result according the combination thus formed in the zodiac, sign, star and sub. Kethu is abortive and confusion creating planet. Infantile death, congestion in the heart and its collapse or uncertain heartbeat are the resultant effects`,
    kpPathogenicEffects: `Cracking and thinning of dises`
  },
  {
    id: 194,
    rashiIndex: 9,
    rashi: 'Capricorn',
    kpRashiBodyParts: `KNEES, BONES & JOINTS`,
    kpSubBodyParts: `Manubrium - The tender bone above the sternum`,
    nakshatraIndex: 20,
    nakshatra: 'UttaraAshadha',
    pada: '4',
    startsAt: `07°46'40"`,
    endsAt: `10°00'00"`,
    sign: 'Saturn',
    star: 'Sun',
    sub: 'Venus',
    profession: ``,
    character: ``,
    epilogue: `Sun and Venus for Air India and Saturn for Labour hence labour in the Air India. Chronic skin diseases, deep-set eyes. SUN & VENUS for social, Saturn to hide hence wants loneliness and away from the crowd. Unsocial, Saturn for secrecy, Venus for passion, so secret passions, love affairs, Venus being lord of 5 and 10, gains from speculation with other's money (8th), skin/hide dealer. Sweet in talk but reserved, thin and lean but beautiful: Govt, transport dept. Chronic disease of skins at breast/patella, kneecaps etc., eatables which grow underground like potato, groundnut, turnip, etc. Very popular`,
    kpPathogenicEffects: `Swelling and pain above the sternum`
  },
  {
    id: 195,
    rashiIndex: 9,
    rashi: 'Capricorn',
    kpRashiBodyParts: `KNEES, BONES & JOINTS`,
    kpSubBodyParts: `Spinal fluid - The fluid encircling the spinal chord`,
    nakshatraIndex: 21,
    nakshatra: 'Shravana',
    pada: '1',
    startsAt: `10°00'00"`,
    endsAt: `11°06'40"`,
    sign: 'Saturn',
    star: 'Moon',
    sub: 'Moon',
    profession: ``,
    character: ``,
    epilogue: `Timid, ever changing, wavering, short life if MOON is also connected with Badhakashthana. Never successful in first attempt, disappointed and trading mind, adaptable. Puss in the knee or congestion in the knee gout or dislocation of the knee cap/joint. Water in the lower part of the lung, pessimist, business with partner. Partner also timid. Very thick and thin with each other. Bony structure, thin and lean, Ice, Business in cement, hair. Sanitary/sewerage dept.; or electricity dept, in a municipality/corporation etc. Devastating storm, Disease in the chest/breast specifically puss in any part of the breast. Broken rib, Electronic dept`,
    kpPathogenicEffects: `The fluid attacked by severe fever`
  },
  {
    id: 196,
    rashiIndex: 9,
    rashi: 'Capricorn',
    kpRashiBodyParts: `KNEES, BONES & JOINTS`,
    kpSubBodyParts: `Acetabulum - The large cup shaped cavity in which the head of the femur articulates`,
    nakshatraIndex: 21,
    nakshatra: 'Shravana',
    pada: '1',
    startsAt: `11°06'40"`,
    endsAt: `11°53'20"`,
    sign: 'Saturn',
    star: 'Moon',
    sub: 'Mars',
    profession: ``,
    character: ``,
    epilogue: `Muscular, Susceptible to accidents/injuries when moving in a vehicle, Wool dealer, emaciation of the muscles of the knee cap. Blood poisoning/clotting in the heart etc. Agriculture, tea estates, intoxicating liquids. Popular, Military/Police, dealer in second hand goods, bicycles. Gains from lands and estates and also from transport. Boring equipment. Agricultural implements. Deficiency of red blood corpuscles. Success in litigation/examination. This 10th sign being movable popular, minister, building contractor, railways, estate broker. This earthy sign makes the native move only when that act would give him some benefit otherwise not. Partner, may be working girl. Hire/purchase of furniture etc.`,
    kpPathogenicEffects: `Pain at the hip joints`
  },
  {
    id: 197,
    rashiIndex: 9,
    rashi: 'Capricorn',
    kpRashiBodyParts: `KNEES, BONES & JOINTS`,
    kpSubBodyParts: `Sacrum - The lower bone of the Vertebrae`,
    nakshatraIndex: 21,
    nakshatra: 'Shravana',
    pada: '1-2',
    startsAt: `11°53'20"`,
    endsAt: `13°53'20"`,
    sign: 'Saturn',
    star: 'Moon',
    sub: 'Rahu',
    profession: ``,
    character: ``,
    epilogue: `The same rule for nodes should apply here. Delayed ambition. Disappointed mind and pessimist. Confused, Service in Jail dept`,
    kpPathogenicEffects: `Pain and swelling at the anus piles`
  },
  {
    id: 198,
    rashiIndex: 9,
    rashi: 'Capricorn',
    kpRashiBodyParts: `KNEES, BONES & JOINTS`,
    kpSubBodyParts: `Ilium - The hip bone`,
    nakshatraIndex: 21,
    nakshatra: 'Shravana',
    pada: '2',
    startsAt: `13°53'20"`,
    endsAt: `15°40'00"`,
    sign: 'Saturn',
    star: 'Moon',
    sub: 'Jupiter',
    profession: ``,
    character: ``,
    epilogue: `1,2,7 and 3 and 12 are the houses shown by this combination. Repayment of loan, dangerous life leading, loss to the native and gain to the partner, Partner in danger and sick. Frequent tours/short journeys or changing of the house, Loss of prestige. Pujari in a Mandir/ Mosque or Gurudwara/ Church Eminent judge, educationist, propagandist, publicity officer. Religious head.  Revenue Department dealing with death/estate duty etc. if JUPITER is the significator of 6th cusp, if 6th cusp falls here, then Cancer in the lung.`,
    kpPathogenicEffects: `Pain at the hip joints`
  },
  {
    id: 199,
    rashiIndex: 9,
    rashi: 'Capricorn',
    kpRashiBodyParts: `KNEES, BONES & JOINTS`,
    kpSubBodyParts: `Temporal Condyle - The upper portion of the ankle`,
    nakshatraIndex: 21,
    nakshatra: 'Shravana',
    pada: '2',
    startsAt: `15°40'00"`,
    endsAt: `17°46'40"`,
    sign: 'Saturn',
    star: 'Moon',
    sub: 'Saturn',
    profession: ``,
    character: ``,
    epilogue: `Deadly Saturn and Moon combination, as MOON is lord of 7 and SATURN gives life as well as is prepared to take it out also being lord of 1 and 2. Thin and lean, a bony structure Secretive and depressed mind, timid and distressed partner. Short life, Separation from the partner. Puss in the lung, injuries to knee or breast, emaciation of liquid in bones. Profuse hair growth on the head and breast`,
    kpPathogenicEffects: `Shooting pain at the ankles`
  },
  {
    id: 200,
    rashiIndex: 9,
    rashi: 'Capricorn',
    kpRashiBodyParts: `KNEES, BONES & JOINTS`,
    kpSubBodyParts: `Vertebral joints - The joints of the vertebral column`,
    nakshatraIndex: 21,
    nakshatra: 'Shravana',
    pada: '2-3',
    startsAt: `17°46'40"`,
    endsAt: `19°40'00"`,
    sign: 'Saturn',
    star: 'Moon',
    sub: 'Mercury',
    profession: ``,
    character: ``,
    epilogue: `Coarse varieties of cloth merchant, accountant in agricultural dept. Sanitary engineer. Wavering mind, depressed mind. Tall gains from foreigner, father, wive's younger brother. Writer of secret novels, weak nervous system. Bookseller, talkative, collation of secret information. Shuns crowd, Chronic mental case, only if MERCURY is a significator of 6th cusp`,
    kpPathogenicEffects: `Complications in the vertebral joints`
  },
  {
    id: 201,
    rashiIndex: 9,
    rashi: 'Capricorn',
    kpRashiBodyParts: `KNEES, BONES & JOINTS`,
    kpSubBodyParts: `Discs in the vertebrae - The disc lying in between each vertebrae`,
    nakshatraIndex: 21,
    nakshatra: 'Shravana',
    pada: '3',
    startsAt: `19°40'00"`,
    endsAt: `20°46'40"`,
    sign: 'Saturn',
    star: 'Moon',
    sub: 'Ketu',
    profession: ``,
    character: ``,
    epilogue: `As per the rule applicable to nodes. Infantile death`,
    kpPathogenicEffects: `Cracking and thinning of the dises`
  },
  {
    id: 202,
    rashiIndex: 9,
    rashi: 'Capricorn',
    kpRashiBodyParts: `KNEES, BONES & JOINTS`,
    kpSubBodyParts: `Manubrium - The tender bone above the sternum`,
    nakshatraIndex: 21,
    nakshatra: 'Shravana',
    pada: '3-4',
    startsAt: `20°46'40"`,
    endsAt: `22°40'00"`,
    sign: 'Saturn',
    star: 'Moon',
    sub: 'Venus',
    profession: ``,
    character: ``,
    epilogue: `Speculative mind, Exchange broker, Beautiful eyes deep-set, profuse hair growth on eyes, head and breast, Petrol, oil, excavation. Business in cement, metal dealer. Soap, skin, hide dealer. Sexually loose. Happy, popular, musician, etc.`,
    kpPathogenicEffects: `Swelling and pain above the sternum`
  },
  {
    id: 203,
    rashiIndex: 9,
    rashi: 'Capricorn',
    kpRashiBodyParts: `KNEES, BONES & JOINTS`,
    kpSubBodyParts: `Lumbar Vertebrae - The Vertebrae at the lumbar region`,
    nakshatraIndex: 21,
    nakshatra: 'Shravana',
    pada: '4',
    startsAt: `22°40'00"`,
    endsAt: `23°20'00"`,
    sign: 'Saturn',
    star: 'Moon',
    sub: 'Sun',
    profession: ``,
    character: ``,
    epilogue: `Short life, heart attack, eosinophilia, chronic headache, injury to knees and puss formed therein. Ever with obstacles danger to life. Slow and steady, Position of trust. Business in partnership`,
    kpPathogenicEffects: `Burning and cracking pain at the centre of the back`
  },
  {
    id: 204,
    rashiIndex: 9,
    rashi: 'Capricorn',
    kpRashiBodyParts: `KNEES, BONES & JOINTS`,
    kpSubBodyParts: `Acetabulum - The large cup shaped cavity in which the head of the femur articulates`,
    nakshatraIndex: 22,
    nakshatra: 'Dhanishtha',
    pada: '1',
    startsAt: `23°20'00"`,
    endsAt: `24°06'40"`,
    sign: 'Saturn',
    star: 'Mars',
    sub: 'Mars',
    profession: ``,
    character: ``,
    epilogue: `Muscular body but thin and lean. Thief if lagna falls here but Police to catch the thief if SUN is also connected and the 6th / 10th cusp falls here. Repairer of old/ancient goods. Gains from land property and machinery parts. Death by attack from thief/dacoit etc. using sharp weapons etc. Dealer/manufacturer of weapons. Agricultural equipment implements. Geologist, farmer, owner of landed property. Labour on the farm. Sanitary attachment to the house. Fertilizer, success in agriculture acquisition of landed property, and gain there form. Success in education, examinations also (4&11). Danger to your vehicle. Tractor / leveller, injury to knee, deficiency of red blood corpuscles`,
    kpPathogenicEffects: `Pain at the hip joints`
  },
  {
    id: 205,
    rashiIndex: 9,
    rashi: 'Capricorn',
    kpRashiBodyParts: `KNEES, BONES & JOINTS`,
    kpSubBodyParts: `Sacrum - The lower bones of the vertebrae`,
    nakshatraIndex: 22,
    nakshatra: 'Dhanishtha',
    pada: '1',
    startsAt: `24°06'40"`,
    endsAt: `26°06'40"`,
    sign: 'Saturn',
    star: 'Mars',
    sub: 'Rahu',
    profession: ``,
    character: ``,
    epilogue: `As per the rules of nodes, jail department for thieves and dacoits and law breakers`,
    kpPathogenicEffects: `Pain and swelling at the anus piles`
  },
  {
    id: 206,
    rashiIndex: 9,
    rashi: 'Capricorn',
    kpRashiBodyParts: `KNEES, BONES & JOINTS`,
    kpSubBodyParts: `Sternum - The tender bone at the anterior portion of chest`,
    nakshatraIndex: 22,
    nakshatra: 'Dhanishtha',
    pada: '1-2',
    startsAt: `26°06'40"`,
    endsAt: `27°53'20"`,
    sign: 'Saturn',
    star: 'Mars',
    sub: 'Jupiter',
    profession: ``,
    character: ``,
    epilogue: `Ever changing his permanent residence. Principal / Headmaster. Philosopher of name, fame and reputation. Department of Finance. Head of Police/ Military/ Finance Department, Religious endowment. Education Department Expenditure on younger brother. Acquisition of landed property, house, old furniture etc. If 6th cusp falls here then manufacturer/dealer in these goods. Old and repaired goods dealer`,
    kpPathogenicEffects: `Tumour and swelling at the front of the chest`
  },
  {
    id: 207,
    rashiIndex: 9,
    rashi: 'Capricorn',
    kpRashiBodyParts: `KNEES, BONES & JOINTS`,
    kpSubBodyParts: `Scapula - The shoulder blade`,
    nakshatraIndex: 22,
    nakshatra: 'Dhanishtha',
    pada: '2',
    startsAt: `27°53'20"`,
    endsAt: `30°00'00"`,
    sign: 'Saturn',
    star: 'Mars',
    sub: 'Saturn',
    profession: ``,
    character: ``,
    epilogue: `Weapons of stone age. Ancient and old weapon. Arms/Ammunition dealer or manufacturer. Liar, Thief/dacoit. Knows no law arid quarrelsome. Deals in lands and estates. Old hand goods or machinery dealer, Thin and lean but stout and muscular body Liar secretive will not give his opinion. Successful in disputes`,
    kpPathogenicEffects: `Chronic shoulder pain`
  },
  {
    id: 208,
    rashiIndex: 10,
    rashi: 'Aquarius',
    kpRashiBodyParts: `External (Legs, Skin Ankles) Blood Circulation`,
    kpSubBodyParts: `The network of veins (The veins that carry impure blood to the heart`,
    nakshatraIndex: 22,
    nakshatra: 'Dhanishtha',
    pada: '2',
    startsAt: `00°00'00"`,
    endsAt: `01°53'20"`,
    sign: 'Saturn',
    star: 'Mars',
    sub: 'Mercury',
    profession: ``,
    character: ``,
    epilogue: `Running pains in different part of the body, arthritis, rheumatism, disorder in the bowels. Mechanical Engineer, Mines Engineer. Industrialist, Death Registrar`,
    kpPathogenicEffects: `The bleeding from the veins`
  },
  {
    id: 209,
    rashiIndex: 10,
    rashi: 'Aquarius',
    kpRashiBodyParts: `External (Legs, Skin Ankles) Blood Circulation`,
    kpSubBodyParts: `Blood circulation in Bowels`,
    nakshatraIndex: 22,
    nakshatra: 'Dhanishtha',
    pada: '2-3',
    startsAt: `01°53'20"`,
    endsAt: `02°40'00"`,
    sign: 'Saturn',
    star: 'Mars',
    sub: 'Ketu',
    profession: ``,
    character: ``,
    epilogue: `Find out the position of Ketu and Accordingly read`,
    kpPathogenicEffects: `Failure of bowels. Bowels do not move freely`
  },
  {
    id: 210,
    rashiIndex: 10,
    rashi: 'Aquarius',
    kpRashiBodyParts: `External (Legs, Skin Ankles) Blood Circulation`,
    kpSubBodyParts: `Blood circulation in kidney`,
    nakshatraIndex: 22,
    nakshatra: 'Dhanishtha',
    pada: '3',
    startsAt: `02°40'00"`,
    endsAt: `04°53'20"`,
    sign: 'Saturn',
    star: 'Mars',
    sub: 'Venus',
    profession: ``,
    character: ``,
    epilogue: `Pains and swellings in the legs, knees, heart also afflicted. Deals in skins and hides, manufacturer of shoes. Dealer in Antiques, Archaeology`,
    kpPathogenicEffects: `Kidney trouble`
  },
  {
    id: 211,
    rashiIndex: 10,
    rashi: 'Aquarius',
    kpRashiBodyParts: `External (Legs, Skin Ankles) Blood Circulation`,
    kpSubBodyParts: `Malleolus - Protuberance on either side of the ankle joint (a bony projection with a shape likened to a hammer head, especially each of those on either side of the ankle)`,
    nakshatraIndex: 22,
    nakshatra: 'Dhanishtha',
    pada: '3-4',
    startsAt: `04°53'20"`,
    endsAt: `05°33'20"`,
    sign: 'Saturn',
    star: 'Mars',
    sub: 'Sun',
    profession: ``,
    character: ``,
    epilogue: `Blood inflamed, rains, disorder, Gravel, Stone, Strangury, Geology, Mine, Defence Department, disposes the dead`,
    kpPathogenicEffects: `Inflammation in the ankle joint`
  },
  {
    id: 212,
    rashiIndex: 10,
    rashi: 'Aquarius',
    kpRashiBodyParts: `External (Legs, Skin Ankles) Blood Circulation`,
    kpSubBodyParts: `Aorta - The main trunk from which the arterial system proceeds`,
    nakshatraIndex: 22,
    nakshatra: 'Dhanishtha',
    pada: '4',
    startsAt: `05°33'20"`,
    endsAt: `06°40'20"`,
    sign: 'Saturn',
    star: 'Mars',
    sub: 'Moon',
    profession: ``,
    character: ``,
    epilogue: `Hysteria, boils, swellings, pain in the legs and also in secret parts. Excavation of wells, tanks, tunnels, pumpsets, dealing liquids`,
    kpPathogenicEffects: `Complications in the aorta`
  },
  {
    id: 213,
    rashiIndex: 10,
    rashi: 'Aquarius',
    kpRashiBodyParts: `External (Legs, Skin Ankles) Blood Circulation`,
    kpSubBodyParts: `Blood circulation in arms`,
    nakshatraIndex: 23,
    nakshatra: 'Shatabhisha',
    pada: '1',
    startsAt: `06°40'20"`,
    endsAt: `08°40'00"`,
    sign: 'Saturn',
    star: 'Rahu',
    sub: 'Rahu',
    profession: ``,
    character: ``,
    epilogue: `Note down the houses signified by Rahu and the planet with which it is connected. Accordingly, you have to read the results for 6 degrees 40 minutes to 20 degrees, in Aquarius. Refer to Arudra star in Gemini and you can predict like that for each sub in Rahu Star (Sathabisha in Aquarius)`,
    kpPathogenicEffects: `Weak and slender arms`
  },
  {
    id: 214,
    rashiIndex: 10,
    rashi: 'Aquarius',
    kpRashiBodyParts: `External (Legs, Skin Ankles) Blood Circulation`,
    kpSubBodyParts: `Blood circulation in chest`,
    nakshatraIndex: 23,
    nakshatra: 'Shatabhisha',
    pada: '1',
    startsAt: `08°40'00"`,
    endsAt: `10°26'40"`,
    sign: 'Saturn',
    star: 'Rahu',
    sub: 'Jupiter',
    profession: ``,
    character: ``,
    epilogue: `Note down the houses signified by Rahu and the planet with which it is connected. Accordingly, you have to read the results for 6 degrees 40 minutes to 20 degrees, in Aquarius. Refer to Arudra star in Gemini and you can predict like that for each sub in Rahu Star (Sathabisha in Aquarius)`,
    kpPathogenicEffects: `Suffocations - Asthma T.B.`
  },
  {
    id: 215,
    rashiIndex: 10,
    rashi: 'Aquarius',
    kpRashiBodyParts: `External (Legs, Skin Ankles) Blood Circulation`,
    kpSubBodyParts: `Upper fibula - The upper and smaller bones of the leg`,
    nakshatraIndex: 23,
    nakshatra: 'Shatabhisha',
    pada: '1-2',
    startsAt: `10°26'40"`,
    endsAt: `12°33'20"`,
    sign: 'Saturn',
    star: 'Rahu',
    sub: 'Saturn',
    profession: ``,
    character: ``,
    epilogue: `Note down the houses signified by Rahu and the planet with which it is connected. Accordingly, you have to read the results for 6 degrees 40 minutes to 20 degrees, in Aquarius. Refer to Arudra star in Gemini and you can predict like that for each sub in Rahu Star (Sathabisha in Aquarius)`,
    kpPathogenicEffects: `Chronic pain in the fibula`
  },
  {
    id: 216,
    rashiIndex: 10,
    rashi: 'Aquarius',
    kpRashiBodyParts: `External (Legs, Skin Ankles) Blood Circulation`,
    kpSubBodyParts: `The network of veins (The veins that carry impure blood to the heart`,
    nakshatraIndex: 23,
    nakshatra: 'Shatabhisha',
    pada: '2',
    startsAt: `12°33'20"`,
    endsAt: `14°26'40"`,
    sign: 'Saturn',
    star: 'Rahu',
    sub: 'Mercury',
    profession: ``,
    character: ``,
    epilogue: `Note down the houses signified by Rahu and the planet with which it is connected. Accordingly, you have to read the results for 6 degrees 40 minutes to 20 degrees, in Aquarius. Refer to Arudra star in Gemini and you can predict like that for each sub in Rahu Star (Sathabisha in Aquarius)`,
    kpPathogenicEffects: `Bleedings from veins`
  },
  {
    id: 217,
    rashiIndex: 10,
    rashi: 'Aquarius',
    kpRashiBodyParts: `External (Legs, Skin Ankles) Blood Circulation`,
    kpSubBodyParts: `Blood circulation in Anus & Rectum`,
    nakshatraIndex: 23,
    nakshatra: 'Shatabhisha',
    pada: '2',
    startsAt: `14°26'40"`,
    endsAt: `15°13'20"`,
    sign: 'Saturn',
    star: 'Rahu',
    sub: 'Ketu',
    profession: ``,
    character: ``,
    epilogue: `Note down the houses signified by Rahu and the planet with which it is connected. Accordingly, you have to read the results for 6 degrees 40 minutes to 20 degrees, in Aquarius. Refer to Arudra star in Gemini and you can predict like that for each sub in Rahu Star (Sathabisha in Aquarius)`,
    kpPathogenicEffects: `Bleeding during motion`
  },
  {
    id: 218,
    rashiIndex: 10,
    rashi: 'Aquarius',
    kpRashiBodyParts: `External (Legs, Skin Ankles) Blood Circulation`,
    kpSubBodyParts: `Blood circulation in Sexual organs`,
    nakshatraIndex: 23,
    nakshatra: 'Shatabhisha',
    pada: '2-3',
    startsAt: `15°13'20"`,
    endsAt: `17°26'40"`,
    sign: 'Saturn',
    star: 'Rahu',
    sub: 'Venus',
    profession: ``,
    character: ``,
    epilogue: `Note down the houses signified by Rahu and the planet with which it is connected. Accordingly, you have to read the results for 6 degrees 40 minutes to 20 degrees, in Aquarius. Refer to Arudra star in Gemini and you can predict like that for each sub in Rahu Star (Sathabisha in Aquarius)`,
    kpPathogenicEffects: `Bleeding during urination and sexual disorders`
  },
  {
    id: 219,
    rashiIndex: 10,
    rashi: 'Aquarius',
    kpRashiBodyParts: `External (Legs, Skin Ankles) Blood Circulation`,
    kpSubBodyParts: `Malleolus - Protuberance on either side of the ankle joint`,
    nakshatraIndex: 23,
    nakshatra: 'Shatabhisha',
    pada: '3',
    startsAt: `17°26'40"`,
    endsAt: `18°06'40"`,
    sign: 'Saturn',
    star: 'Rahu',
    sub: 'Sun',
    profession: ``,
    character: ``,
    epilogue: `Note down the houses signified by Rahu and the planet with which it is connected. Accordingly, you have to read the results for 6 degrees 40 minutes to 20 degrees, in Aquarius. Refer to Arudra star in Gemini and you can predict like that for each sub in Rahu Star (Sathabisha in Aquarius)`,
    kpPathogenicEffects: `Inflammation in these region`
  },
  {
    id: 220,
    rashiIndex: 10,
    rashi: 'Aquarius',
    kpRashiBodyParts: `External (Legs, Skin Ankles) Blood Circulation`,
    kpSubBodyParts: `Aorta - The main trunk from which the anterial system proceeds`,
    nakshatraIndex: 23,
    nakshatra: 'Shatabhisha',
    pada: '3-4',
    startsAt: `18°06'40"`,
    endsAt: `19°13'20"`,
    sign: 'Saturn',
    star: 'Rahu',
    sub: 'Moon',
    profession: ``,
    character: ``,
    epilogue: `Note down the houses signified by Rahu and the planet with which it is connected. Accordingly, you have to read the results for 6 degrees 40 minutes to 20 degrees, in Aquarius. Refer to Arudra star in Gemini and you can predict like that for each sub in Rahu Star (Sathabisha in Aquarius)`,
    kpPathogenicEffects: `Complications in the arota`
  },
  {
    id: 221,
    rashiIndex: 10,
    rashi: 'Aquarius',
    kpRashiBodyParts: `External (Legs, Skin Ankles) Blood Circulation`,
    kpSubBodyParts: `The flow of blood`,
    nakshatraIndex: 23,
    nakshatra: 'Shatabhisha',
    pada: '4',
    startsAt: `19°13'20"`,
    endsAt: `20°00'00"`,
    sign: 'Saturn',
    star: 'Rahu',
    sub: 'Mars',
    profession: ``,
    character: ``,
    epilogue: `Note down the houses signified by Rahu and the planet with which it is connected. Accordingly, you have to read the results for 6 degrees 40 minutes to 20 degrees, in Aquarius. Refer to Arudra star in Gemini and you can predict like that for each sub in Rahu Star (Sathabisha in Aquarius)`,
    kpPathogenicEffects: `High and sudden fever`
  },
  {
    id: 222,
    rashiIndex: 10,
    rashi: 'Aquarius',
    kpRashiBodyParts: `External (Legs, Skin Ankles) Blood Circulation`,
    kpSubBodyParts: `Blood circulation in the legs`,
    nakshatraIndex: 24,
    nakshatra: 'PurvaBhadrapada',
    pada: '1',
    startsAt: `20°00'00"`,
    endsAt: `21°46'40"`,
    sign: 'Saturn',
    star: 'Jupiter',
    sub: 'Jupiter',
    profession: ``,
    character: ``,
    epilogue: `Much of blood in the body and corrupt one, many diseases, Lumbago, hip pains. Philosopher, religion, teacher, banker, advocate, postmortem, Surgeon`,
    kpPathogenicEffects: `Pain and swelling in the legs`
  },
  {
    id: 223,
    rashiIndex: 10,
    rashi: 'Aquarius',
    kpRashiBodyParts: `External (Legs, Skin Ankles) Blood Circulation`,
    kpSubBodyParts: `Upper tibia - The outer longer bone Of the leg below the knee`,
    nakshatraIndex: 24,
    nakshatra: 'PurvaBhadrapada',
    pada: '1',
    startsAt: `21°46'40"`,
    endsAt: `23°53'20"`,
    sign: 'Saturn',
    star: 'Jupiter',
    sub: 'Saturn',
    profession: ``,
    character: ``,
    epilogue: `Saturn, Jupiter, Saturn: (21-46-40)-(23-53-20). Disorder in the head and teeth, defect in the ear, pains in the joints, swelling in the leg, bruises, sore-throat. Service, no independent business, college, Law Court, Schools, night school`,
    kpPathogenicEffects: `Chronic pain in the upper Tibia`
  },
  {
    id: 224,
    rashiIndex: 10,
    rashi: 'Aquarius',
    kpRashiBodyParts: `External (Legs, Skin Ankles) Blood Circulation`,
    kpSubBodyParts: `Blood circulation in the vertebrae`,
    nakshatraIndex: 24,
    nakshatra: 'PurvaBhadrapada',
    pada: '1-2',
    startsAt: `23°53'20"`,
    endsAt: `25°46'40"`,
    sign: 'Saturn',
    star: 'Jupiter',
    sub: 'Mercury',
    profession: ``,
    character: ``,
    epilogue: `Windy, pain In the body, daily changing from one place to the other, imaginative pain, upset of the digestive system. Journalist, Novelist, Editor and Publisher, Bank Agent, Estate Broker, Consultant`,
    kpPathogenicEffects: `Shooting and severe pain in the back`
  },
  {
    id: 225,
    rashiIndex: 10,
    rashi: 'Aquarius',
    kpRashiBodyParts: `External (Legs, Skin Ankles) Blood Circulation`,
    kpSubBodyParts: `Blood circulation in the Bowels`,
    nakshatraIndex: 24,
    nakshatra: 'PurvaBhadrapada',
    pada: '2',
    startsAt: `25°46'40"`,
    endsAt: `26°33'20"`,
    sign: 'Saturn',
    star: 'Jupiter',
    sub: 'Ketu',
    profession: ``,
    character: ``,
    epilogue: `Note down the position of Ketu and Accordingly predict`,
    kpPathogenicEffects: `Bowels disorders`
  },
  {
    id: 226,
    rashiIndex: 10,
    rashi: 'Aquarius',
    kpRashiBodyParts: `External (Legs, Skin Ankles) Blood Circulation`,
    kpSubBodyParts: `Blood circulation in Kidney`,
    nakshatraIndex: 24,
    nakshatra: 'PurvaBhadrapada',
    pada: '2',
    startsAt: `26°33'20"`,
    endsAt: `28°46'40"`,
    sign: 'Saturn',
    star: 'Jupiter',
    sub: 'Venus',
    profession: ``,
    character: ``,
    epilogue: `Due to excess, indigestion, pains, flatulence, appendicitis, also heart afflicted. Legal Adviser, Judge, Girls School, Drama, Cinema, Music`,
    kpPathogenicEffects: `Kidney troubles`
  },
  {
    id: 227,
    rashiIndex: 10,
    rashi: 'Aquarius',
    kpRashiBodyParts: `External (Legs, Skin Ankles) Blood Circulation`,
    kpSubBodyParts: `Condyle - The rounded portion of the ankle`,
    nakshatraIndex: 24,
    nakshatra: 'PurvaBhadrapada',
    pada: '2-3',
    startsAt: `28°46'40"`,
    endsAt: `29°26'40"`,
    sign: 'Saturn',
    star: 'Jupiter',
    sub: 'Sun',
    profession: ``,
    character: ``,
    epilogue: `Enlarged heart, palpitation, low blood pressure, gravel, physician,  Government Service, Inspector, Education Department, Legal, Steady income`,
    kpPathogenicEffects: `Inflammation of the cordyle`
  },
  {
    id: 228,
    rashiIndex: 10,
    rashi: 'Aquarius',
    kpRashiBodyParts: `External (Legs, Skin Ankles) Blood Circulation`,
    kpSubBodyParts: `Blood circulation in Head`,
    nakshatraIndex: 24,
    nakshatra: 'PurvaBhadrapada',
    pada: '3',
    startsAt: `29°26'40"`,
    endsAt: `30°00'00"`,
    sign: 'Saturn',
    star: 'Jupiter',
    sub: 'Moon',
    profession: ``,
    character: ``,
    epilogue: `Epilepsy hysterical trouble, fits, lumbago, dull pain in the lower abdominal region, irregular menstrual complain. Politics, service in Bank, Orator, fond of travels, constant change, roaming about, love / romance`,
    kpPathogenicEffects: `Headache, Vomitting fever etc`
  },
  {
    id: 229,
    rashiIndex: 11,
    rashi: 'Pisces',
    kpRashiBodyParts: `Bones of Feet & Toes Nymphatic System`,
    kpSubBodyParts: `Navicular - Boat shaped bone in the foot`,
    nakshatraIndex: 24,
    nakshatra: 'PurvaBhadrapada',
    pada: '3-4',
    startsAt: `00°00'00"`,
    endsAt: `00°33'20"`,
    sign: 'Jupiter',
    star: 'Jupiter',
    sub: 'Moon',
    profession: ``,
    character: ``,
    epilogue: `Fair complexion, courteous disposition, Ever changing habits, unsteady, tries to lead a peaceful life, affable, hospitable, tries to avoid anxiety, reliable people, medium stature, fleshy face, full eyes, hair dark brown to black, passionate, mysterious in their way of doing things, love music scenery, like occupation that bring some kind of change or where attention to details and completeness is necessary, works in gardens, clothing, deals in fish, milk, etc., marine navy, (if Mars connected) liver trouble, tumor in abdomen, intestine overworks etc.`,
    kpPathogenicEffects: `Pain and swelling of the foot`
  },
  {
    id: 230,
    rashiIndex: 11,
    rashi: 'Pisces',
    kpRashiBodyParts: `Bones of Feet & Toes Nymphatic System`,
    kpSubBodyParts: `The Thymus - The lymphatic gland that lies in the upper part of the chest behind the breast bone. Its function is to resist the diseases attacking the body`,
    nakshatraIndex: 24,
    nakshatra: 'PurvaBhadrapada',
    pada: '4',
    startsAt: `00°33'20"`,
    endsAt: `01°20'00"`,
    sign: 'Jupiter',
    star: 'Jupiter',
    sub: 'Mars',
    profession: ``,
    character: ``,
    epilogue: `Bold, emotional, good health, Independent, Married life may be short (if Venus and Saturn are badly placed.) . Quick in understanding, inspirational, Independent auditors, ministers, judges, advocates, administrators, etc.`,
    kpPathogenicEffects: `Pain and swelling in the Thymus(small, irregular-shaped gland in the top part of the chest, just under the breastbone and between the lungs)`
  },
  {
    id: 231,
    rashiIndex: 11,
    rashi: 'Pisces',
    kpRashiBodyParts: `Bones of Feet & Toes Nymphatic System`,
    kpSubBodyParts: `Cuboid - The cubular shaped bone in the feet`,
    nakshatraIndex: 24,
    nakshatra: 'PurvaBhadrapada',
    pada: '4',
    startsAt: `01°20'00"`,
    endsAt: `03°20'00"`,
    sign: 'Jupiter',
    star: 'Jupiter',
    sub: 'Rahu',
    profession: ``,
    character: ``,
    epilogue: `Predict as, per the position of RAHU.`,
    kpPathogenicEffects: `Pain and swelling of the Foot Complications`
  },
  {
    id: 232,
    rashiIndex: 11,
    rashi: 'Pisces',
    kpRashiBodyParts: `Bones of Feet & Toes Nymphatic System`,
    kpSubBodyParts: `Talus - The ankle`,
    nakshatraIndex: 25,
    nakshatra: 'UttaraBhadrapada',
    pada: '1',
    startsAt: `03°20'00"`,
    endsAt: `05°26'40"`,
    sign: 'Jupiter',
    star: 'Saturn',
    sub: 'Saturn',
    profession: ``,
    character: ``,
    epilogue: `Imaginative, reserved nature, anxious, patient discontentment, economical, deals in corns, rich person`,
    kpPathogenicEffects: `Chronic pain in the ankle. Mostly shoe wearing persons are affected`
  },
  {
    id: 233,
    rashiIndex: 11,
    rashi: 'Pisces',
    kpRashiBodyParts: `Bones of Feet & Toes Nymphatic System`,
    kpSubBodyParts: `Tarsus - The plate between foot & leg`,
    nakshatraIndex: 25,
    nakshatra: 'UttaraBhadrapada',
    pada: '1',
    startsAt: `05°26'40"`,
    endsAt: `07°20'00"`,
    sign: 'Jupiter',
    star: 'Saturn',
    sub: 'Mercury',
    profession: ``,
    character: ``,
    epilogue: `Stature more than average, medium complexion, imaginative, hospitable, intelligent, studious, learns without any instructor, traveller, mathematician, learn occult sciences, respects others, married life unhappy, often marries twice as first marriage ends in divorce, suffers from malaria, round worms, hook worms, works as engineer, accountant in mines, statistics`,
    kpPathogenicEffects: `Pain and swelling at the - leg joints`
  },
  {
    id: 234,
    rashiIndex: 11,
    rashi: 'Pisces',
    kpRashiBodyParts: `Bones of Feet & Toes Nymphatic System`,
    kpSubBodyParts: `Calcaneus - The irregular, quadranglular bone at the back of the Tarsus`,
    nakshatraIndex: 25,
    nakshatra: 'UttaraBhadrapada',
    pada: '1-2',
    startsAt: `07°20'00"`,
    endsAt: `08°06'40"`,
    sign: 'Jupiter',
    star: 'Saturn',
    sub: 'Ketu',
    profession: ``,
    character: ``,
    epilogue: `Predict as per the position of ketu`,
    kpPathogenicEffects: `Pain and swelling of the heel bone`
  },
  {
    id: 235,
    rashiIndex: 11,
    rashi: 'Pisces',
    kpRashiBodyParts: `Bones of Feet & Toes Nymphatic System`,
    kpSubBodyParts: `Tibia - The inner and longer bone af the leg below the knee`,
    nakshatraIndex: 25,
    nakshatra: 'UttaraBhadrapada',
    pada: '2',
    startsAt: `08°06'40"`,
    endsAt: `10°20'00"`,
    sign: 'Jupiter',
    star: 'Saturn',
    sub: 'Venus',
    profession: ``,
    character: ``,
    epilogue: `Diplomatic, selfish, chronic sufferers, damage to internal parts, works on administrative side in oil companies, petrol pump (if Mars is connected), disinfectants, condensers (if Moon connected)`,
    kpPathogenicEffects: `Pain and swelling of the tibia`
  },
  {
    id: 236,
    rashiIndex: 11,
    rashi: 'Pisces',
    kpRashiBodyParts: `Bones of Feet & Toes Nymphatic System`,
    kpSubBodyParts: `Fibula - The outer and smaller bones of the leg`,
    nakshatraIndex: 25,
    nakshatra: 'UttaraBhadrapada',
    pada: '2',
    startsAt: `10°20'00"`,
    endsAt: `11°00'00"`,
    sign: 'Jupiter',
    star: 'Saturn',
    sub: 'Sun',
    profession: ``,
    character: ``,
    epilogue: `Liberal, proud and generous, fond of jewels, works in government in any capacity like magistrate, goldsmith, mint etc. Suffers from Sunstroke, Rehabilitation`,
    kpPathogenicEffects: `Pain and swelling of the fibula - Burning sensation`
  },
  {
    id: 237,
    rashiIndex: 11,
    rashi: 'Pisces',
    kpRashiBodyParts: `Bones of Feet & Toes Nymphatic System`,
    kpSubBodyParts: `Navicular - Boat shaped bone in the foot`,
    nakshatraIndex: 25,
    nakshatra: 'UttaraBhadrapada',
    pada: '2-3',
    startsAt: `11°00'00"`,
    endsAt: `12°06'40"`,
    sign: 'Jupiter',
    star: 'Saturn',
    sub: 'Moon',
    profession: ``,
    character: ``,
    epilogue: `Pale complexion, reserved person, cool temper, wavery and vacillating, obstruction of lymphatic circulation. (If Saturn and moon connected unfavourably) intestinal defects and diseases, varicose veins, constipation, complication due to excess of drinks, works as a mechanical engineer in water works, sewerage, sanitary inspector, deals in Kerosene, agriculturists, preacher of oil ideas, follower of tradition, serves in museum, stadium`,
    kpPathogenicEffects: `Pain and swelling of the navicular bone`
  },
  {
    id: 238,
    rashiIndex: 11,
    rashi: 'Pisces',
    kpRashiBodyParts: `Bones of Feet & Toes Nymphatic System`,
    kpSubBodyParts: `MetaTarsus - The part of the foot between the Tarsus and the toes`,
    nakshatraIndex: 25,
    nakshatra: 'UttaraBhadrapada',
    pada: '3',
    startsAt: `12°06'40"`,
    endsAt: `12°53'20"`,
    sign: 'Jupiter',
    star: 'Saturn',
    sub: 'Mars',
    profession: ``,
    character: ``,
    epilogue: `White complexion with a red shade, muscular, bold and courageous but not rash, impulsive or aggressive, patient, endurance, healthy, suffer from smallpox. (If mars/Saturn connected badly). One commits murder due to some provocation, ulcers in the intestines, hernia, appendicitis, mines, mine ores, leather, works as an engineer in Mines, mason, engravers, surveyors`,
    kpPathogenicEffects: `Sudden and shooting pain at the metatarsus`
  },
  {
    id: 239,
    rashiIndex: 11,
    rashi: 'Pisces',
    kpRashiBodyParts: `Bones of Feet & Toes Nymphatic System`,
    kpSubBodyParts: `Cuboid - The cubular shaped bone in the feet`,
    nakshatraIndex: 25,
    nakshatra: 'UttaraBhadrapada',
    pada: '3-4',
    startsAt: `12°53'20"`,
    endsAt: `14°53'20"`,
    sign: 'Jupiter',
    star: 'Saturn',
    sub: 'Rahu',
    profession: ``,
    character: ``,
    epilogue: `Predict as per the placement to Rahu`,
    kpPathogenicEffects: `Pain and swelling of the foot`
  },
  {
    id: 240,
    rashiIndex: 11,
    rashi: 'Pisces',
    kpRashiBodyParts: `Bones of Feet & Toes Nymphatic System`,
    kpSubBodyParts: `Cuneiform - The sharp bone in the feet resembling like a canine tooth`,
    nakshatraIndex: 25,
    nakshatra: 'UttaraBhadrapada',
    pada: '4',
    startsAt: `14°53'20"`,
    endsAt: `16°40'00"`,
    sign: 'Jupiter',
    star: 'Saturn',
    sub: 'Jupiter',
    profession: ``,
    character: ``,
    epilogue: `Healthy body, (if Saturn and Jupiter are afflicted) impotent, constipation, nausea and cancer, physician, broker of landed property, service in banks, scientific laboratories, political offices,  mines owners, societies, clubs, birth control appliances, propagandists`,
    kpPathogenicEffects: `Tumour and extra growth at this region`
  },
  {
    id: 241,
    rashiIndex: 11,
    rashi: 'Pisces',
    kpRashiBodyParts: `Bones of Feet & Toes Nymphatic System`,
    kpSubBodyParts: `Phalanges - The small bones forming the toes etc`,
    nakshatraIndex: 26,
    nakshatra: 'Revati',
    pada: '1',
    startsAt: `16°40'00"`,
    endsAt: `18°33'20"`,
    sign: 'Jupiter',
    star: 'Mercury',
    sub: 'Mercury',
    profession: ``,
    character: ``,
    epilogue: `Optimistic, always in spirits, broad minded, versatile, slow in forming an opinion, but the decision is in-controversial, law, literature, contract with engineers, journalist, export, import, editing, civil engineer, mathematician, accounts, auditing, banking, good astrologer, (bad disposition of Mercury and Jupiter) brings out disputes, leading to litigation and troubles; suffers from vitamin 'B' deficiency, lack of enzymes, Dyspepsia`,
    kpPathogenicEffects: `Pain in the Toes and phalanges`
  },
  {
    id: 242,
    rashiIndex: 11,
    rashi: 'Pisces',
    kpRashiBodyParts: `Bones of Feet & Toes Nymphatic System`,
    kpSubBodyParts: `Distal Phalanges - The first bones of the toes etc`,
    nakshatraIndex: 26,
    nakshatra: 'Revati',
    pada: '1',
    startsAt: `18°33'20"`,
    endsAt: `19°20'00"`,
    sign: 'Jupiter',
    star: 'Mercury',
    sub: 'Ketu',
    profession: ``,
    character: ``,
    epilogue: `Predict as per the position of Ketu`,
    kpPathogenicEffects: `Pain and swelling at the base of the toes and phalanges`
  },
  {
    id: 243,
    rashiIndex: 11,
    rashi: 'Pisces',
    kpRashiBodyParts: `Bones of Feet & Toes Nymphatic System`,
    kpSubBodyParts: `Tibia - The inner and larger bone of the leg below the knee`,
    nakshatraIndex: 26,
    nakshatra: 'Revati',
    pada: '1-2',
    startsAt: `19°20'00"`,
    endsAt: `21°33'20"`,
    sign: 'Jupiter',
    star: 'Mercury',
    sub: 'Venus',
    profession: ``,
    character: ``,
    epilogue: `Cheerful, beautiful, handsome, many partners in business, social prestige, ever smiling, large hearted, will have many friends, liked by all, fond of fine arts and refinements, transport, deals in scented articles, painting, earns through music, radio, transistor, gramophone, jewellery, dress making, deals in rubber, opticians, stands surety for any body and never gets entangled. Affliction in the eyes, nervous disease, Hysteria, injuries may be caused by any vehicle, animals or birds governed by Venus. Cinema, Analytical chemist, Broadcasting`,
    kpPathogenicEffects: `Pain and swelling of the tibia`
  },
  {
    id: 244,
    rashiIndex: 11,
    rashi: 'Pisces',
    kpRashiBodyParts: `Bones of Feet & Toes Nymphatic System`,
    kpSubBodyParts: `Middle Phalanges - The second bones of the toes etc`,
    nakshatraIndex: 26,
    nakshatra: 'Revati',
    pada: '2',
    startsAt: `21°33'20"`,
    endsAt: `22°13'20"`,
    sign: 'Jupiter',
    star: 'Mercury',
    sub: 'Sun',
    profession: ``,
    character: ``,
    epilogue: `Generous, courteous, cheerful in nature, social, feels pleasure in easy life, fond of company of opposite sex, art, music and poetry, if Sun and Venus in conjunction are placed in 5, 7 or 9th shows wife having some disease in generative system, If Sun and Venus have adverse aspect unpleasant domestic life isindicated (depends on other aspects) eye sight, heart disease, low blood pressure if afflicted by Saturn and high blood-pressure if afflicted by Jupiter, Cardiac thrombosis, sharp fevers, typhoid, epilepsy, sunstroke, chief engineer, accountant- general, publicity officers, inclination, to study astrology, astronomy, engineering, mathematics, ambitious, studious, capable and inspiring`,
    kpPathogenicEffects: `Burning sensation at the middle phalanges`
  },
  {
    id: 245,
    rashiIndex: 11,
    rashi: 'Pisces',
    kpRashiBodyParts: `Bones of Feet & Toes Nymphatic System`,
    kpSubBodyParts: `Distal Phalanges - The first bones of the toes etc`,
    nakshatraIndex: 26,
    nakshatra: 'Revati',
    pada: '2',
    startsAt: `22°13'20"`,
    endsAt: `23°20'00"`,
    sign: 'Jupiter',
    star: 'Mercury',
    sub: 'Moon',
    profession: ``,
    character: ``,
    epilogue: `Average height, stout body hands, long and slender, dark hair with expressive eyes thin and shrill voice, often looks younger than one's age, intelligent, fertile imagination, deep feelings, emotion (if moon and mercury are having bad aspect) lack of mental balance, indecision, spreads false rumors, suffers from over anxiety, frequently changes, learns many languages, short journeys, pessimistic imagination and intuition increases with the advancement of age, speculative, upset due to troubles in nervous or digestive system, by entering into a wrong contract public criticism etc. unhappy dealings with relatives. Persons suffer from eye trouble, asthma, cold, cough, colic pains, worms, typhoid, gastric, nervous debility. Serves in shipping department, water analysis or water supply department, deals in fish, perfumes, kerosene, milk, farmers, vegetable and fruit growers, an engineer in water works, novel writings, inspectors of accounts, internal auditors`,
    kpPathogenicEffects: `Pain and swelling at the base of the toes and phalanges`
  },
  {
    id: 246,
    rashiIndex: 11,
    rashi: 'Pisces',
    kpRashiBodyParts: `Bones of Feet & Toes Nymphatic System`,
    kpSubBodyParts: `Proximal Phalanges-The third smaller bones of the toes etc at their base`,
    nakshatraIndex: 26,
    nakshatra: 'Revati',
    pada: '2-3',
    startsAt: `23°20'00"`,
    endsAt: `24°06'40"`,
    sign: 'Jupiter',
    star: 'Mercury',
    sub: 'Mars',
    profession: ``,
    character: ``,
    epilogue: `Medium stature, healthy body, round eyes, waist narrow, lover of work, completes duties assigned quickly, never lazy or lethargic, has an ability to organise, humorous, ingenious, constructive, practical and business like, great mental activity and intellectual powers, impulsive and rash, gets irritated and irritates others also, suffers from fits, epilepsy, brain disorders, piles, fissure, disputer, litigation, risky venture, hasty decision leading to public scandal and criticism (if aspects are bad); serves in the accounts or audit department; military or mechanical engineering if aspects are good, person makes fortune by quick buying and selling, by becoming a broker, bad aspects make him loose through speculation, fraud, cheating etc., adding machine. If Mars or Mercury has any connection with significator or of marriage or partner in life, disharmony and manhandling of each other are indicated, Microscope, printer, post and telegraph`,
    kpPathogenicEffects: `Sudden pain at the base of toes and phalanges`
  },
  {
    id: 247,
    rashiIndex: 11,
    rashi: 'Pisces',
    kpRashiBodyParts: `Bones of Feet & Toes Nymphatic System`,
    kpSubBodyParts: `Cuboid - The cubular shaped bone in the feet`,
    nakshatraIndex: 26,
    nakshatra: 'Revati',
    pada: '3',
    startsAt: `24°06'40"`,
    endsAt: `26°06'40"`,
    sign: 'Jupiter',
    star: 'Mercury',
    sub: 'Rahu',
    profession: ``,
    character: ``,
    epilogue: `Predict according to the position of Rahu and the planet indicated by it. Work in jails as accountant.`,
    kpPathogenicEffects: `Pain and swelling of the foot`
  },
  {
    id: 248,
    rashiIndex: 11,
    rashi: 'Pisces',
    kpRashiBodyParts: `Bones of Feet & Toes Nymphatic System`,
    kpSubBodyParts: `Cuneiform - The sharp bone in the feet, resembling a canine tooth`,
    nakshatraIndex: 26,
    nakshatra: 'Revati',
    pada: '3-4',
    startsAt: `26°06'40"`,
    endsAt: `27°53'20"`,
    sign: 'Jupiter',
    star: 'Mercury',
    sub: 'Jupiter',
    profession: ``,
    character: ``,
    epilogue: `Well built persons, in youth good growth, tall, stout, look younger than the actual age, clear thinking, forethought and good judgement, dealing in accounts, accountant in bank, advertising agent, auctioneer, books, calendars, salesman, stationary, god fearing, law abiding, honest, religious minded, liberal, journalist, correspondent, good astrologer, administrative department in engineering, treasury, literature, commerce, suffer due to excesses, frequent heart trouble, liver complaints, jaundice abscess, dermatitis, catarrh, cough and carbuncles`,
    kpPathogenicEffects: `Tumour and extra growth at this region`
  },
  {
    id: 249,
    rashiIndex: 11,
    rashi: 'Pisces',
    kpRashiBodyParts: `Bones of Feet & Toes Nymphatic System`,
    kpSubBodyParts: `Talus - The ankle`,
    nakshatraIndex: 26,
    nakshatra: 'Revati',
    pada: '4',
    startsAt: `27°53'20"`,
    endsAt: `30°00'00"`,
    sign: 'Jupiter',
    star: 'Mercury',
    sub: 'Saturn',
    profession: ``,
    character: ``,
    epilogue: `Thin built, pale complexion, person looks older than the age, eyes deep set, if mercury afflicted by Saturn produces ear troubles, fear complex, deafness (puss in the ear). If Moon also is afflicted then, defective speech, paralysis etc. Works as engineer, Old purana writers, Censor Department, short-hand writer (if Mars connected) stenographer, intelligence department, tale carriers: (If Venus connected) wood cutters, teachers, scientists, mines owner, landed properties, scientific laboratories, clubs, societies`,
    kpPathogenicEffects: `Chronic pain in the ankle. Mostly shoe wearing persons are affected`
  }
])
